<template lang="pug">
v-flex.inicio-panel.panel-requeriment.panel-full-height.mt-2.border-radius-top(xs12 sm12 md10 lg9)
  v-flex(v-if="$vuetify.breakpoint.smAndUp")
    br
    br
  v-flex#cabecera(v-if="!processFinished" style="display:none")
    br
    h2.omnesMedium.text-xs-center.text-md-center Te Ayudamos
    h3.omnesRegular.text-xs-center.text-md-center.main-title
      span Gestionamos por este medio tu solicitud de
        br
        | atención o documentación digital
    br
  br(v-if="$vuetify.breakpoint.smAndDown")

  v-flex
    //- INDICATOR FOR SM-AND-UP - DESKTOP
    v-item-group.text-xs-center.text-md-center(v-model="window" mandatory tag="v-flex" v-if="!processFinished && !showValidationPhone")
      v-item(v-for="(item, index) in items" :key="index")
        .stepper-item(slot-scope="{ active, toggle }")
          .stepper-item-contain
            v-btn(:input-value="active" icon)
              v-img(:src="item.icon" contain height="40px" style="background-color: #FFF")
          .separator-line.non-activated(ref="separatorLine" v-if="index < items.length - 1")
          span.stepper-text(ref="stepperText") {{item.text}}
  v-layout#formalities(align-center)
    v-flex#form-formalities
      v-window.elevation-1(v-model="window" horizontal v-if="!processFinished && !showValidationPhone" touchless)
        v-window-item
          v-card(flat)
            v-card-text
              v-layout.text-xs-center.text-md-center(align-center wrap)
                v-flex(xs1 sm12 md1 lg1)
                v-flex.text-xs-center.text-md-center(xs10 sm12 md10 lg10)
                  v-layout.text-xs-center.text-md-center(align-center wrap)
                    //- v-flex.text-xs-center.text-md-center(xs sm12 md4 lg0)
                    v-flex.text-xs-center.text-md-center(xs12 sm12 md12 lg12)
                      br
                      v-layout
                        //- PANTALLA PARA ELEGIR PRODUCTOS
                        v-flex#view_myproduct(xs0 sm0 md4 lg4)
                          v-layout(v-if="isViewProductSelectedDesktop")
                            v-flex.myproduct
                              h2.omnesMedium.mp-title Mi Producto
                              v-layout.row-mp-subtitle(v-if="!(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
                                v-flex(lg10)
                                  h4.omnesRegular.mp-subtitle Elige el tipo de solicitud que deseas registrar.
                                v-flex.col-mp-button(lg2)
                                  button(@click="myProductEdit()") Editar
                              v-layout.row-mp-data.hr
                                v-flex.mp-data-name(lg4)
                                  span Producto
                                v-flex.mp-data-value(lg8)
                                  p {{form.product}}
                              v-layout.row-mp-data.hr
                                v-flex.mp-data-name(lg4)
                                  span Póliza
                                v-flex.mp-data-value(lg8)
                                  p {{form.policy}}
                              v-layout.row-mp-data
                                v-flex.mp-data-name(lg4)
                                  span Tipo de solicitud
                                v-flex.mp-data-value(lg8)
                                  p {{capitalizeString(form.transact)}}
                              v-layout.row-mp-data(v-if="deleteCoverageIsActivated")
                                v-flex.mp-data-name(lg4)
                                  span Prima de tu póliza
                                v-flex.mp-data-value(lg8)
                                  p {{form.currency}} {{form.current_amount}}
                        //- PANTALLA DE SELECCIÓN DE SOLICITUDES Y CAMPOS A MOSTRAR POR SOLICITUD
                        v-flex#view_form_constancy(xs12 sm12 md4 lg4)
                          v-layout(v-if="!isViewProductSelectedDesktop")
                            v-flex(xs12 sm12 md12 lg12)
                              h2.omnesMedium.text-xs-center.text-md-center.title-solicitud Complete la información
                              h4.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud Elige el tipo de solicitud que deseas registrar.
                              v-select#select_product(v-if="!justOneProduct" :items='products' label="Selecciona el producto" required v-model='form.product' @change="validateTransact(); selectDetailsAnalytics('Selecciona el producto')" v-on:change="changeLabel('product')")
                                template(slot="no-data")
                                  .v-select-list.v-card.theme--light
                                    .v-list.theme--light(role='list')
                                      div(role='listitem')
                                        .v-list__tile.theme--light
                                          .v-list__tile__content
                                            .v-list__tile__title Sin Solicitudes disponibles
                              p.text-product(v-else) Producto
                                span  {{form.product}}
                              v-select#select_poliza(:items='policies' label="Selecciona póliza" required v-model='form.policy' @change="changeLabel('poliza'); selectDetailsAnalytics('Selecciona póliza')")
                                template(slot="no-data")
                                  .v-select-list.v-card.theme--light
                                    .v-list.theme--light(role='list')
                                      div(role='listitem')
                                        .v-list__tile.theme--light
                                          .v-list__tile__content
                                            .v-list__tile__title Sin Solicitudes disponibles
                              v-select#selectPP(:items="transact" label="Selecciona el tipo de solicitud" required v-model='form.transact' @change="validateTransact(); selectDetailsAnalytics('Selecciona el tipo de solicitud')")
                                template(slot="no-data")
                                  .v-select-list.v-card.theme--light
                                    .v-list.theme--light(role='list')
                                      div(role='listitem')
                                        .v-list__tile.theme--light
                                          .v-list__tile__content
                                            .v-list__tile__title Sin Solicitudes disponibles
                          v-layout(v-if="isViewProductSelectedDesktop")
                            v-flex
                              h2.omnesMedium.title-constancy Mi Solicitud
                          v-layout.pd-lr.pd-top
                            v-flex(xs12 sm12 md12 lg12)
                              h4.omnesRegular.subtitle-solicitud.text-align-left(v-if="isViewProductSelectedDesktop && !endorsementReleaseIsActivated && !showAnulacionFields && !(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
                                | Para registrar tu solicitud es obligatorio seleccionar e ingresar los datos en los siguientes campos.
                              //- [CAMPOS PARA SOLICITUDES QUE NO SON ENDOSOS]
                              v-select#select_reason.hide-details(v-if="showReason" :items='reasons' label="Selecciona el motivo" required v-model='form.description_cancellation' @change="validateTransact()" v-on:change="changeLabel('reason')")
                              v-select#selectPP.hide-details(v-if="showRelationShip" :items='relationships' label="Parentesco del beneficiario" required v-model='form.relationship' @change="changeRelationship")
                              p#msg_relationship(v-if="showImportantMessageRelationShip")
                                span Importante:
                                |  {{important_message}}
                              //- [/CAMPOS PARA SOLICITUDES QUE NO SON ENDOSOS]
                              //- [CAMPOS PARA SOLICITUDES DE ANULACIONES DE PÓLIZAS]
                              h4.omnesRegular.subtitle-solicitud.text-align-left(v-if="showAnulacionFields")
                                | Para registrar tu solicitud por favor valida tus datos.
                              .anulaciones-fields(v-if="showAnulacionFields")
                                v-text-field(hide-details label="Correo" required v-model='form.email' readonly)
                                v-text-field(hide-details label="Teléfono" required v-model='form.cellphone' readonly)
                              //- [/CAMPOS PARA SOLICITUDES DE ANULACIONES DE PÓLIZAS]
                              //- [CAMPOS PARA SOLICITUDES QUE ES PARA ENDOSOS]
                              .endosos-fields(v-if="endososIsActivated" :class="habilitarOtroBanco ? 'otros-bancos' : ''")
                                v-select(:items='banks' hide-details label="Entidad financiera" required v-model='endosos.ruc' :disabled='banksLoading' :loading='banksLoading')
                                //- v-text-field(hide-details label="RUC" readonly required v-model='endosos.entidad')
                                //- [CAMPO PARA OTROS BANCOS]
                                .endosos-other-fields(v-if="habilitarOtroBanco")
                                  v-text-field(hide-details label="Otra entidad financiera" required v-model='endosos.entidad' @input="onBankEntityInput" @keypress="isBankEntityChar($event)" @paste="onBankEntityPaste" maxlength="100" autocomplete="off")
                                  p.text-email_address(style="color: red; font-size: 13px; margin-top: -2px;" v-if="errors.endososEntidad.length > 0") {{ errors.endososEntidad[0] }}
                                  v-text-field(hide-details label="RUC" required v-model='endosos.otroRuc' @input="onOtroRucInput" @click.right.prevent="" @copy.prevent="" @paste.prevent="" @keypress="isDigitsOnly($event)" maxlength="11" autocomplete="off")
                                  p.text-email_address(style="color: red; font-size: 13px; margin-top: -2px;" v-if="errors.endososOtroRuc.length > 0") {{ errors.endososOtroRuc[0] }}
                                //- [CAMPO PARA OTROS BANCOS]
                                v-text-field#monto-endosable(hide-details label="Monto a endosar" required v-model='endosos.monto' @input="onEndosoMontoInput" @click.right.prevent="" @copy.prevent="" @paste.prevent="" @keypress="isNumber($event)" autocomplete="off")
                                  template(v-slot:prepend='')
                                    p {{ form.currency }}
                                  template(v-slot:prepend-inner='')
                                    img(:src="images.iconPencil")
                                p.text-email_address(style="color: red; font-size: 13px; margin-top: -2px;" v-if="errors.endososMonto.length > 0") {{ errors.endososMonto[0] }}
                                p.info-parraf-endosos
                                  img(:src="images.infoEndosos" alt="info-endosos")
                                  | Monto máximo a endosar es de {{ form.currency }} {{ endosos.montoMaximo !== null ? endosos.montoMaximo.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0.00' }}
                              //- [CAMPOS PARA SOLICITUDES QUE ES PARA ENDOSOS]
                          v-layout.pd-lr(v-if="showFileAttachments")
                            v-flex(xs12 sm12 md12 lg12)
                              h3.text-fileupload-title {{fileAttachment.title}}
                              v-layout.ly-uploadfile
                                v-flex(xs6)
                                  .btns-upload.btn-border-solid
                                    button.v-btn.theme--(@click="uploadFile($event)")
                                      | Archivo
                                      img(:src="images.iconClip")
                                    input#inputfile_1.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                                    v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
                                v-flex(xs6)
                                  p.text-fileupload-indications Tamaño máximo
                                    span  2mb
                                  p.text-fileupload-indications Formatos permitidos:
                                    br
                                    span xls, xlsx, doc
                                  p.text-file-uploaded
                                    img(:src="images.iconCheckUpload")
                                    span Archivo subido
                          v-layout.pd-lr(v-if="showFileAttachments2")
                            v-flex(xs12 sm12 md12 lg12)
                              h3.text-fileupload-title {{fileAttachment2.title}}
                              v-layout.ly-uploadfile
                                v-flex(xs6)
                                  .btns-upload.btn-border-solid
                                    button.v-btn.theme--(@click="uploadFile($event)")
                                      | Archivo
                                      img(:src="images.iconClip")
                                    input#inputfile_2.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                                    v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
                                v-flex(xs6)
                                  p.text-fileupload-indications Tamaño máximo
                                    span  2mb
                                  p.text-fileupload-indications Formatos permitidos:
                                    br
                                    span xls, xlsx, doc
                                  p.text-file-uploaded
                                    img(:src="images.iconCheckUpload")
                                    span Archivo subido
                          v-layout.pd-lr(v-if="showBeneficiarios")
                            v-flex(xs12 sm12 md12 lg12)
                              span.label-beneficiarios Beneficiarios actuales
                              v-layout(v-if="existBeneficiarios")
                                v-flex(xs12)
                                  v-text-field.inputtext-beneficiario(v-for="(benef, index) in beneficiarios" :key="index" :label="'Beneficiario ' + (index  + 1)" :value="benef.gls_beneficiario" readonly)
                                  v-layout.ly-new-beneficiario(v-for="(benef, index) in beneficiariosAdd" :key="index")
                                    v-flex(xs12)
                                      v-layout.ly-inline-left
                                        img(:src="images.iconTime")
                                        p En proceso de evaluación
                                      v-text-field.inputtext-beneficiario(:label="'Beneficiario ' + (beneficiarios.length + index  + 1)" :value="benef.fullName" readonly)
                                      v-layout
                                        <v-btn outline class="btn-border-blue" :id="'btnbenefedit_' + (index + 1)" @click="editBenef($event)">
                                          img(:src="images.iconEdit")
                                          |Editar
                                        </v-btn>
                                        <v-btn outline class="btn-border-blue" :id="'btnbenefdelete_' + (index + 1)" @click="deleteBenef($event)">
                                          img(:src="images.iconTrash")
                                          |Eliminar
                                        </v-btn>
                                  v-btn.btnadd-beneficiario(@click="openDialogBeneficiario")
                                    img(:src="images.iconAdd")
                                    |Añadir nuevo beneficiario
                              p(v-else) No existen beneficiarios para la poliza seleccionada
                          v-layout.pd-lr(v-if="showRenovacionCertificados")
                            v-flex(xs12 sm12 md12 lg12)
                              v-layout(v-for="(benef, index) in beneficiarios" :key="index")
                                v-flex(xs12 sm12 md12 lg12)
                                  v-text-field.inputtext-beneficiario(:label="'Beneficiario ' + (index  + 1)" :value="benef.gls_beneficiario" readonly)
                                  v-btn.btnadd-renovcertificado(v-if="!isAddedInRenovations(benef.num_identificacion)"  @click="openDialogRenovCertificado(benef)")
                                    <img :src="images.iconLoad" />
                                      | Renovar certificado
                                  v-btn.btnadd-renovcertificado(v-else @click="openDialogRenovCertificado(benef)")
                                    <img :src="images.iconCheck" />
                                      | Certificado renovado
                          v-layout.pd-lr(v-if="showRemoveBeneficiarios")
                            v-flex(xs12 sm12 md12 lg12)
                              span.label-beneficiarios Beneficiarios actuales
                              v-layout(v-if="existBeneficiarios")
                                v-flex(xs12)
                                  v-layout(v-for="(benef, index) in beneficiarios" :key="index")
                                    v-flex(v-if="!isDeleted(benef)" xs12 sm12 md12 lg12)
                                      v-text-field.inputtext-beneficiario(:label="'Beneficiario ' + (index  + 1)" :value="benef.gls_beneficiario" readonly)
                                      v-layout
                                        <v-btn outline class="btn-border-blue" :id="'btnbenefdelete_' + (index + 1)" @click="openDialogRemoveBeneficiario(benef)">
                                          img(:src="images.iconTrash")
                                          |Eliminar
                                        </v-btn>
                                    v-flex(v-else xs12 sm12 md12 lg12)
                                      v-text-field.inputtext-beneficiario.input-border-dashed(:label="'Beneficiario ' + (index  + 1)" :value="benef.gls_beneficiario")
                              p(v-else) No existen beneficiarios para la poliza seleccionada
                          v-layout.pd-lr(v-if="showModificarNroCuenta")
                            v-flex(xs12 sm12 md12 lg12)
                              v-select#selectPP.hide-details(:items='entidadesBancarias' label="Entidad bancaria" required v-model='dataNroCuenta.entidad' @change="changeEntidadBancaria($event)")
                              v-layout
                                v-flex(xs6)
                                  v-select#selectPP.mr-2.hide-details(:items='tiposCuentas' label="Tipo de cuenta" required v-model='dataNroCuenta.tipoCuenta' @change="changeTipoCuenta($event)")
                                v-flex(xs6)
                                  v-select#selectPP.ml-2.hide-details(:items='tiposMonedas' label="Tipo de moneda" required v-model='dataNroCuenta.tipoMoneda')
                              v-text-field.hide-details(label='Número de cuenta bancaria' v-model='dataNroCuenta.nroCuenta' type='text' :mask='maskTipoCuenta')
                          //- [CAMBIO DE FRECUENCIA DE PAGO]
                          v-layout#ly_changePaymentFrecuency.pd-lr.pd-bottom(v-if="changeFrecuencyIsActivated")
                            v-flex(xs12 sm12 md12 lg12)
                              p.text-primary Tu frecuencia de pago actual es:
                              div.i-input.i-input--radio.i-radio--extend.i-marginless
                                input#radio_actual.i-radio--extend(type='radio' name='name' value='' :checked='true' @click="form.new_frequency=''")
                                div
                                label(for='radio_actual')
                                  p
                                    small.text-primary Frecuencia de pago:
                                    em.text-primary.omnesMedium {{frecuencias.frecuenciaActual}}
                                  p
                                    small.text-primary Monto de prima
                                    em.text-primary.omnesMedium {{form.currency}} {{frecuencias.montoActual}}
                              p.text-primary Elige la &nbsp;
                                strong nueva
                                | &nbsp; frecuencia de pago para tu seguro:
                              div.i-input.i-input--radio.i-radio--extend.i-marginless(v-if="frecuencias.frecuenciaActual !== 'Mensual' && frecuencias.mensual")
                                input#radio_mensual.i-radio--extend(type='radio' name='name' value='Mensual' v-model="form.new_frequency")
                                div
                                label(for='radio_mensual')
                                  p
                                    small.text-primary Frecuencia de pago:
                                    em.text-primary.omnesMedium Mensual
                                  p
                                    small.text-primary Monto de prima
                                    em.text-primary.omnesMedium {{form.currency}} {{frecuencias.mensual}}
                              div.i-input.i-input--radio.i-radio--extend.i-marginless(v-if="frecuencias.frecuenciaActual !== 'Trimestral' && frecuencias.trimestral")
                                input#radio_trimestral.i-radio--extend(type='radio' name='name' value='Trimestral' v-model="form.new_frequency")
                                div
                                label(for='radio_trimestral')
                                  p
                                    small.text-primary Frecuencia de pago:
                                    em.text-primary.omnesMedium Trimestral
                                  p
                                    small.text-primary Monto de prima
                                    em.text-primary.omnesMedium {{form.currency}} {{frecuencias.trimestral}}
                              div.i-input.i-input--radio.i-radio--extend.i-marginless(v-if="frecuencias.frecuenciaActual !== 'Semestral' && frecuencias.semestral")
                                input#radio_semestral.i-radio--extend(type='radio' name='name' value='Semestral' v-model="form.new_frequency")
                                div
                                label(for='radio_semestral')
                                  p
                                    small.text-primary Frecuencia de pago:
                                    em.text-primary.omnesMedium Semestral
                                  p
                                    small.text-primary Monto de prima
                                    em.text-primary.omnesMedium {{form.currency}} {{frecuencias.semestral}}
                              div.i-input.i-input--radio.i-radio--extend.i-marginless(v-if="frecuencias.frecuenciaActual !== 'Anual' && frecuencias.anual")
                                input#radio_anual.i-radio--extend(type='radio' name='name' value='Anual' v-model="form.new_frequency")
                                div
                                label(for='radio_anual')
                                  p
                                    small.text-primary Frecuencia de pago:
                                    em.text-primary.omnesMedium Anual
                                  p
                                    small.text-primary Monto de cuota
                                    em.text-primary.omnesMedium {{form.currency}} {{frecuencias.anual}}
                          //- [ELIMINACIÓN DE COBERTURAS]
                          v-layout#ly_deleteCoverages.pd-lr.pd-bottom(v-if="deleteCoverageIsActivated")
                            v-flex(xs12 sm12 md12 lg12)
                              h3.omnesMedium.title-constancy(style="position: relative;width:fit-content;") Eliminar coberturas adicionales
                                svg(style="position:absolute;right:-25px;top:2px;" width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('coberturaAdicional')")
                                  path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                  path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')
                              p.omnesRegular.subtitle-solicitud Selecciona las coberturas adicionales que deseas eliminar y calcula el nuevo monto.
                              v-flex.list-coverages
                                div.group-checkbox(v-for="(cobertura, index) in coberturasAdicionales" :class="{ 'selected': cobertura.selected }")
                                  v-checkbox(
                                    :key="index"
                                    v-model="cobertura.selected"
                                    color="#0855C4"
                                    @change="selectedCoverages(cobertura)"
                                    :disabled="calculatingEndoso"
                                    )
                                    .detail(slot="label")
                                      p {{cobertura.nombre}}
                                      p.monto {{form.currency}} {{cobertura.montoCobertura}}
                            v-flex(xs12 sm12 md12 lg12 v-if="showButtonCalculate")
                              v-btn#btnSolicitud.btn-calculate-endoso.btn-full-width(
                                 type='button'
                                 @click="calcularEndoso"
                                 :disabled="!hasSelectedCoverages || calculatingEndoso"
                              )
                                v-progress-circular(
                                  v-if="calculatingEndoso"
                                  indeterminate
                                  color="white"
                                  size="20"
                                  width="2"
                                  style="margin-right: 10px;"
                                )
                                span.omnesSemibold(style="color: #fff;" v-if="!calculatingEndoso") Calcular
                                span.omnesSemibold(style="color: #fff;" v-if="calculatingEndoso") Calculando...
                            v-flex(v-if="!showButtonCalculate" style="position:relative;")
                                .group-recalculate
                                  div.relative
                                    div.section-amount
                                      p El nuevo monto de tu prima sería:
                                      p.amount {{form.currency}} {{form.new_amount}}
                                    div.section-date
                                      p.omnesRegular Si tu solicitud es aprobada, el cambio aplicará el&nbsp;
                                        span.omnesSemibold {{formatDate(form.new_endorsement_date)}}.
                                svg.tooltip-cobertura(width='16' height='16' viewbox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' @click="showTooltip('coberturaRecalculo')")
                                  path(d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#D0D6E0')
                                  path(d='M7.8557 9.55915C8.14494 9.55915 8.34801 9.47115 8.3714 9.28223C8.39663 8.38869 9.01324 8.025 9.62986 7.6213C9.98909 7.45188 10.2938 7.18534 10.5094 6.8518C10.7251 6.51826 10.8431 6.13104 10.8502 5.73392C10.8502 4.48838 9.85632 3.59484 8.22063 3.59484C7.47641 3.5623 6.74769 3.81422 6.18247 4.29946C5.99381 4.45927 5.83882 4.65501 5.72652 4.87529C5.61421 5.09557 5.54684 5.33598 5.52832 5.58253C5.52832 6.25946 6.39663 6.28715 6.40894 6.24961C6.43625 5.80183 6.63886 5.38284 6.97289 5.08337C7.30691 4.7839 7.74546 4.62806 8.19355 4.64961C9.0994 4.64961 9.61509 5.11484 9.61509 5.83238C9.61509 6.48654 9.06124 6.72592 8.49509 7.10315C8.13447 7.30345 7.83525 7.59823 7.62957 7.95581C7.42389 8.31339 7.31953 8.72026 7.3277 9.13269C7.31478 9.42069 7.54124 9.55915 7.8557 9.55915ZM7.79417 11.9745H7.97017C8.06258 11.9866 8.15654 11.9776 8.24495 11.9481C8.33336 11.9186 8.41391 11.8694 8.48053 11.8042C8.54714 11.739 8.59808 11.6595 8.62949 11.5718C8.6609 11.484 8.67197 11.3903 8.66186 11.2976V11.1468C8.67323 11.053 8.66315 10.9579 8.63238 10.8685C8.60161 10.7792 8.55095 10.698 8.48422 10.6311C8.41749 10.5642 8.33643 10.5133 8.24717 10.4823C8.15791 10.4513 8.06277 10.4409 7.96894 10.4521H7.79294C7.70049 10.4429 7.60716 10.4547 7.51986 10.4864C7.43255 10.5182 7.35349 10.5691 7.28851 10.6355C7.22353 10.7019 7.1743 10.782 7.14444 10.87C7.11459 10.958 7.10487 11.0515 7.11601 11.1438V11.2945C7.10499 11.3862 7.11488 11.4792 7.14495 11.5665C7.17503 11.6538 7.22449 11.7332 7.28964 11.7986C7.35479 11.8641 7.43392 11.9139 7.52109 11.9444C7.60826 11.9748 7.70121 11.9851 7.79294 11.9745H7.79417Z' fill='white')
                          //-- MODAL-TOOLTIP COBERTURA ADICIONAL
                          v-dialog(v-model="tooltips.coberturaAdicional" width="455")
                            v-card
                              .modal.modal-tooltip.modal-one-btn.mx-auto
                                p.mx-auto Son las que agregaste a tu póliza para una seguridad extra.
                                button(@click="tooltips.coberturaAdicional = false").g-font-semibold Entendido
                          //-- MODAL-TOOLTIP COBERTURA RECALCULO
                          v-dialog(v-model="tooltips.coberturaRecalculo" width="455")
                            v-card
                              .modal.modal-tooltip.modal-one-btn.mx-auto
                                p.mx-auto Al eliminar una cobertura, la prima de tu póliza se ajustará automáticamente.
                                button(@click="tooltips.coberturaRecalculo = false").g-font-semibold Entendido
                          //-- DECLARACION JURADA
                          //- CESION-ZS PASO2 — Texto del modal alineado al trámite (cesión vs frecuencia vs eliminación cobertura)
                          v-dialog(v-model="tooltips.declaracionJurada" width="363")
                            v-card
                              .modal.modal-procede.modal-one-btn.mx-auto
                                span.dialog-close(@click="tooltips.declaracionJurada = false") x
                                h2.font-weight-medium.mx-auto.text-blue.text-xs-center Declaración Jurada
                                p.mx-auto Mediante la presentación de esta solicitud, declaro bajo juramento que:
                                ol
                                  li Soy contratante de la póliza consignada en mi solicitud.
                                  li La información registrada en la solicitud de&nbsp;
                                    span.omnesSemibold.transact-name {{ declaracionJuradaTransactLabel }}&nbsp;
                                    | es verídica.
                                  li Conozco y acepto los cambios realizados, y entiendo que, de ser aprobada esta solicitud, los cambios serán indicados en el documento de endoso de la presente póliza.
                                  li Que al presionar el botón "CONTINUAR", la solicitud será remitida a Interseguro y, en caso de que la información consignada sea incorrecta o errada, mi solicitud será declarada como no presentada y no tendrá validez alguna.
                          //- /CESION-ZS PASO2
                          //  CUOTA COMODÍN
                          v-flex(xs12 sm12 md12 lg12 v-if="wildcardFeeIsActivated")
                            v-layout.pd-lr(row wrap)
                              p.text-email_address Selecciona y activa tu próxima cuota comodín.
                              v-flex(xs12 md12 lg12)
                                v-text-field.hide-details(v-model='form.wildcard_fee_month' label="Mes de cuota comodín" @click="dialogWildcardFeeMonths = true" @focus="dialogWildcardFeeMonths = true")
                                  template(v-slot:prepend-inner='')
                                    img(:src="images.iconPencil")
                              .i-advice
                                p
                                  | Puedes escoger desde el pr&oacute;ximo pago hasta 12 meses en adelante, m&aacute;s info &nbsp;
                                  a#open_terms(@click="dialogWildcardFeeUsed = true") aqu&iacute;.
                          //  LIBERACIÓN DE ENDOSO
                          v-flex(xs12 sm12 md12 lg12 v-if="endorsementReleaseIsActivated")
                            v-layout.pd-lr(row wrap)
                              h3.text-fileupload-title Requisitos
                              p.text-email_address(style="font-size: 13px; margin-top: 0px; margin-bottom: 0px;") Adjuntar la carta de no adeudo emitida por la entidad financiera o EECC donde figure el pago de su seguro de desgravamen.

                            v-layout.pd-lr(row wrap)
                            v-layout.pd-lr(row wrap style="margin-top:20px;")
                              .btns-upload.btn-border-solid(style="position: relative; right: 10px;left: 0px !important; width: 100%;")
                                button.v-btn.theme--(style="position: relative; border: 1px solid #0855C4; box-sizing: border-box; border-radius: 3px; width: 100%;" @click="uploadFileEndorsementRelease($event)")
                                  | Adjuntar documento
                                  img#attachments-release(:src="images.iconCloud" )
                                input#inputfile_1.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInputRelease" @change="previewFileEndorsementRelease($event)" accept="image/*,application/pdf")

                            v-layout.pd-lr(row wrap)
                              p.text-email_address(style="font-size: 13px; margin-top: 3px;") Formatos permitidos: .jpg, .jpeg, .png, .pdf cada uno con un peso máximo de 5MB.

                            // ARCHIVOS
                            v-layout.pd-lr(row wrap v-if="filesAttachments.length > 0")
                              p.text-email_address(style="font-size: 13px;") Archivos
                              v-flex(xs12 sm12 md12 lg12 style="border: 1.2px solid #cccccc; padding: 5px; border-radius: 3px; align-items: left;")
                                v-flex(v-for="(f, index) in filesAttachments" :key="index" style="float: left;")
                                  v-btn.previewFileRelease.v-btn.v-btn--depressed.theme--light(type='button')
                                    .v-btn__content(:title="f.file.name") {{ (f.file.name.length >= 17)? f.file.name.slice(0, 17) + '...' : f.file.name}}
                                    i#icon--close.v-icon.v-icon--right.material-icons.theme--light(aria-hidden='true', @click="removeFileEndorsementRelease($event, index)") close
                              div(style="clear:both")
                          //- [CONDICIONADO Y ENVIO DE EMAIL]
                          v-flex#ly_emailaddress.pd-lr.pd-bottom(row wrap v-if="showEmailAndConditions")
                            //- CORREO ADICIONAL PARA ENDOSOS
                            //- v-flex(xs12 sm12 md12 lg12 v-if="endososIsActivated && showEmailFinancialAdvisor")
                            //-   p.text-email_address Ingresa un correo de tu asesor financiero que se mostrará en tu endoso:
                            //-   v-text-field.hide-details(v-model='endosos.asesor' label="Correo electrónico")
                            //-     template(v-slot:prepend-inner='')
                            //-       img(:src="images.iconPencil")
                          //- CORREO PARA TODAS LAS SOLICITUDES
                          v-flex(xs12 sm12 md12 lg12 v-if="showEmailAndConditions")
                            v-layout.pd-lr(row wrap)
                              //- CAMPO CORREO DEL FINAL ES PARA COMUNICACIONES PARA TODOS LOS REQUERMIENTOS ESTANDARES
                              //- A EXCEPCION DE ANULACIONES
                              p.text-email_address(v-if="!showAnulacionFields && !(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
                                | Ingresa el correo electrónico al que quieras enviar la respuesta a la solicitud.
                              p.text-email_address.endosos-simples(v-if="changeFrecuencyIsActivated || deleteCoverageIsActivated")
                                | Este es el correo electrónico al que llegará tu solicitud. Si deseas realizar un cambio, ingresa a la opción&nbsp;
                                a.omnesMedium.text-primary(@click="$router.push('/mi-perfil')" style="text-decoration:underline;cursor:pointer;") Actualizaci&oacute;n de datos
                                | .
                              v-flex(xs12 md12 lg12 v-if="!showAnulacionFields")
                                v-text-field.input-email.hide-details(v-model='form.email' label="Correo electrónico" @input="onEmailInput" @keypress="isEmailChar($event)" @paste="onEmailPaste" :disabled="changeFrecuencyIsActivated || deleteCoverageIsActivated" autocomplete="off")
                                  template(v-slot:prepend-inner='' v-if="!(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
                                    img(:src="images.iconPencil")
                              p.text-email_address(style="color: red; font-size: 13px; margin-top: -2px;" v-if="errors.email.length > 0") {{ errors.email[0] }}
                              v-flex(xs12 md12 lg12)
                                ul.list-terms_and_conditions
                                  li.text-conditions(v-if="endososIsActivated")
                                    p Al continuar, doy fe de la veracidad de los datos consignados y en caso se evidencie que lo declarado es falso, estaré sujeto a los alcances del Código Penal.
                                    span
                                  li.text-conditions
                                    p Al continuar acepto las <a target="_blank" href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf" style="color:#454A6C;">condiciones de uso y políticas de privacidad</a>.
                                    span
                                div.group-checkbox.declaration-checkbox(style="margin-bottom:1rem;")
                                  v-checkbox(
                                    v-model="declaracion"
                                    color="#0855C4"
                                    )
                                    .detail(slot="label")
                                      span(style="font-size:11px;color:#454A6C") Acepto la 
                                        a(@click="tooltips.declaracionJurada = true" style="text-decoration:underline;color:#454A6C") declaraci&oacute;n jurada
                                        | .
                              v-flex.anulaciones-datos_personales(xs12 md12 lg12 v-if="showAnulacionFields && !(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
                                v-checkbox(label="Acepto el  tratamiento de los datos personales." v-model="anulaciones.datosPersonales")
                            v-btn#btnSolicitud.actualizar_datos.omnesSemibold(v-if="showAnulacionFields && !(changeFrecuencyIsActivated || deleteCoverageIsActivated)" outline type='button' @click="goProfile()")
                              | Actualizar
                              br
                              | mis datos
                            v-layout.pd-lr(row wrap)
                              v-btn#btnSolicitud.omnesSemibold.btn-full-width(type='button' :disabled="isDisabledBtnSendSolicitud()" @click="next") {{(changeFrecuencyIsActivated || deleteCoverageIsActivated) ? 'Continuar' : 'Siguiente'}}
                        v-flex#column_additional(xs0 sm0 md4 lg4 v-if="!isViewProductSelectedDesktop")
                    //- v-flex.text-xs-center.text-md-center(xs sm12 md4 lg0)
                v-flex(xs1 sm12 md1 lg1)
        //- RESUMEN DE LA SOLICITUD
        v-window-item
          v-card(flat)
            v-card-text.tramite
              v-layout(wrap)
                v-flex(xs0 sm0 md4 lg3)
                v-flex(xs12 sm12 md6 lg6)
                  v-layout#ly_resumen(v-if="!changeFrecuencyIsActivated && !deleteCoverageIsActivated")
                    v-flex(xs12 sm12 md12 lg12)
                      h2.omnesMedium.text-xs-center.text-md-center.title-solicitud
                        | Resumen de solicitud
                      v-layout.resumen-data(v-if="!endososIsActivated")
                        v-flex(xs12 sm12 md12 lg12)
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen N° Documento:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.number_document}}
                          v-layout(v-if="!deleteCoverageIsActivated")
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Producto:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen(style="word-wrap: break-word;padding-right: 10px;") {{form.product}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Póliza:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.policy}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Tipo de solicitud:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{capitalizeString(form.transact)}}
                          v-layout(v-if="wildcardFeeIsActivated")
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Mes Programado:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{monthsFull[parseInt(form.wildcard_fee_month.split('-')[1])]}} {{form.wildcard_fee_month.split('-')[0]}}
                          v-layout(v-if="endorsementReleaseIsActivated")
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Documento{{(filesAttachments.length === 1)?'':'s'}} adjunto{{(filesAttachments.length === 1)?'':'s'}}:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{ filesAttachments.length }} &nbsp; documento{{(filesAttachments.length === 1)?'':'s'}}
                          v-layout(v-if="endorsementReleaseIsActivated" v-for="(f, index) in filesAttachments" :key="index")
                            v-flex(xs5 sm5 md5 lg5)
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen(style="word-wrap: break-word;padding-right: 10px;") {{ f.file.name }}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Fecha de solicitud:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{this.today}}
                          v-layout(v-if="!(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Correo de envío de solicitud:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen(style="word-wrap: break-word;padding-right: 10px;") {{form.email}}
                      //- RESUMEN PARA ENDOSOS Y OTROS REQ NO CONVENCIONALES
                      v-layout.resumen-data(v-else)
                        v-flex(xs12 sm12 md12 lg12)
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Producto:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.product}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Póliza:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.policy}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Tipo de solicitud:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.transact}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Entidad financiera:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.bank}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Monto de endoso:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.currency + ' ' + form.amount_endorse}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Fecha de solicitud:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{this.today}}
                          v-layout
                            v-flex(xs5 sm5 md5 lg5)
                              p.label-resumen Correo de envío de solicitud:
                            v-flex(xs7 sm7 md7 lg7)
                              p.text-resumen {{form.email}}
                      v-layout
                        v-flex.text-xs-center.text-md-center(xs12 sm12 md12 lg12)
                          v-layout(v-if="requireValidationPhone()")
                            v-flex.text-xs-center.text-md-center(sm12)
                              p.resumen-confirmation-subtitle Enviar la confirmación via SMS al siguiente número celular
                              v-text-field.text-phone-confirmation(v-model='form.cellphone' label="Celular")
                                template(v-slot:prepend-inner='')
                                  img(:src="images.iconPencil")
                          v-layout
                            v-flex.text-xs-center.text-md-center(sm12)
                              v-btn#btnSendSolicitud.omnesSemibold(type='button' @click="processTransact" :disabled="isDisabledBtnSendSolicitud()") {{!(changeFrecuencyIsActivated || deleteCoverageIsActivated) ? 'Enviar solicitud' : 'Enviar'}}
                              a#btnBack.omnesSemibold(href="#" @click="prev") VOLVER
                  //- RESUMEN DE SOLICITUD: CAMBIO DE FRECUENCIA DE PAGO Y ELIMINACIÓN DE COBERTURA
                  v-layout#ly_resumen_2(v-if="changeFrecuencyIsActivated || deleteCoverageIsActivated")
                    v-flex(xs12 sm12 md12 lg12)
                      h2.omnesMedium.text-xs-center.text-md-center.title-solicitud
                        | Confirma tu solicitud
                      v-layout.detalle-actual
                        v-flex(xs12 sm12 md12 lg12)
                          v-layout
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen Número de póliza:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen {{form.policy}}
                          v-layout
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen Solicitud:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen {{capitalizeString(form.transact)}}
                          v-layout
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen Monto de prima actual:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen {{form.currency}} {{deleteCoverageIsActivated ? form.current_amount : frecuencias.montoActual}}
                          v-layout(v-if="changeFrecuencyIsActivated")
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen Frecuencia de pago actual:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen {{frecuencias.frecuenciaActual}}
                          v-layout(v-if="deleteCoverageIsActivated")
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen {{coberturasEliminadas.length > 1 ? "Coberturas" : "Cobertura"}} por eliminar:
                            v-flex(xs7 sm6 md5 lg5 v-if="coberturasEliminadas.length === 1")
                              p.text-resumen(v-for="(coverage, index) in coberturasEliminadas" :key="index") {{coverage.nombre}}
                          v-layout(v-if="deleteCoverageIsActivated && coberturasEliminadas.length > 1")
                            v-flex(xs12 sm12 md12 lg12)
                              ul.list-resumen
                                li(v-for="(coverage, index) in coberturasEliminadas" :key="index") {{coverage.nombre}}
                      div.detalle-cambio
                        v-flex(xs12 sm12 md12 lg12)
                          v-layout
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen.omnesMedium Nuevo monto de prima:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen.omnesSemibold {{form.currency}} {{form.amount_endorse}}
                          v-layout(v-if="changeFrecuencyIsActivated")
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen.omnesMedium Nueva frecuencia de pago:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen.omnesSemibold {{form.new_frequency}}
                          v-layout
                            v-flex(xs5 sm6 md7 lg7)
                              p.label-resumen.omnesMedium Fecha efectiva del endoso:
                            v-flex(xs7 sm6 md5 lg5)
                              p.text-resumen.omnesSemibold {{formatDate(form.new_endorsement_date)}}
                          v-layout
                            v-flex.btns-actions(xs12 sm12 md12 lg12)
                              v-btn#btnSendSolicitud.omnesSemibold(type='button' @click="processTransact" :disabled="isDisabledBtnSendSolicitud()") Enviar solicitud
                              a.omnesMedium#btnBack(href="#" @click="prev") Volver
                v-flex(xs0 sm0 md3 lg3)
      .validation-phone(v-if="showValidationPhone")
        validation-phone(:celular="form.cellphone")
      .last-step(v-if="processFinished")
        v-layout#ly_constancy_registered(align-center wrap v-if="!(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
          v-flex(xs2 sm12 md3 lg3)
          v-flex.cr-main.text-xs-center.text-md-center(xs12 sm12 md6 lg6)
            img.img-solicitud_registrada(:src="images.solicitudRegistrada")
            h2.omnesMedium.text-xs-center.text-md-center.title-solicitud {{form.transact === 'Anulación de póliza' ? `¡Tu solicitud de anulación de póliza N°${numCode} fue registrada con éxito!` : '¡Solicitud recibida con éxito!'}}
            //- CESION-ZS PASO4 — Cesión Vida Free / traductor: copy correo + 24h Zona Segura; legacy img 1 sin cambios
            h3.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud(v-if="cesionSuccessUsesTraductorFlow")
              |Enviaremos el detalle del estado de tu solicitud Nº {{numCode}} a tu correo electrónico.
            p.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud(v-else-if="form.transact === 'Anulación de póliza'" style="margin-top: 1rem;")
              |En un <b>plazo máximo de 7 días hábiles</b>, procesaremos tu solicitud y te enviaremos el resultado al correo electrónico registrado.
            h3.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud(v-else-if="(changeFrecuencyIsActivated || deleteCoverageIsActivated)")
              |La solicitud N° {{numCode}} ha sido ingresada, la respuesta será enviada a tu correo electrónico en un tiempo de 24 horas.
            h3.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud(v-else)
              |Recibirás el estado de tu solicitud
              |N° {{numCode}} en 2 días hábiles
            //- /CESION-ZS PASO4

            .disclaimer-endosos(v-if="form.transact === 'Anulación de póliza'")
              p.omnesRegular
                img.img-disclaimer(:src="clockIcon" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 10px")
                span(style="color: #6e6e6e; font-size: 14px; text-align: justify;") Si corresponde, la devolución de la prima por el periodo no transcurrido se realizará como parte de este mismo proceso, de acuerdo con lo estabecido en el Condicionado General.


            br
            v-btn#btnBackToMain.omnesSemibold(type='button'  @click="backHome" style="width: 90% !important;") {{!(changeFrecuencyIsActivated || deleteCoverageIsActivated) ? 'Ir al menú principal' : 'Ir al inicio'}}
            div(v-if="!cesionSuccessUsesTraductorFlow")
              a.simple-btn-blue(@click="openDialogSendConstancy" style="text-decoration: underline;" v-if="!(changeFrecuencyIsActivated || deleteCoverageIsActivated)") Enviar constancia
              a.simple-btn-blue(@click="downloadTransact" style="text-decoration: underline;" v-if="!(changeFrecuencyIsActivated || deleteCoverageIsActivated)") Descargar constancia

            div.disclaimer-endosos(v-if="cesionSuccessUsesTraductorFlow" style="margin-top: 1.5rem; margin-bottom: 0;")
              .disclaimer-content
                img.img-disclaimer(:src="images.iconClock")
                p.text-disclaimer
                  |Los cambios se reflejarán en tu Zona Segura en un plazo de 24 horas.

          v-flex(xs2 sm12 md3 lg3)
        //- CONFIRMACIÓN DE SOLICITUD: CAMBIO DE FRECUENCIA DE PAGO Y ELIMINACIÓN DE COBERTURA
        v-layout#ly_constancy_registered_2(align-center wrap v-if="changeFrecuencyIsActivated || deleteCoverageIsActivated")
          v-flex(xs2 sm12 md3 lg3)
          v-flex.cr-main.text-xs-center.text-md-center(xs12 sm12 md6 lg6)
            img.img-solicitud_registrada(:src="images.solicitudRegistrada")
            h2.omnesMedium.text-xs-center.text-md-center.title-solicitud ¡Tu solicitud N° {{numCode}} ha sido procesada con éxito!
            p.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud
              | Además, te hemos enviado los documentos del endoso de {{capitalizeString(form.transact)}} a tu correo electrónico registrado.
            .confirmation-date
              p.omnesMedium Fecha efectiva del endoso:
              p.omnesMedium {{formatDate(form.new_endorsement_date)}}

            .disclaimer-endosos
              .disclaimer-content
                img.img-disclaimer(:src="images.iconClock")
                p.text-disclaimer
                  | Los cambios de tu endoso estarán disponibles en tu Zona Segura dentro de las próximas 24 horas.

            .btns-actions
              v-btn#btnBackToMain.omnesSemibold(type='button' @click="backHome") Ir al menú principal
          v-flex(xs2 sm12 md3 lg3)
  //- MODALS
  v-dialog(v-model="dialogSendConstancy" max-width="430px" :persistent="true")
    v-card
      v-layout#dialog-formalities.dialog-with-inputbox
        v-flex(xs1 sm1 md1 lg1)
        v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
          img.imgbtn-icon_close(:src="images.iconClose" @click="closeDailogSendConstancy")
          img.img-send_constancy(:src="images.sendConstancy")
          h3 Recibe tu solicitud al correo:
          v-text-field(v-model='form.email_send_constancy' label="Correo electrónico" @input="emailConstErrors()")
            template(v-slot:prepend-inner='')
              img(:src="images.iconPencil")
          p.text-email_address(style="color: red; font-size: 13px; margin-top: -15px; margin-bottom: 20px;" v-if="errors.email.length > 0") {{ errors.email[0] }}
          v-btn#btnSendConstancy.omnesSemibold.btn-pink(type='button' @click="sendConstancy" :disabled="errors.email.length > 0") Enviar
        v-flex(xs1 sm1 md1 lg1)
  v-dialog(v-model="dialogConstancySent" max-width="430px" :persistent="true")
    v-card
      v-layout#dialog_constancy_sent
        v-flex(xs1 sm1 md1 lg1)
        v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
          img.img-constancy_sent(:src="images.constancySent")
          h3 La constancia ha sido enviada a tu correo
          v-btn#btnConstancySentAccept.omnesSemibold.btn-pink(type='button' @click="closeDailogSendConstancy") Entendido
        v-flex(xs1 sm1 md1 lg1)
  v-dialog(v-model="dialogBeneficiario" max-width="430px" :persistent="true")
    v-card
      v-layout#dialog_beneficiario.dialog-with-inputbox.dialog-with-attachments
        v-flex(xs1 sm1 md1 lg1)
        v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
          img.imgbtn-icon_close(:src="images.iconClose" @click="closeDialogBeneficiario")
          h3.title-dialog Registra los datos del beneficiario
          h5.subtitle-dialog Puedes registrar como beneficiarios a padres, cónyuge e hijos
          v-text-field.textfield-dialog(label="Ingresa DNI/CE del beneficiario" v-model='beneficiario.dni' type="text" mask="###########")
          p.text-indication Copia DNI/CE del beneficiario
          v-layout.mg-bt-4.ly-uploadfile
            v-flex(xs6)
              .btns-upload.btn-border-solid
                button.v-btn.theme--(@click="uploadFile($event)")
                  | Archivo
                  img(:src="images.iconClip")
                input#inputfile_benef_1.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
            v-flex(xs6)
              p.text-fileupload-indications Tamaño máximo
                span  2mb
              p.text-fileupload-indications Formatos permitidos:
                br
                span xls, xlsx, doc
              p.text-file-uploaded
                img(:src="images.iconCheckUpload")
                span Archivo subido
          v-text-field.textfield-dialog(label="Nombre" v-model='beneficiario.name' type='text' @keypress="validateOnlyLetter($event)")
          v-layout
            v-flex(xs6)
              v-text-field.textfield-dialog.textfield-benef-apepat(label="Apellido paterno" v-model='beneficiario.apePat' @keypress="validateOnlyLetter($event)")
            v-flex(xs6)
              v-text-field.textfield-dialog.textfield-benef-apemat(label="Apellido materno" v-model='beneficiario.apeMat' @keypress="validateOnlyLetter($event)")
          v-layout
            v-flex(xs6)
              v-text-field.textfield-dialog.textfield-benef-fecnac(label="F. de nacimiento" v-model='beneficiario.fecNac' mask='##/##/####')
            v-flex(xs6)
              v-select.textfield-dialog.textfield-benef-genero(:items='generos' label="Género" required v-model='beneficiario.genero')
          v-select#select_relationship_benef.textfield-dialog(:items='relationships' label="Seleccione parentesco" required v-model='beneficiario.relationship' @change="changeParentescoAddBenef($event)" v-on:change="changeLabel('relationship_benef')")
          p.text-indication {{beneficiario.msgIndication}}
          v-layout.mg-bt-4.ly-uploadfile
            v-flex(xs6)
              .btns-upload.btn-border-solid
                button.v-btn.theme--(@click="uploadFile($event)")
                  | Archivo
                  img(:src="images.iconClip")
                input#inputfile_benef_2.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
            v-flex(xs6)
              p.text-fileupload-indications Tamaño máximo
                span  2mb
              p.text-fileupload-indications Formatos permitidos:
                br
                span xls, xlsx, doc
              p.text-file-uploaded
                img(:src="images.iconCheckUpload")
                span Archivo subido
          v-btn#btnBeneficiarios.omnesSemibold.btn-pink(type='button' @click="addBeneficiario" :disabled="isDisableBtnAddBeneficiario()") CONTINUAR
        v-flex(xs1 sm1 md1 lg1)
  v-dialog(v-model="dialogRenovCertificado" max-width="430px" :persistent="true")
    v-card
      v-layout#dialog_renovarcertificado.dialog-with-inputbox.dialog-with-attachments
        v-flex(xs1 sm1 md1 lg1)
        v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
          img.imgbtn-icon_close(:src="images.iconClose" @click="closeDialogRenovCertificado")
          h3.title-dialog Adjunta los documentos requeridos
          v-layout
            p.title-attachment 1. Constancia de matrícula del semestre vigente
          v-layout.mg-bt-4.border-bottom.ly-uploadfile
            v-flex(xs6)
              .btns-upload.btn-border-solid
                button.v-btn.theme--(@click="uploadFile($event)")
                  | Archivo
                  img(:src="images.iconClip")
                input#inputfile_renov_1.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
            v-flex(xs6)
              p.text-fileupload-indications Tamaño máximo
                span  2mb
              p.text-fileupload-indications Formatos permitidos:
                br
                span xls, xlsx, doc
              p.text-file-uploaded
                img(:src="images.iconCheckUpload")
                span Archivo subido
          v-layout
            p.title-attachment 2. Recórd de notas
          v-layout.mg-bt-4.border-bottom.ly-uploadfile
            v-flex(xs6)
              .btns-upload.btn-border-solid
                button.v-btn.theme--(@click="uploadFile($event)")
                  | Archivo
                  img(:src="images.iconClip")
                input#inputfile_renov_2.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
            v-flex(xs6)
              p.text-fileupload-indications Tamaño máximo
                span  2mb
              p.text-fileupload-indications Formatos permitidos:
                br
                span xls, xlsx, doc
              p.text-file-uploaded
                img(:src="images.iconCheckUpload")
                span Archivo subido
          v-layout
            p.title-attachment 3. Malla curricular
          v-layout.mg-bt-4.ly-uploadfile
            v-flex(xs6)
              .btns-upload.btn-border-solid
                button.v-btn.theme--(@click="uploadFile($event)")
                  | Archivo
                  img(:src="images.iconClip")
                input#inputfile_renov_3.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
            v-flex(xs6)
              p.text-fileupload-indications Tamaño máximo
                span  2mb
              p.text-fileupload-indications Formatos permitidos:
                br
                span xls, xlsx, doc
              p.text-file-uploaded
                img(:src="images.iconCheckUpload")
                span Archivo subido
          v-layout
            p.check-message
              v-checkbox(label="Por medio de la presente declaro que estoy cursando estudios de manera satisfactoria que corresponde a mi primera carrera." v-model="beneficiario.conditionsAccepted")
          v-btn#btnRenovCertificado.omnesSemibold.btn-pink(type='button' @click="addRenovacionCertificado" :disabled="isDisableBtnRenovCertificado()") CONTINUAR
        v-flex(xs1 sm1 md1 lg1)
  v-dialog(v-model="dialogRemoveBeneficiario" max-width="430px" :persistent="true")
    v-card
      v-layout#dialog_removebeneficiario.dialog-with-inputbox.dialog-with-attachments
        v-flex(xs1 sm1 md1 lg1)
        v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
          img.imgbtn-icon_close(:src="images.iconClose" @click="closeDialogRemoveBeneficiario")
          h3.title-dialog ¿Cuál es el motivo?
          v-layout
            v-flex(xs12)
              p.subtitle-dialog-min.mg-bt-0 Beneficiario a excluir
              p.subtitle-dialog {{beneficiario.fullName}}
          v-layout
            v-select#select_reason_removebenef.textfield-dialog(:items='reasonRemovBenef' label="Selecciona el motivo" required v-model='beneficiario.reason' @change="changeReasonRemovebenef($event)"  v-on:change="changeLabel('reason_removebenef')")
          v-layout(v-if="isReasonAttachment")
            p.title-attachment-blue Adjuntar acta de matrimonio con la anotación de la disolución del vínculo matrimonial.
          v-layout.mg-bt-4.ly-uploadfile(v-if="isReasonAttachment")
            v-flex(xs6)
              .btns-upload.btn-border-solid
                button.v-btn.theme--(@click="uploadFile($event)")
                  | Archivo
                  img(:src="images.iconClip")
                input#inputfile_rmvbenef_1.uploadFile(style="display:none" type="file" name="filenames[]" ref="filesInput" @change="previewFile($event)")
                v-btn.previewFile.hide(depressed @click="hidePreviewFile($event)")
            v-flex(xs6)
              p.text-fileupload-indications Tamaño máximo
                span  2mb
              p.text-fileupload-indications Formatos permitidos:
                br
                span xls, xlsx, doc
              p.text-file-uploaded
                img(:src="images.iconCheckUpload")
                span Archivo subido
          v-btn#btnRemoveBenef.omnesSemibold.btn-pink(type='button' @click="addRemoveBeneficiario" :disabled="isDisabledRemoveBenef()") CONTINUAR
        v-flex(xs1 sm1 md1 lg1)
  //- Listado de solicitados disponibles
  v-dialog(v-model="dialogListaSolicitudes" max-width="430px" :persistent="true")
    v-card
      v-layout#dialog_listasolicitudes
        v-flex(xs1 sm1 md1 lg1)
        v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
          h3.title-dialog-without-close {{form.name}}, estas son las solicitudes que puedes realizar
          v-layout
            v-flex(xs12)
              ul.list-solicitudes
                li(v-for="(t, index) in transact")
                  p {{t}}
                  img(:src="images.iconCheckRound")
          v-btn#btnListaSolicitudes.omnesSemibold.btn-pink(type='button' @click="closeDialogListaSolicitudes") Entendido
        v-flex(xs1 sm1 md1 lg1)
  //- DIALOG ENDOSOS
  v-dialog(v-model="dialogEndorsements" width="550" :persistent="true")
    v-card#info-endorsements
      v-card-title
        v-flex
          h1.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 22px;") ¿Cómo funciona?
      v-card-text
        v-layout(wrap)
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='loans.bullet1' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2 Este tipo de endoso permite ceder tu póliza a una entidad financiera como garantía a una deuda u obligación.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='loans.bullet2' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2 Debes estar al día en tus pagos.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3 style="align-self: center;")
                img.mt-2(:src='loans.bullet3' width="60px")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2 Tu póliza no debe estar endosada a una entidad financiera.
        v-card-actions
          v-layout
            v-flex.text-xs-center
              v-btn#btn-endorsements(color="dark" @click="dialogEndorsements = false") ¡Estoy listo!
  //- DIALOG PAYMENT CHANGE FRECUENCY
  v-dialog(v-model="dialogChangeFrecuency" width="550" :persistent="true")
    v-card#info-change-payment
      v-card-title
        v-flex
          h1.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 22px;") Lo que debes saber
      v-card-text(style="padding-top: 0;")
        v-layout(wrap)
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='frecuencyInfo.bullet1' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.text-primary.mb-2.mt-2 Este trámite te permite modificar la frecuencia de pago de tu seguro.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='frecuencyInfo.bullet2' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.text-primary.mb-2.mt-2 El cambio se aplicará a futuro, no es retroactivo.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='frecuencyInfo.bullet3' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.text-primary.mb-2.mt-2
                  | Ten en cuenta que, al realizar el cambio, podría aplicarse <b>variación de la prima</b> dependiendo de la fecha en que se efectúe la modificación.
        v-card-actions
          v-layout
            v-flex.text-xs-center
              v-btn.omnesMedium#btn-endorsements(color="dark" @click="dialogChangeFrecuency = false") ¡Estoy listo!
  //- DIALOG WILDCARD FEE
  v-dialog(v-model="dialogWildcardFee" width="550" :persistent="true")
    v-card#info-wildcard-fee
      v-card-title
        v-flex
          h1.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 22px;") Lo que debo saber
      v-card-text
        v-layout(wrap)
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='frecuencyInfo.bullet1' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2 Cada cuota comodín te exonera  de un pago mensual de tu seguro de vida.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3)
                img.mt-2(:src='frecuencyInfo.bullet2' width="60px" style="align-self: center;")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2 Puedes utilizarla  1 vez por cada año de tu contrato.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 1em;")
              v-flex.text-xs-center(xs4 offset-sm1 sm3 md3 lg3 style="align-self: center;")
                img.mt-2(:src='frecuencyInfo.bullet2' width="60px")
              v-flex(xs8 sm7 md7 lg7 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2 Si no utilizaste tus cuotas comodines, serán aplicadadas automáticamente en lo meses finales a tu contrato.
        v-card-actions
          v-layout
            v-flex.text-xs-center
              v-btn#btn-endorsements(color="dark" @click="dialogWildcardFee = false") ¡Estoy listo!
  //- DIALOG ENDORSEMENT RELEASE
  v-dialog(v-model="dialogEndorsementRelease" width="450" :persistent="true")
    v-card#info-endorsement-release
      v-card-title(style="padding-bottom: 0;")
        v-layout(wrap)
          v-flex.text-xs-center
            img(:src='endorsementReleaseInfo.logo' width="120px" style="align-self: center;")
      v-card-title(style="padding-bottom: 0; padding-top: 0;")
        v-flex(style="justify-content: center;")
          h1.omnesMedium(style="color: #0855c4; text-align: center; font-size: 18px;") ¿Qué es liberación de endoso?
          v-flex
            p.omnesRegular.info--text.text-xs-center(style="margin-left: 15px; margin-right: 10px;") Es la acción de dejar sin efecto los beneficios de la póliza dadas a un tercero, en este caso a la entidad financiera.
      v-card-title(style="padding-bottom: 0; padding-top: 0;")
        v-flex
          h2.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 18px;") ¿Cómo funciona?
      v-card-text(style="padding-bottom: 0; padding-top: 0;")
        v-layout(wrap)
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 0;")
              v-flex.text-xs-center(xs3 sm2 md2 lg2 style="margin-left: 3%;")
                img.mt-2(:src='endorsementReleaseInfo.bullet1' width="60px" style="align-self: center;")
              v-flex(xs8 sm9 md9 lg9 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2(style="margin-left: 10px;") Adjunta la carta de no adeudo emitida por la entidad financiera o EECC donde figura el pago del seguro de desgravamen.
          v-flex(xs12 sm12 md12 lg12)
            v-layout(wrap style="margin-bottom: 0;")
              v-flex.text-xs-center(xs3 sm2 md2 lg2 style="margin-left: 3%;")
                img.mt-2(:src='endorsementReleaseInfo.bullet2' width="60px" style="align-self: center;")
              v-flex(xs8 sm9 md9 lg9 style="align-self: center;")
                p.omnesRegular.info--text.mb-2.mt-2(style="margin-left: 10px;") Envía tu solicitud y te responderemos en 48 horas.
        v-card-actions(wrap style="margin-top: 0;")
          v-layout
            v-flex.text-xs-center
              v-btn#btn-endorsements(color="dark" @click="dialogEndorsementRelease = false") ¡Estoy listo!
  //- DIALOG ANULACION
  v-dialog(v-model="dialogCancellation" width="390" :persistent="true")
    v-card#info-cancellation
      v-card-title
        v-flex(style="justify-content: center;")
          span.omnesMedium(style="color: rgb(8, 85, 196);text-align: right;display: block;font-size: 23px;cursor:pointer;line-height: 1;", @click="dialogCancellation = false") x
          h1.omnesMedium(style="color: #0855c4; text-align: center; font-size: 18px;")
            | Antes de continuar con tu solicitud, conoce todos los beneficios que tiene tu seguro:
      v-card-text
        v-layout(wrap)
          v-flex(xs12 md12 lg12)
            .landing-item-formalities(:style="{ backgroundImage: `url(${backImagen1})`, backgroundPosition: 'top'}")
              h3.g-text-center Asistencias
              .btn-purple(@click="viewAsistent") Quiero conocerlos
          v-flex(xs12 md12 lg12).mt-4
            .landing-item-formalities(:style="{ backgroundImage: `url(${backImagen2})`, backgroundPosition: 'top' }")
              h3.g-text-center Descuentos
              .btn-purple(@click="viewDescuent") Quiero conocerlos
      v-flex
        h1.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 18px;") ¡Sigue protegiendo a los que más amas!

  //- DIALOG WILDCARD FEE (MONTHS)
  v-dialog(v-model="dialogWildcardFeeMonths" width="550" :persistent="true")
    v-card#info-wildcard-fee-months
      v-card-title
        v-flex
          h3.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 18px;") Seleccione en que mes quieres aplicar tu cuota comodín
      v-card-text
        v-layout(wrap)
          .i-radio__content
            .i-input.i-input--radio.i-input.i-input--radio.i-radio--date(v-for="wildcardFee in mesesComodin" :key='wildcardFee.key')
              input.i-input.i-input--radio.i-radio--date(v-model='form.wildcard_fee_month' type='radio', :value='wildcardFee.key' :id='wildcardFee.key')
              div
              label(:for='wildcardFee.key')
                p {{ wildcardFee.value }}

      v-card-actions
        v-layout
          v-flex.text-xs-center
            v-btn#btn-endorsements(color="dark" @click="dialogWildcardFeeMonths = false") Siguiente
  v-dialog(v-model="dialogWildcardFeeUsed" width="550" :persistent="true")
    v-card#info-wildcard-fee-used
      v-card-title
        v-flex
          h3.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 18px;") Tus cuotas comodín
          h4.omnesMedium.text-xs-center(style="font-size: 14px;") Te mostramos el estado de tus cuotas comodín
      v-card-title
        v-flex
          h3(style="color: #0855c4; font-size: 18px;border-bottom: 1px solid #e7eaed;") {{ wildcardFeesUsed.length }} cuotas usadas
      v-card-text
        v-layout(wrap)
          .i-radio__content
            .i-input.i-input--radio.i-input.i-input--radio.i-radio--date(v-for="wildcardFeeUsed in wildcardFeesUsed" :key="wildcardFeeUsed.numero_CUOTA")
              input.i-input.i-input--radio.i-radio--date(type='radio', :value='wildcardFeeUsed.numero_CUOTA' :id='"wildcardUsed-"+wildcardFeeUsed.numero_CUOTA')
              label
                p {{ months[parseInt(wildcardFeeUsed.fecha_PROGRAMADA.split("-")[1])]+' - ' + wildcardFeeUsed.fecha_PROGRAMADA.split("-")[0]}}
      v-card-title
        v-flex
          h3(style="color: #0855c4; font-size: 18px;border-bottom: 1px solid #e7eaed;") {{ wildcardFeesTotal - wildcardFeesUsed.length }} cuotas por usar
          h4(style="font-size: 14px;") En caso de que quieras programar todas tus cuotas comodín, comunícate&nbsp;
            a(:href="links.WhatsApp" target="_blank" style="font-size: 14px;")
              b aquí
      v-card-actions
        v-layout
          v-flex.text-xs-center
            v-btn#btn-endorsements(color="dark" @click="dialogWildcardFeeUsed = false") Entendido

  //- LOADER PROCESS
  v-dialog(v-model="loader" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | {{ textLoader }}
        v-progress-linear.mb-0(indeterminate="" color="white")

  PopupAlertMessage(
    @closeAlertPopup="closeAlertPopupMethod"
    :openPopup="flagPopupAlert"
    :image="infoPopup.img"
    :title="infoPopup.title"
    :message="infoPopup.message"
    :messageButton="infoPopup.messageButton"
    )

</template>

<script>
import backImg1 from '@/assets/landing/general/back-imagen-1.jpg'
import backImg2 from '@/assets/landing/general/back-imagen-2.png'
import { mapWorkflowBanksToSelectItems } from '@/utils/workflow-banks'
import {
  EMAIL_CHAR_REGEX,
  sanitizeBankEntityName,
  sanitizeEmailInput,
  validateBankEntityName,
  validateEmail,
  validateEndorsementAmount,
  validateFinancialEntityRuc
} from '@/utils/formValidation'

import { mapActions, mapGetters } from 'vuex'
// import moment from 'moment'
import jsPDF from 'jspdf'
import UploadButton from 'vuetify-upload-button'
import PopupAlertMessage from '../components/PopupAlertMessage.vue'
import Functionalities from '../interfaces/functionalities'
import Links from '../interfaces/links'
import ValidationPhone from './../components/ValidationPhone'
import attachmentRules from './../interfaces/attachmentRules'
import transacts from './../interfaces/transacts'
import ubigeo from './../interfaces/ubigeo'
import { TRADUCTOR_PRODUCTS } from '../utils/traductorProducts'

var formData = new FormData()

export default {
  props: ['seguroCodeGTM', 'seguroPolicy'],
  data () {
    return {
      links: Links,
      length: 3,
      // CODE GTM
      codeGTM: '',
      // CODE OF REQUIREMENT
      textLoader: 'Procesando trámite...',      
      numCode: '',
      typeProductSelected: '',
      today: '',
      availableForUpload: false,
      filenameSelected: '',
      checkPersonalData: '',      
      processFinished: false,
      completeEmail: false,
      completeAddress: false,
      products: [],
      justOneProduct: false,
      policies: [],
      loader: false,
      attachments: { main: '', attachments: [] },
      transact: [],
      reasons: [],
      banks: [],
      banksLoading: false,
      window: 0,
      fileAlreadyUpload: [],
      backImagen1: backImg1,
      backImagen2: backImg2,
      flags: {
        enableBtnNext: false,
        enableBtnRegistro: false
      },
      modUbigeo: {
        department: [],
        province: [],
        district: []
      },
      items: [
        { name: 'Producto', icon: require('./../assets/formpp/number-one-checked.svg'), text: 'Solicitud' },
        { name: 'Datos personales', icon: require('./../assets/formpp/number-two-disabled.svg'), text: 'Resumen' }
      ],
      habilitarOtroBanco: false,
      endososIsActivated: false,
      dialogEndorsements: false,
      changeFrecuencyIsActivated: false,
      wildcardFeeIsActivated: false,
      endorsementReleaseIsActivated: false,
      deleteCoverageIsActivated: false,
      showReleaseFileAttachments: false,
      showAnulacionFields: false,
      dialogChangeFrecuency: false,
      dialogWildcardFee: false,
      dialogWildcardFeeMonths: false,
      dialogWildcardFeeUsed: false,
      dialogEndorsementRelease: false,
      dialogCancellation: false,
      showEmailFinancialAdvisor: false,
      endosos: {
        entidad: '',
        ruc: '',
        otroRuc: '',
        monto: '',
        asesor: '',
        montoMaximo: 0
      },
      frecuencias: {
        montoActual: null,
        frecuenciaActual: null,
        mensual: null,
        trimestral: null,
        semestral: null,
        anual: null
      },
      months: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      monthsFull: ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      mesesComodin: [],
      wildcardFeesUsed: [],
      wildcardFeesTotal: 0,
      loans: {
        bullet1: require('./../assets/endosos/ico-1.svg'),
        bullet2: require('./../assets/endosos/ico-2.svg'),
        bullet3: require('./../assets/endosos/ico-3.svg')
      },
      frecuencyInfo: {
        bullet1: require('./../assets/endosos/ico-1.svg'),
        bullet2: require('./../assets/endosos/ico-2.svg'),
        bullet3: require('./../assets/endosos/ico-4.svg')
      },
      endorsementReleaseInfo: {
        logo: require('./../assets/general/personaje_computador_2.svg'),
        bullet1: require('./../assets/general/nube_check.svg'),
        bullet2: require('./../assets/general/tiempo_48h.svg')
      },
      anulaciones: {
        datosPersonales: false,
        actDatosPendiente: false
      },
      images: {
        completaTusDatos: require('./../assets/formpp/completa-tus-datos.svg'),
        comentariosAdicionales: require('./../assets/formpp/comentarios-adicionales.svg'),
        mediosRespuesta: require('./../assets/formpp/medios-de-respuesta.svg'),
        descargaRequisitos: require('./../assets/formpp/descarga-requisitos.svg'),
        arrowBack: require('./../assets/icons/arrow-back.svg'),
        responseEmail: require('./../assets/formpp/email-noactivated.svg'),
        responseFisic: require('./../assets/formpp/address-noactivated.svg'),
        edit: require('./../assets/formpp/lapiz.svg'),
        personalDataIcon: require('./../assets/formpp/personal-data-icon.svg'),
        productIcon: require('./../assets/formpp/producto-icon.svg'),
        procedureIcon: require('./../assets/formpp/tramite-icon.svg'),
        mainIcon: require('./../assets/icons/icon-rentas.svg'),
        solicitudRegistrada: require('./../assets/formpp/icon_registered_request.svg'),
        sendConstancy: require('./../assets/formpp/icon_send_constancy.svg'),
        constancySent: require('./../assets/formpp/icon_constancy_sent.svg'),
        iconClose: require('./../assets/formpp/icon_close.svg'),
        iconPencil: require('./../assets/formpp/icon_pencil.svg'),
        iconClip: require('./../assets/formpp/icon_clip.svg'),
        iconCloud: require('./../assets/general/nube.svg'),
        iconAdd: require('./../assets/formpp/icon_add.svg'),
        iconLoad: require('./../assets/formpp/icon_load.svg'),
        iconCheck: require('./../assets/formpp/icon_check.svg'),
        iconTime: require('./../assets/formpp/icon_time.svg'),
        iconClock: require('./../assets/formpp/icon_clock.svg'),
        iconQuestion: require('./../assets/formpp/icon_question.svg'),
        iconEdit: require('./../assets/formpp/icon_edit.svg'),
        iconTrash: require('./../assets/formpp/icon_trash.svg'),
        iconCheckRound: require('./../assets/formpp/icon_check_round.svg'),
        iconCheckUpload: require('./../assets/formpp/icon_check_round_filled.svg'),
        infoEndosos: require('./../assets/iconsv5/icon-info-endosos.png')
      },
      files: {
        pdfPrivacy: require('./../assets/downloable/autorizacion-para-el-uso-y-tratamiento-de-datos-personales.pdf')
      },
      form: {
        product: null,
        policy: null,
        transact: null,
        name: null,
        paternal_surname: null,
        maternal_surname: null,
        type_document: null,
        number_document: null,
        home_address: '',
        interior: '',
        response_medium: null,
        department: null,
        province: null,
        district: 'distrito',
        cellphone: null,
        phone: null,
        email: '',
        email_financial_advisor: '',
        requisition_number: null,
        detail_transact: '',
        state: 'PENDIENTE',
        /** ANULACION POLIZA - PRESTAMO */
        description_cancellation: null,
        // cancellation_reason: null,
        account_number: null,
        fullname_account_holder: null,
        bank: null,
        currency: null,
        reason: null,
        // endosos
        amount_endorse: null,
        // cambio de frecuencia pago
        actual_frequency: '',
        new_frequency: '',
        new_endorsement_date: '',
        // cuota comodín
        wildcard_fee_month: '',
        // eliminación de cobertura
        current_amount: null,
        new_amount: null,
        coberturas: [],
      },
      coberturasAdicionales: [],
      coberturasEliminadas: [],
      coberturasRestantes: [],
      showButtonCalculate: true,
      calculatingEndoso: false,
      declaracion: false,
      errors: {
        product: [],
        policy: [],
        transact: [],
        department: [],
        province: [],
        district: [],
        email: [],
        endososEntidad: [],
        endososOtroRuc: [],
        endososMonto: [],
        home_address: [],
        interior: [],
        cellphone: [],
        detail_transact: [],
        response_medium: [],
        accept_condition: [],
        /** ANULACION POLIZA - PRESTAMO */
        description_cancellation: [],
        // cancellation_reason: [],
        account_number: [],
        fullname_account_holder: [],
        bank: [],
        currency: []
      },
      dialogSendConstancy: false,
      dialogConstancySent: false,
      dialogBeneficiario: false,
      dialogRenovCertificado: false,
      dialogRemoveBeneficiario: false,
      dialogListaSolicitudes: false,
      isViewProductSelectedDesktop: false,
      showReason: false,
      showRelationShip: false,
      showFileAttachments: false,
      showFileAttachments2: false,
      showEmailAndConditions: false,
      showImportantMessageRelationShip: false,
      showBeneficiarios: false,
      showRemoveBeneficiarios: false,
      showRenovacionCertificados: false,
      showModificarNroCuenta: false,
      showValidationPhone: false,
      existBeneficiarios: false,
      fileAttachment: {
        title: null
      },
      fileAttachment2: {
        title: null
      },
      filesAttachments: [],
      relationships: [
        'Cónyuge',
        'Concubino',
        'Hijos mayores de 18 años con discapacidad'
      ],
      importantMessagesRelationShip: [
        'Adjuntar como documento adicional la partida de matrimonio con 6 meses de vigencia.',
        'Adjuntar como documento adicional resolución de unión de hecho.',
        'Adjuntar como documento adicional la partida de nacimiento.'
      ],
      msgsIndications: [
        'Adjuntar partida de matrimonio con 6 meses de vigencia.',
        'Adjuntar resolución de unión de hecho.',
        'Adjuntar partida de nacimiento.'
      ],
      important_message: '',
      generos: [
        'Femenino',
        'Masculino'
      ],
      beneficiarios: [],
      beneficiariosAdd: [],
      beneficiario: {
        dni: null,
        name: null,
        apePat: null,
        apeMat: null,
        fullName: null,
        fecNac: null,
        genero: null,
        relationship: null,
        files: [],
        reason: null,
        msgIndication: null,
        conditionsAccepted: false
      },
      validatedPhone: false,
      reasonRemovBenef: [
        'Divorcio',
        'Estudios incompletos',
        'Otros'
      ],
      isReasonAttachment: false,
      dataNroCuenta: {
        entidad: null,
        tipoCuenta: null,
        tipoMoneda: null,
        nroCuenta: null
      },
      entidadesBancarias: [],
      tiposCuentas: [],
      tiposMonedas: [
        'Soles',
        'Dólares'
      ],
      maskTipoCuenta: '',
      trackEvents: {
        endorsements: {
          access: {
            category: 'Endoso a Entidad Financiera',
            action: 'Acceso',
            label: 'Acceso OK',
            event: 'ENDOSO Acceso',
            producto: ''
          },
          success: {
            category: 'Endoso a Entidad Financiera',
            action: 'Acceso',
            label: 'Registro Exitoso',
            event: 'ENDOSO Exitoso',
            producto: ''
          },
          pending: {
            category: 'Endoso a Entidad Financiera',
            action: 'Error',
            label: 'Solicitud Pendiente',
            event: 'ENDOSO Solicitud Pendiente',
            producto: ''
          },
          unavailable: {
            category: 'Endoso a Entidad Financiera',
            action: 'Error',
            label: 'Sin Monto Disponible',
            event: 'ENDOSO Sin monto disponible',
            producto: ''
          },
          nonPayment: {
            category: 'Endoso a Entidad Financiera',
            action: 'Error',
            label: 'Con impagos',
            event: 'ENDOSO Con impagos',
            producto: ''
          },
          error: {
            category: 'Endoso a Entidad Financiera',
            action: 'Error',
            label: 'Error de Servidor',
            event: 'ENDOSO Server Error',
            producto: ''
          }
        },
        wildcard: {
          access: {
            category: 'Cuota Comodín',
            action: 'Acceso',
            label: 'Acceso OK',
            event: 'CCOMODIN Acceso',
            producto: ''
          },
          success: {
            category: 'Cuota Comodín',
            action: 'Acceso',
            label: 'Asignación Exitosa',
            event: 'CCOMODIN Exitoso',
            producto: ''
          },
          reject: {
            category: 'Cuota Comodín',
            action: 'Rechazo',
            label: 'No Tiene Cuota Comodín',
            event: 'CCOMODIN No Posee Beneficio',
            producto: ''
          },
          error: {
            category: 'Cuota Comodín',
            action: 'Error',
            label: 'Error de Servidor',
            event: 'CCOMODIN Server Error',
            producto: ''
          }
        },
        frequency: {
          access: {
            category: 'Cambio Frecuencia de Pago',
            action: 'Acceso',
            label: 'Acceso OK',
            event: 'CFRECUENCIA Acceso',
            producto: ''
          },
          success: {
            category: 'Cambio Frecuencia de Pago',
            action: 'Acceso',
            label: 'Asignación Exitosa',
            event: 'CFRECUENCIA Exitoso',
            producto: ''
          },
          reject: {
            category: 'Cambio Frecuencia de Pago',
            action: 'Rechazo',
            label: 'No Posee el beneficio',
            event: 'CFRECUENCIA No Posee Beneficio',
            producto: ''
          },
          error: {
            category: 'Cambio Frecuencia de Pago',
            action: 'Error',
            label: 'Error de Servidor',
            event: 'CFRECUENCIA Server Error',
            producto: ''
          }
        },
        coverages: {
          access: {
            category: 'Eliminación de cobertura',
            action: 'Acceso',
            label: 'Acceso OK',
            event: 'RECOBERTURA Acceso',
            producto: ''
          },
          success: {
            category: 'Eliminación de cobertura',
            action: 'Acceso',
            label: 'Asignación Exitosa',
            event: 'RECOBERTURA Exitoso',
            producto: ''
          },
          reject: {
            category: 'Eliminación de cobertura',
            action: 'Rechazo',
            label: 'No Posee el beneficio',
            event: 'RECOBERTURA No Posee Beneficio',
            producto: ''
          },
          error: {
            category: 'Eliminación de cobertura',
            action: 'Error',
            label: 'Error de Servidor',
            event: 'RECOBERTURA Server Error',
            producto: ''
          }
        },
        release: {
          access: {
            category: 'Liberación de endoso',
            action: 'Acceso',
            label: 'Acceso OK',
            event: 'LIBENDOSO Acceso',
            producto: ''
          },
          success: {
            category: 'Liberación de endoso',
            action: 'Acceso',
            label: 'Liberación Exitosa',
            event: 'LIBENDOSO Exitoso',
            producto: ''
          },
          reject: {
            category: 'Liberación de endoso',
            action: 'Rechazo',
            label: 'No Posee el beneficio',
            event: 'LIBENDOSO No Posee Beneficio',
            producto: ''
          },
          error: {
            category: 'Liberación de endoso',
            action: 'Error',
            label: 'Error de Servidor',
            event: 'LIBENDOSO Server Error',
            producto: ''
          }
        }
      },
      requirementsData: {
        VIADP: 'Anulación de Póliza',
        VIEEF: 'Endoso a Entidad financiera',
        VICFP: 'Cambio Frecuencia de Pago',
        VICCM: 'Cambio de Cuota Comodín',
        VILE: 'Liberación de Endoso',
        VIRCA: 'Eliminación de cobertura'
      },
      amplitude: {
        events: {
          requestAttempt: 'Intento de Solicitud',
          summaryRequest: 'Resumen de la Solicitud',
          editionRequest: 'Edición de la Solicitud',
          requestSent: 'Solicitud Enviada'
        }
      },
      reqAvailables: [],
      flagPopupAlert: false,
      infoPopup: {},
      solicitudEnProceso: false,
      /** Resultado del último envío cesión: traductor vs legacy (null = sin envío / otro trámite) */
      cesionUltimoEnvioUsaTraductor: null,
      ramo: '',
      tooltips: {
        coberturaAdicional: false,
        coberturaRecalculo: false,
        declaracionJurada: false
      },
      clockIcon: require('@/assets/formpp/icon_load_gray.svg')

    }
  },
  watch: {
    'endosos.ruc': function (val) {
      let bank = this.banks.filter((v) => { return v.value === val })
      if (bank.length > 0) {
        if (bank[0].value !== 'otros') {
          this.endosos.entidad = bank[0].text
          this.habilitarOtroBanco = false
          this.endosos.otroRuc = ''
          this.errors.endososEntidad = []
          this.errors.endososOtroRuc = []
          this.errors.endososMonto = []
        } else {
          this.habilitarOtroBanco = true
          this.endosos.entidad = ''
          this.endosos.otroRuc = ''
          this.errors.endososEntidad = []
          this.errors.endososOtroRuc = []
          this.errors.endososMonto = []
        }
        this.endosos.asesor = bank[0].email
        // - CASO ESPECIAL PARA SCOTIABANK
        /* if (bank[0].value === '20100043140') {
          this.showEmailFinancialAdvisor = true
        } else {
          this.showEmailFinancialAdvisor = false
        } */
      }
    },
    'form.response_medium': function () {
      if (this.form.response_medium === 'fisico' || this.form.response_medium === 'Físico') {
        this.completeAddress = true
        this.images.responseFisic = require('./../assets/formpp/address-activated.svg')
        this.images.responseEmail = require('./../assets/formpp/email-noactivated.svg')
      } else if (this.form.response_medium === 'electronico' || this.form.response_medium === 'Electrónico') {
        this.completeEmail = true
        this.images.responseFisic = require('./../assets/formpp/address-noactivated.svg')
        this.images.responseEmail = require('./../assets/formpp/email-activated.svg')
      }
    },
    'form.transact': function () {
      if (this.form.transact !== 'Endoso a entidad financiera') {
        this.cesionUltimoEnvioUsaTraductor = null
      }
      let self = this
      if (this.form.transact !== '' && this.form.transact !== null) {
        // RESET TRANSACT DETAIL
        this.form.bank = null
        this.form.currency = null
        this.form.description_cancellation = null
        // this.form.cancellation_reason = null
        this.form.detail_transact = null
        // PUT ATTACHMENT RULES
        let resAttachments = attachmentRules.filter(function (a) { return a.main === self.form.transact })
        this.attachments = resAttachments[0]
        // PUT CODE GTM FOR SEND TO Google Tab Manager
        this.codeGTM = resAttachments[0].codeGTM
        this.afterSelectTransact()
        // CLEAR FORMDATA
        formData = new FormData()
        this.form.filenames = []
      }
    },
    'form.department': function () {
      this.modUbigeo.province = ubigeo.province[this.form.department]
      this.modUbigeo.district = []
    },
    'form.product': function () {
      if (this.form.product !== null && this.form.product !== '') {
        let productName = this.form.product
        let polizas = this.polizasInfo.filter(function (poliza) {
          return poliza.producto === productName
        })
        // FIX FOR IE11
        if (polizas.length > 0) {
          this.policies = polizas.map(function (p) { return p.numeroPoliza })
          this.ramo = polizas[0].ramo
          switch (this.ramo) {
          case 'Vida':
            this.typeProductSelected = 'Vida'
            this.images.mainIcon = require('./../assets/icons/icon-educacion-garantizada.svg')
            break
          case 'RRVV':
            this.typeProductSelected = 'Rentas'
            this.images.mainIcon = require('./../assets/icons/icon-rentas.svg')
            break
          case 'Masivo':
            this.images.mainIcon = require('./../assets/icons/icon-otros.svg')
            let polizasMasivos = this.polizasInfo.filter(function (poliza) {
              return (poliza.ramo === 'Masivo' && poliza.producto === productName)
            })
            this.policies = polizasMasivos.map(function (p) { return p.numeroPoliza })
            this.typeProductSelected = 'Masivo'
            break
          default:
            this.typeProductSelected = 'Vida'
            this.images.mainIcon = require('./../assets/icons/icon-educacion-garantizada.svg')
            break
          }
        }
        this.showFilterTipoSolicitud(this.form.product)
      }
    },
    'form.province': function () {
      this.modUbigeo.district = ubigeo.district[this.form.province]
    },
    'coberturasEliminadas': function () {
      this.showButtonCalculate = true
      this.showEmailAndConditions = false
    },
    window: function () {
      switch (this.window) {
      case 0:
        this.items[0].icon = require('./../assets/formpp/number-one-checked.svg')
        this.items[1].icon = require('./../assets/formpp/number-two-disabled.svg')
        this.$refs.separatorLine[0].classList.add('non-activated')
        this.$refs.separatorLine[0].classList.remove('activated')
        this.$refs.stepperText[1].classList.remove('active')
        break
      case 1:
        this.items[0].icon = require('./../assets/formpp/number-one-checked.svg')
        this.items[1].icon = require('./../assets/formpp/number-two-checked.svg')
        this.$refs.separatorLine[0].classList.remove('non-activated')
        this.$refs.separatorLine[0].classList.add('activated')
        this.$refs.stepperText[1].classList.add('active')
        break
      }
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo', 'basicInfo', 'functionsRules']),
    hasSelectedCoverages() {
      // Verificar si hay coberturas seleccionadas para eliminar
      if (!this.form.coberturas || this.form.coberturas.length === 0) {
        return false
      }
      // Cantidad de coberturas seleccionadas
      const selectedCount = this.form.coberturas.filter(cobertura => cobertura.selected).length
      return selectedCount > 0
    },
    /* CESION-ZS PASO2 — Etiqueta jurada: mismo patrón que frecuencia / eliminación cobertura, más cesión a entidad financiera */
    declaracionJuradaTransactLabel () {
      if (this.changeFrecuencyIsActivated) {
        return 'Cambio Frecuencia de Pago'
      }
      if (this.deleteCoverageIsActivated) {
        return 'Eliminación de Cobertura'
      }
      if (this.endososIsActivated || this.form.transact === 'Endoso a entidad financiera') {
        return 'Endoso a entidad financiera'
      }
      return 'Eliminación de Cobertura'
    },
    /* CESION-ZS PASO4 — Vista éxito: mismo criterio que envío traductor (PASO3), valor fijado en processTransact */
    cesionSuccessUsesTraductorFlow () {
      return this.form.transact === 'Endoso a entidad financiera' && this.cesionUltimoEnvioUsaTraductor === true
    }
  },
  methods: {
    ...mapActions('endorsements', ['getMaxAmountEndorse', 'getPolicyDataPerEndoso', 'checkIfPolicyHasPendingOkEndoso']),
    ...mapActions('user', ['getUserInfo', 'sendSMSValidationPhone', 'checkIfPolicyHasPendingOkActDatos']),
    ...mapActions('formalities', ['registerFormality', 'registerFormalityModifyAccount', 'registerFiles', 'sendMailConstancy', 'getBeneficiariosPoliza', 'getFrequency', 'getWildcardFees', 'fetchWorkflowBanks', 'checkPdfPoliza']),
    ...mapActions('requirements', ['checkIfPolicyHasPending']),
    ...mapActions('event', ['eventLog']),
    ...mapActions('endorsements', ['makeEndorsement', 'makeEndorsementRequirement', 'simularEndoso']),
    loadBanksForEndosos () {
      this.banksLoading = true
      this.fetchWorkflowBanks()
        .then((items) => {
          this.banks = items
        })
        .catch((err) => {
          console.error('Error cargando entidades financieras', { message: err && err.message ? err.message : 'unknown' })
          this.banks = mapWorkflowBanksToSelectItems([])
        })
        .finally(() => {
          this.banksLoading = false
        })
    },
    checkPhoneValidation() {
      if (this.requireValidationPhone()) {
        this.solicitudEnProceso = false
        this.showViewValidationPhone()
        return true
      }
      return false
    },
    backToMain (evt) {
      evt.preventDefault()
      this.$router.push('/inicio')
    },
    next () {
      if (this.window === 0) {
        this.errors.product = this.productErrors()
        this.errors.policy = this.policyErrors()
        this.errors.transact = this.transactErrors()
        // - [TRACK_EVENT]
        this.$gtm.trackEvent({
          event: 'virtualPageView',
          pageTitle: 'Solicitudes | Ingresar Datos',
          pageUrl: '/zonaprivada/solicitudes/ingresar-datos'
        })
        // - [/TRACK_EVENT]

        // #004.33: Elemento - Botón Siguiente
        this.nextButtonAnalytic()

        // - [VALIDACION PARA ENDOSOS]
        if (this.form.transact === 'Endoso a entidad financiera') {
          if (!this.isEndosoBancarioFormValid()) {
            this.endososEntidadErrorsValidate()
            this.endososOtroRucErrorsValidate()
            this.endososMontoErrorsValidate()
            this.emailErrorsValidate()
            return false
          }
          let poliza = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
          this.form.bank = this.endosos.entidad
          this.form.account_number = this.endosos.ruc === 'otros' ? this.endosos.otroRuc : this.endosos.ruc
          this.form.email_financial_advisor = this.endosos.asesor
          // SI ES DISTINTO A PLAN GARANTIZADO Y VIDA FREE. CAMBIAR EL ESTADO A PENDIENTE SAC
          if (poliza[0].codigoProducto !== '77909' && poliza[0].codigoProducto !== '64899') {
            this.form.state = 'PENDIENTE SAC'
          }
          this.form.amount_endorse = this.endosos.monto
        } else if (this.form.transact === 'Liberación de endoso') {
          this.form.state = 'PENDIENTE SAC'
          this.form.currency = null
          this.form.response_medium = 'Electrónico'
        } else if (this.form.transact === 'Anulación de póliza') {
          if (!this.anulaciones.datosPersonales) {
            return false
          }
          if (this.anulaciones.actDatosPendiente) {
            this.$swal({
              title: '¡Solicitud en proceso!',
              html: 'Tu solicitud de actualización de datos se encuentra en proceso. Podrás volver a intentarlo en 24 horas.',
              confirmButtonText: 'Ok'
            })
            return false
          }
        } else if (this.form.transact === 'Modificación de Beneficiarios') {
          let polizaVida = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
          this.$router.push({ name: 'PerfilBeneficiarios',
            params: {
              policy: this.form.policy,
              productName: this.form.product,
              producto: polizaVida.ramo || this.ramo,
              subProducto: polizaVida.nombreProducto
            }
          })
        } else if (this.form.transact === 'Cambio Frecuencia de Pago') {
          // Obtener la fecha efectiva del endoso
          let polizaVida = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
          this.recalculateDateEndorsement(polizaVida[0].pagadoHasta)

          // Agregar el monto de la nueva frecuencia en el registro requirements
          this.form.amount_endorse = this.frecuencias[this.form.new_frequency.toLowerCase()]
        } else if (this.form.transact === 'Eliminación de cobertura') {
          let polizaVida = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })

          this.coberturasRestantes = this.coberturasAdicionales.filter(
            (cobertura) => !this.coberturasEliminadas.some(
              (eliminada) => eliminada === cobertura
            )
          )

          // Lista con el estado "Excluir"
          const listaExcluir = this.coberturasEliminadas.map((cobertura) => ({
            ...cobertura,
            estado: "Excluir",
          }));

          // Lista con el estado "Vigente"
          const listaVigentes = polizaVida[0].coberturasVida.map((cobertura) => ({
            ...cobertura,
            estado: 'Vigente'
          }))

          // Combinar ambas listas priorizando las coberturas de listaExcluir
          // Si hay coberturas con el mismo nombre, prevalece la de listaExcluir
          const listaCoberturas = [
            ...listaExcluir,
            ...listaVigentes.filter(
              (vigente) =>
                !listaExcluir.some((excluir) => excluir.nombre.toLowerCase() === vigente.nombre.toLowerCase())
            )
          ]

          // Formatear la lista final
          const formattedCoberturas = listaCoberturas.map((cobertura) => ({
            COVCodigoCobertura: cobertura.codigoCobertura,
            COVDescCobertura: cobertura.nombre.toUpperCase(),
            COVEstado: cobertura.estado
          }))

          this.form.coberturas = formattedCoberturas
          this.form.amount_endorse = this.form.new_amount
        }
        // - [/VALIDACION PARA ENDOSOS]
        if (this.form.product && this.form.policy && this.form.transact && this.validateFilesUploadesSuccessfully()) {
          // this.window = this.window + 1 === length - 1 ? this.window : this.window + 1
          this.window = 1
        }
      } else if (this.window === 1) {
        // this.errors.department = this.departmentErrors()
        // this.errors.province = this.provinceErrors()
        // this.errors.home_address = this.homeAddressErrors()
        this.errors.email = this.emailErrors()
        // this.errors.cellphone = this.cellphoneErrors()
        // - [TRACK_EVENT]
        this.$gtm.trackEvent({
          event: 'virtualPageView',
          pageTitle: 'Solicitudes | Cargar Documentos',
          pageUrl: '/zonaprivada/solicitudes/cargar-documentos'
        })
        // - [/TRACK_EVENT]

        // #004.33: Elemento - Botón Siguiente
        this.nextButtonAnalytic()

        if (this.form.name && this.form.paternal_surname && this.form.maternal_surname && this.form.type_document && this.form.number_document && this.form.email && this.form.cellphone) {
          this.window = this.window + 1 === length ? this.window : this.window + 1
          // if (this.window === length)
          // TRACK EVENT - AMPLITUDE
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.summaryRequest,
              {
                'Producto': this.form.product,
                'Poliza': this.form.policy,
                'Tipo de Solicitud': this.form.transact,
                'Motivo': ''
              }
            )
        }
      }
    },
    prev () {
      this.window = this.window - 1 < 0 ? this.window : this.window - 1

      // #004.35: Elemento - Botón Volver
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis solicitudes - Paso 2 - Resumen de solicitud',
        'label': 'Seleccionar botón - Volver'
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis solicitudes - Paso 2 - Resumen de solicitud',
        'CTA': 'Seleccionar botón - Volver'
      })
    },
    checkFieldsInvalidDatosPersonales () {
      this.errors.department = this.departmentErrors()
      this.errors.province = this.provinceErrors()
      this.errors.home_address = this.homeAddressErrors()
      this.errors.email = this.emailErrors()
      this.errors.cellphone = this.cellphoneErrors()

      if (Object.keys(this.errors.department).length > 0 ||
          Object.keys(this.errors.province).length > 0 ||
          Object.keys(this.errors.home_address).length > 0 ||
          Object.keys(this.errors.email).length > 0 ||
          Object.keys(this.errors.cellphone).length > 0) {
        this.flags.enableBtnNext = false
      } else {
        this.flags.enableBtnNext = true
      }
    },
    setInfoInForm () {
      // [RENTAS]
      let polizasRentas = this.polizasInfo.filter(function (poliza) {
        return poliza.ramo === 'RRVV'
      })
      if (polizasRentas.length > 0) {
        this.transact = this.transact.concat(transacts.rentas)
      }
      // [VIDA]
      let polizasVida = this.polizasInfo.filter(function (poliza) {
        return poliza.ramo === 'Vida' || poliza.ramo === ''
      })
      if (polizasVida.length > 0) {
        this.transact = this.transact // .concat(transacts.vida)
      }
      // [MASIVO]
      let polizasMasivos = this.polizasInfo.filter(function (poliza) {
        return poliza.ramo === 'Masivo'
      })
      if (polizasMasivos.length > 0) {
        this.transact = this.transact.concat(transacts.masivos)
      }
      // [COMPLETE-FORM_DATA]
      this.products = polizasRentas.map(function (p) { return p.producto }).concat(polizasVida.map(function (p) { return p.producto })).concat(polizasMasivos.map(function (p) { return p.producto }))
      this.form.name = this.basicInfo.nombres
      this.form.paternal_surname = this.basicInfo.apellidoPaterno
      this.form.maternal_surname = this.basicInfo.apellidoMaterno
      this.form.type_document = this.basicInfo.tipoDocumento
      this.form.number_document = this.basicInfo.numeroDocumento
      this.form.cellphone = this.basicInfo.celular === '' ? '-' : this.basicInfo.celular
      this.form.email = this.basicInfo.correo
      this.form.phone = this.basicInfo.telefono === '' ? '-' : this.basicInfo.telefono

      this.validateProduct()
    },
    closeDialog (type) {
      this.form.response_medium = null
      this.images.responseFisic = require('./../assets/formpp/address-noactivated.svg')
      this.images.responseEmail = require('./../assets/formpp/email-noactivated.svg')
      switch (type) {
      case 'Electrónico':
      case 'electronico':
        this.completeEmail = false
        break
      case 'Físico':
      case 'fisico':
        this.completeAddress = false
        break
      }
    },
    viewAsistent () {
      this.$router.push({ name: 'AsistenciasVivemas' })
    },
    viewDescuent () {
      this.$router.push({ name: 'DescuentosVivemas' })
    },
    /** GENERATE PDF CONFIRMATION */
    downloadTransact () {
      let numTransact = this.numCode
      let pdfName = 'tramite_' + numTransact
      const coordX = 15
      // eslint-disable-next-line new-cap
      var doc = new jsPDF()
      doc.text('Resumen del trámite', coordX, 20)
      doc.setFontSize(13)
      doc.setTextColor(25, 118, 210)
      doc.text('Datos generales', coordX, 35)
      doc.setFontSize(10)
      doc.setTextColor(0, 0, 0)
      doc.text('N° de solicitud: ', coordX, 45)
      doc.text(numTransact, 75, 45)
      doc.text('Fecha de trámite:', coordX, 50)
      doc.text('' + this.today, 75, 50)
      doc.text('Producto:', coordX, 55)
      doc.text('' + this.form.product, 75, 55)
      doc.text('Número de póliza:', coordX, 60)
      doc.text('' + this.form.policy, 75, 60)
      doc.setFontSize(13)
      doc.setTextColor(25, 118, 210)
      doc.text('Datos del cliente', coordX, 75)
      doc.setFontSize(10)
      doc.setTextColor(0, 0, 0)
      doc.text('Nombres:', coordX, 85)
      doc.text('' + this.form.name, 75, 85)
      doc.text('Apellido paterno:', coordX, 90)
      doc.text('' + this.form.paternal_surname, 75, 90)
      doc.text('Apellido materno:', coordX, 95)
      doc.text('' + this.form.maternal_surname, 75, 95)
      doc.text('Tipo de Documento:', coordX, 100)
      doc.text('' + this.form.type_document, 75, 100)
      doc.text('Número de Documento:', coordX, 105)
      doc.text('' + this.form.number_document, 75, 105)
      doc.text('Correo:', coordX, 110)
      doc.text('' + this.form.email, 75, 110)
      /*
      doc.text('Dirección:', 15, 115)
      doc.text('' + this.form.home_address, 75, 115)
      doc.text('Departamento:', 15, 120)
      doc.text('' + this.form.department, 75, 120)
      doc.text('Provincia:', 15, 125)
      doc.text('' + this.form.province, 75, 125)
      doc.text('Distrito:', 15, 130)
      */
      doc.text('Teléfono:', coordX, 115)
      doc.text('' + this.form.phone, 75, 115)
      doc.text('Teléfono celular:', coordX, 120)
      doc.text('' + this.form.cellphone, 75, 120)
      doc.setFontSize(13)
      doc.setTextColor(25, 118, 210)
      doc.text('Datos del trámite', coordX, 135)
      doc.setFontSize(10)
      doc.setTextColor(0, 0, 0)
      doc.text('Trámite:', coordX, 145)
      doc.text('' + this.form.transact, 75, 145)
      var blockHeight = 0

      if (this.form.detail_transact !== null && this.form.detail_transact.length > 0) {
        doc.text('Detalle del trámite:', coordX, 170)
        // SPLIT TEXT DETAIL TRANSACT
        if (this.form.detail_transact.split(' ').length > 1) {
          var lineHeight = doc.getLineHeight(this.form.detail_transact) / doc.internal.scaleFactor
          var splittedDetailTransactText = doc.splitTextToSize(this.form.detail_transact, 120)
          var lines = splittedDetailTransactText.length
          blockHeight = lines * lineHeight
          doc.text(splittedDetailTransactText, 75, 170)
        } else {
          blockHeight = 0
          doc.text('' + this.form.detail_transact, 75, 170)
        }
      }

      // SPLITTED TEXT
      // CALCULATE NEXT LINES
      var yPos = ((this.form.transact === 'Liberación de endoso') ? 150 : 170) + blockHeight + 5
      // NEXT LINES
      doc.text('Medio de respuesta:', coordX, yPos)
      doc.text('' + this.form.response_medium, 75, yPos)
      doc.setFontSize(13)
      doc.setTextColor(25, 118, 210)
      yPos += 15
      doc.text('Adjuntos', coordX, yPos)
      doc.setFontSize(10)
      doc.setTextColor(0, 0, 0)
      if (this.filesAttachments.length > 0 && this.form.transact === 'Liberación de endoso') {
        yPos += 10
        let self = this
        for (let index = 0; index < self.filesAttachments.length; index++) {
          doc.setTextColor(0, 173, 238)
          doc.text((index + 1) + '.', coordX, yPos)
          doc.setTextColor(0, 0, 0)
          doc.text('' + self.filesAttachments[index].file.name, 19, yPos)
          yPos += 5
        }
      } else if (this.fileAlreadyUpload && this.fileAlreadyUpload.length > 0) {
        yPos += 10
        let self = this
        let resAttachments = attachmentRules.filter(function (a) { return a.main === self.form.transact })
        let number = 1
        for (let index = 0; index < resAttachments[0].attachments.length; index++) {
          if (resAttachments[0].attachments[index].attach) {
            doc.setTextColor(0, 173, 238)
            doc.text(number + '.', coordX, yPos)
            doc.setTextColor(0, 0, 0)
            doc.text('' + resAttachments[0].attachments[index].name, 19, yPos)
            yPos += 5
            doc.text('' + this.fileAlreadyUpload[number - 1], 19, yPos)
            yPos += 5
            number += 1
          }
        }
      } else {
        yPos += 10
        doc.text('NO HAY ARCHIVOS ADJUNTADOS.', coordX, yPos)
      }

      doc.save(pdfName + '.pdf')
    },
    saveEmailDialog () {
      this.errors.email = this.emailErrors()
      if (this.form.email && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)) {
        this.completeEmail = false
      }
    },
    validateTransact () {
      let self = this
      let messageAlert = 'Este trámite no está disponible para el producto seleccionado. Por favor, elige otro.'
      /** AUTOCOMPLETE POLICIES SELECT/OPTION */
      if (this.form.product && this.policies.length < 1) {
        let productName = this.form.product
        let polizas = this.polizasInfo.filter(function (poliza) {
          return poliza.producto === productName
        })
        // FIX FOR IE11
        if (polizas.length > 0) {
          this.policies = polizas.map(function (p) { return p.numeroPoliza })
          let ramo = polizas[0].ramo
          switch (ramo) {
          case 'Vida':
            this.typeProductSelected = 'Vida'
            this.images.mainIcon = require('./../assets/icons/icon-educacion-garantizada.svg')
            break
          case 'RRVV':
            this.typeProductSelected = 'Rentas'
            this.images.mainIcon = require('./../assets/icons/icon-rentas.svg')
            break
          case 'Masivo':
            this.images.mainIcon = require('./../assets/icons/icon-otros.svg')
            let polizasMasivos = this.polizasInfo.filter(function (poliza) {
              return (poliza.ramo === 'Masivo' && poliza.producto === productName)
            })
            this.policies = polizasMasivos.map(function (p) { return p.numeroPoliza })
            this.typeProductSelected = 'Masivo'
            break
          default:
            this.typeProductSelected = 'Vida'
            this.images.mainIcon = require('./../assets/icons/icon-educacion-garantizada.svg')
            break
          }
        }
      }
      /** CHECK IF TRANSACT IS VALIDATE PER TYPE OF PRODUCT */
      if (this.form.transact) {
        if (this.form.product) {
          let producto = this.polizasInfo.filter(function (poliza) { return poliza.producto === self.form.product })
          let ramo = producto[0].ramo
          let ownTransact = null
          switch (ramo) {
          case 'Vida':
            ownTransact = transacts.vida.filter(function (t) { return t === self.form.transact })
            break
          case 'RRVV':
            ownTransact = transacts.rentas.filter(function (t) { return t === self.form.transact })
            break
          case 'Masivo':
            ownTransact = transacts.masivos.filter(function (t) { return t === self.form.transact })
            break
          }
          /** SI ELIGE UN TRAMITE QUE NO CORRESPONDE A SU PRODUCTO, APARECERÁ ESTE MENSAJE */
          if (ownTransact.length < 1) {
            this.$swal({
              title: 'Atención',
              text: messageAlert,
              confirmButtonText: 'Entendido'
            }).then((result) => {
              this.form.transact = null
            })
          } else {
            // - SOLO LLAMAR ESTA FUNCION CUANDO NO SEA ENDOSO. CUANDO ES ENDOSO, ESTA FUNCIONA SE ACTIVA EN LA FUNCION afterSelectTransact
            const requirement = Functionalities.requirements[this.form.transact] || this.form.transact
            if (!Functionalities.isAvailable(requirement, self.functionsRules, self)) {
              self.transact = self.transact.filter(x => x !== self.form.transact)
              self.form.transact = ''
              return
            }
            // Redirigir a vista específica para anulación SOAT
            if (this.form.transact === 'Anulación de póliza' && this.form.product === 'SOAT') {
              this.$router.push({
                name: 'FormalitiesSOATCancellation',
                params: {
                  policy: this.form.policy,
                  product: this.form.product
                }
              })
              return
            }
            
            if (this.form.transact === 'Modificación de Beneficiarios') {
              let polizaVida = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
              this.$router.push({ name: 'PerfilBeneficiarios',
                params: {
                  policy: this.form.policy,
                  productName: this.form.product,
                  producto: polizaVida.ramo || this.ramo,
                  subProducto: polizaVida.nombreProducto
                }
              })
            } else if (this.form.transact !== 'Endoso a entidad financiera') {
              this.changeViewForDesktop()
            }
          }
        }
      }
      this.validateReason()
    },
    changeLabel (type) {
      if (type === 'product') {
        let selectProduct = document.querySelector('#select_product')
        if (selectProduct !== null && this.form.product !== null && this.form.product !== '') {
          selectProduct.parentElement.previousElementSibling.innerText = 'Producto'
        }
        return
      }
      if (type === 'poliza') {
        let selectPoliza = document.querySelector('#select_poliza')
        let poliza = this.polizasInfo !== null ? this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy }) : []
        if (selectPoliza !== null && this.form.policy !== null && this.form.policy !== '') {
          selectPoliza.parentElement.previousElementSibling.innerText = 'Póliza'
        }

        if (poliza.length > 0 && poliza[0].ramo === 'Vida') {
          this.checkIfPolicyHasPending({ numeroPoliza: poliza[0].numeroPoliza })
            .then((res) => {
              // this.transact = []
              // let toRemove = []
              // let requirements = res.data.data.filter((req) => req.transact !== 'Liberación de endoso')
              if (!poliza[0].puedeCuotaComodin) {
                let indexCuotaComodin = this.transact.indexOf('Cuota comodín')
                if (indexCuotaComodin !== -1) {
                  this.transact.splice(indexCuotaComodin, 1)
                }
                // toRemove.push('Cuota comodín')
              }
              // CAMBIO DE FRECUENCIA DE PAGO
              if (!poliza[0].puedeCambiarFrecuencia) {
                let indexCambioFrecuenciaPago = this.transact.indexOf('Cambio Frecuencia de Pago')
                if (indexCambioFrecuenciaPago !== -1) {
                  this.transact.splice(indexCambioFrecuenciaPago, 1)
                }
                // toRemove.push('Cambio de frecuencia de pago')
              }

              if (!poliza[0].puedeEndosar) {
                let indexEndosoEntidad = this.transact.indexOf('Endoso a entidad financiera')
                if (indexEndosoEntidad !== -1) {
                  this.transact.splice(indexEndosoEntidad, 1)
                }
                // toRemove.push('Endoso a entidad financiera')
              }

              if (!poliza[0].puedeLiberarEndoso) {
                let indexLiberacionEndoso = this.transact.indexOf('Liberación de endoso')
                if (indexLiberacionEndoso !== -1) {
                  this.transact.splice(indexLiberacionEndoso, 1)
                }
                // toRemove.push('Liberación de endoso')
              }

              if (!poliza[0].puedeCambiarBeneficiario) {
                let indexCambiarBeneficiario = this.transact.indexOf('Modificación de Beneficiarios')
                if (indexCambiarBeneficiario !== -1) {
                  this.transact.splice(indexCambiarBeneficiario, 1)
                }
                // toRemove.push('Liberación de endoso')
              }

              // ELIMINACIÓN DE COBERTURAS:
              if (!poliza[0].puedeRetirarCoberturas) {
                let indexRetiroCoberturas = this.transact.indexOf('Eliminación de cobertura')
                if (indexRetiroCoberturas !== -1) {
                  this.transact.splice(indexRetiroCoberturas, 1)
                }
                // toRemove.push('Cambio de frecuencia de pago')
              }
              /*
              for (let requirement of requirements) {
                if (toRemove.indexOf(requirement.transact)) {
                  toRemove.push(requirement.transact)
                }
              }
              for (let transact of transacts.vida) {
                if (!toRemove.includes(transact)) {
                  this.transact.push(transact)
                }
              }
              */
            })
            .catch(() => {
              this.transact = []
            })
        }
        return
      }
      if (type === 'reason') {
        let selectReason = document.querySelector('#select_reason')
        if (selectReason !== null && this.form.description_cancellation !== null && this.form.description_cancellation !== '') {
          selectReason.parentElement.previousElementSibling.innerText = 'Motivo'
        }
        return
      }
      if (type === 'relationship_benef') {
        let selectRShipBenef = document.querySelector('#select_relationship_benef')
        if (selectRShipBenef !== null && this.beneficiario.relationship !== null && this.beneficiario.relationship !== '') {
          selectRShipBenef.parentElement.previousElementSibling.innerText = 'Parentesco'
        }
        return
      }
      if (type === 'reason_removebenef') {
        let selectReasonRemovBenef = document.querySelector('#select_reason_removebenef')
        if (selectReasonRemovBenef !== null && this.beneficiario.reason !== null && this.beneficiario.reason !== '') {
          selectReasonRemovBenef.parentElement.previousElementSibling.innerText = 'Motivo'
        } else {
          selectReasonRemovBenef.parentElement.previousElementSibling.innerText = 'Seleccione motivo'
        }
      }
    },
    validateOnlyLetter (event) {
      let keyCode = event.keyCode ? event.keyCode : event.which
      if (keyCode >= 48 && keyCode <= 57) {
        event.preventDefault()
      }
    },
    saveAddressDialog () {
      this.errors.department = this.departmentErrors()
      this.errors.province = this.provinceErrors()
      // this.errors.district = this.districtErrors()
      this.errors.home_address = this.homeAddressErrors()
      this.errors.interior = this.interiorErrors()
      if (this.form.department && this.form.province && this.form.district && this.form.home_address && this.form.interior) {
        this.completeAddress = false
      }
    },
    backHome () {
      this.$router.push('/inicio')
    },
    downloadFile (fileurl) {
      var fileuri = require('./../assets/downloable/' + fileurl)
      window.open(fileuri)
    },
    filesUploadesSuccessfully () {
      let _self = this
      const codeGTMIgnore = [transacts.codesGTM.INCLUSION_BENEF,
        transacts.codesGTM.EXCLUSION_BENEF,
        transacts.codesGTM.RENOV_CERTIF,
        transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA]
      const idx = codeGTMIgnore.findIndex((code) => code === _self.codeGTM)
      if (idx !== -1) return true

      let countFileUpload = 0
      let fileUpload = this.attachments.attachments.filter(function (file) { return file.attach }).length
      if (this.availableForUpload) {
        countFileUpload = this.filesAttachments.length
      }
      if (countFileUpload !== fileUpload) {
        return false
      }
      return true
    },
    validateFilesUploadesSuccessfully () {
      if (!this.filesUploadesSuccessfully()) {
        this.$swal({
          title: 'Atención',
          text: 'Debes cargar todos los archivos requeridos para completar el trámite.',
          imageUrl: require('./../assets/formpp/atencion-2.svg'),
          imageHeight: 80,
          imageWidth: 80,
          confirmButtonText: 'Entiendo'
        })
        return false
      }
      return true
    },
    validateReason () {
      if (this.codeGTM === 'REBBE' && this.form.description_cancellation !== null) {
        if (this.form.description_cancellation === this.reasons[0]) {
          this.fileAttachment.title = 'Acta de defunción del Beneficiario'
        } else if (this.form.description_cancellation === this.reasons[1]) {
          this.fileAttachment.title = 'Acta de Matrimonio'
        }
        this.showFileAttachments = true
      }
    },
    changeRelationship () {
      if (this.form.relationship !== null) {
        const idx = this.relationships.findIndex(rs => rs === this.form.relationship)
        this.important_message = this.importantMessagesRelationShip[idx]
        this.showImportantMessageRelationShip = true
      }
    },
    getBeneficiariosInclusionBenef () {
      let _self = this
      let callback = function () {
        _self.showBeneficiarios = true
      }
      _self.getBeneficiarios(callback)
    },
    getBeneficiariosExclusionBenef () {
      let _self = this
      let callback = function () {
        _self.showRemoveBeneficiarios = true
      }
      _self.getBeneficiarios(callback)
    },
    getBeneficiariosRenovacionCertificado () {
      let _self = this
      let callback = function () {
        _self.showRenovacionCertificados = true
      }
      _self.getBeneficiarios(callback)
    },
    getBeneficiarios (callback) {
      let _self = this
      let data = {
        'codCartera': 'rvi',
        'codPoliza': _self.form.policy,
        'usuario': 'username'
      }
      if (_self.beneficiarios !== null && _self.beneficiarios.length > 0) {
        _self.existBeneficiarios = true
        callback()
      } else {
        _self.getBeneficiariosPoliza(data).then(res => {
          if (res.status === 200) {
            if (res.data.length > 1) {
              _self.beneficiarios = res.data.slice(1)
              _self.existBeneficiarios = true
              callback()
            } else {
              _self.existBeneficiarios = false
            }
          }
        })
      }
    },
    changeParentescoAddBenef (value) {
      const idx = this.relationships.findIndex((v) => v === value)
      this.beneficiario.msgIndication = this.msgsIndications[idx]
    },
    addBeneficiario () {
      let _self = this
      let newBeneficiario = Object.assign({}, _self.beneficiario)
      newBeneficiario.fullName = newBeneficiario.apePat + ' ' + newBeneficiario.apeMat + ', ' + newBeneficiario.name
      let dialog = document.querySelector('#dialog_beneficiario')
      const mode = dialog.getAttribute('data-mode')
      if (mode === 'edit') {
        const idx = dialog.getAttribute('data-id')
        _self.beneficiariosAdd[idx - 1] = newBeneficiario
      } else {
        _self.beneficiariosAdd.push(newBeneficiario)
      }
      _self.closeDialogBeneficiario()
    },
    cleanFormAddBeneficiario () {
      this.beneficiario.dni = null
      this.beneficiario.name = null
      this.beneficiario.apePat = null
      this.beneficiario.apeMat = null
      this.beneficiario.fullName = null
      this.beneficiario.fecNac = null
      this.beneficiario.genero = null
      this.beneficiario.relationship = null
      this.beneficiario.reason = null
      this.beneficiario.files = []
      this.beneficiario.msgIndication = null
      this.beneficiario.conditionsAccepted = false
    },
    isDisableBtnAddBeneficiario () {
      let countFileUploads = this.attachments.attachments.filter(function (file) { return file.attach }).length
      if (this.beneficiario.files === null || this.beneficiario.files.length < countFileUploads) {
        return true
      }
      return false
    },
    deleteBenef (event) {
      let id = event.target.parentElement.getAttribute('id').split('_')[1]
      let idx = parseInt(id)
      this.beneficiariosAdd = this.beneficiariosAdd.slice(0, idx - 1).concat(this.beneficiariosAdd.slice(idx, this.beneficiariosAdd.length))
    },
    editBenef (event) {
      let id = event.target.parentElement.getAttribute('id').split('_')[1]
      let idx = parseInt(id)
      this.beneficiario = Object.assign({}, this.beneficiariosAdd[idx - 1])
      let dialog = document.querySelector('#dialog_beneficiario')
      dialog.setAttribute('data-mode', 'edit')
      dialog.setAttribute('data-id', idx)
      this.dialogBeneficiario = true
    },
    addRenovacionCertificado () {
      let newBenefRenov = Object.assign({}, this.beneficiario)
      const idx = this.beneficiariosAdd.findIndex((b) => b.dni === newBenefRenov.dni)
      if (idx === -1) {
        this.beneficiariosAdd.push(newBenefRenov)
      } else {
        this.beneficiariosAdd[idx] = newBenefRenov
      }
      this.closeDialogRenovCertificado()
    },
    isAddedInRenovations (dni) {
      return this.beneficiariosAdd.findIndex((b) => b.dni === dni) !== -1
    },
    isDisableBtnRenovCertificado () {
      let countFileUploads = this.attachments.attachments.filter(function (file) { return file.attach }).length
      if (this.beneficiario.files === null || this.beneficiario.files.length < countFileUploads || this.beneficiario.conditionsAccepted === false) {
        return true
      }
      return false
    },
    isDisabledRemoveBenef () {
      // const boolEnable = this.beneficiario.reason !== null
      let countFileUploads = this.attachments.attachments.filter(function (file) { return file.attach }).length
      if ((this.isReasonAttachment && (this.beneficiario.files === null || this.beneficiario.files.length < countFileUploads))) {
        return true
      }
      return false
    },
    requireValidationPhone () {
      let codesGTMReqValidationPhone = [
        transacts.codesGTM.INCLUSION_BENEF,
        transacts.codesGTM.EXCLUSION_BENEF,
        transacts.codesGTM.MODIF_NUM_CUENTA
      ]
      if (codesGTMReqValidationPhone.indexOf(this.codeGTM) !== -1 && !this.validatedPhone) {
        return true
      }
      return false
    },
    showViewValidationPhone () {
      let _self = this
      let callback = function () {
        _self.showValidationPhone = true
      }
      _self.launchSendSMS(callback)
    },
    addRemoveBeneficiario () {
      if (!this.isReasonAttachment) {
        this.beneficiario.files = []
      }
      let newRemoveBenef = Object.assign({}, this.beneficiario)
      const idx = this.beneficiariosAdd.findIndex((b) => b.dni === newRemoveBenef.dni)
      if (idx === -1) {
        this.beneficiariosAdd.push(newRemoveBenef)
      } else {
        this.beneficiariosAdd[idx] = newRemoveBenef
      }
      this.closeDialogRemoveBeneficiario()
    },
    isDeleted (benef) {
      const idx = this.beneficiariosAdd.findIndex((b) => b.dni === benef.num_identificacion)
      if (idx === -1) {
        return false
      }
      return true
    },
    changeReasonRemovebenef (opt) {
      const optDivorcio = this.reasonRemovBenef[0]
      if (optDivorcio === opt) {
        this.isReasonAttachment = true
      } else {
        this.isReasonAttachment = false
      }
    },
    setEntidadesBancarias () {
      this.entidadesBancarias = transacts.cuentasBancarias.map((cb) => cb.entidad)
      this.dataNroCuenta.entidad = null
      this.dataNroCuenta.tipoCuenta = null
      this.dataNroCuenta.tipoMoneda = null
      this.dataNroCuenta.nroCuenta = null
    },
    changeEntidadBancaria (value) {
      this.tiposCuentas = transacts.cuentasBancarias.filter((cb) => cb.entidad === value)[0].tipo_cuentas.map((tc) => tc.tipo)
      this.dataNroCuenta.tipoCuenta = null
      this.dataNroCuenta.tipoMoneda = null
      this.dataNroCuenta.nroCuenta = null
    },
    changeTipoCuenta (value) {
      let self = this
      self.maskTipoCuenta = transacts.cuentasBancarias.filter((cb) => cb.entidad === self.dataNroCuenta.entidad)[0].tipo_cuentas.filter((tc) => tc.tipo === value)[0].format
      this.dataNroCuenta.tipoMoneda = null
      this.dataNroCuenta.nroCuenta = null
    },
    processTransactNormal(){
      let self = this
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.requestSent,
          {
            'Producto': this.form.product,
            'Poliza': this.form.policy,
            'Tipo de Solicitud': this.form.transact,
            'Motivo': ''
          }
        )
      if (this.checkPhoneValidation()) {
        this.loader = false
        return
      }
      // VARIABLES
      let canContinue = true
      this.fileAlreadyUpload = []
      if (this.validateFilesUploadesSuccessfully()) {
        // CHECK GENERAL DATA
        if (this.noMissingFormData()) {
          if (canContinue) {
            this.loader = true
            this.form.home_address = '-'
            this.form.department = '-'
            this.form.province = '-'
            this.form.district = '-'
            this.form.response_medium = 'Electrónico'

            if (this.codeGTM === transacts.codesGTM.INCLUSION_BENEF ||
              this.codeGTM === transacts.codesGTM.RENOV_CERTIF ||
              this.codeGTM === transacts.codesGTM.EXCLUSION_BENEF) {
              this.form.detail_transact = ''
              for (let index = 0; this.beneficiariosAdd !== null && index < this.beneficiariosAdd.length; index++) {
                let dataBenef = this.beneficiariosAdd[index]
                this.form.detail_transact += '['
                this.form.detail_transact += dataBenef.dni + ' - ' + dataBenef.fullName
                if (this.codeGTM === transacts.codesGTM.EXCLUSION_BENEF) {
                  this.form.detail_transact += ' - ' + dataBenef.reason
                }
                this.form.detail_transact += ']'
                if (index < this.beneficiariosAdd.length - 1) {
                  this.form.detail_transact += ' / '
                }
                for (let j = 0; j < dataBenef.files.length; j++) {
                  formData.append('filenames[]', dataBenef.files[j]['file'])
                  let fileName = dataBenef.files[j]['name'] + ' - ' + dataBenef.dni
                  formData.append('fileinputnames[]', fileName)
                  // SAVE FILES UPLOAD
                  this.fileAlreadyUpload.push(fileName)
                }
              }
            } else if (this.codeGTM === transacts.codesGTM.MODIF_NUM_CUENTA) {
              this.form.detail_transact = this.dataNroCuenta.entidad + ' - ' + this.dataNroCuenta.tipoCuenta
              this.form.detail_transact += ' - ' + this.dataNroCuenta.tipoMoneda + ' - ' + this.dataNroCuenta.nroCuenta
            }

            const eventData = {
              categoria: 'Funcionalidad',
              nombre: this.form.transact,
              datos: {
                request: this.form,
                numeroPoliza: this.form.policy
              }
            }
            // BEGIN PROCESS
            const polizaFind = self.polizasInfo.find(p => p.numeroPoliza === self.form.policy) || {}
            const metadata = {
              numeroPoliza: self.form.policy,
              productoConsultado: polizaFind.ramo || self.ramo
            }
            switch (metadata.productoConsultado) {
              case 'Vida':
                metadata.subproductoConsultado = polizaFind.nombreProducto
                break
              case 'RRVV':
                metadata.subproductoConsultado = polizaFind.codigoProducto
                break
              case 'Masivo':
                metadata.subproductoConsultado = polizaFind.producto
                break
              default:
                metadata.subproductoConsultado = polizaFind.nombreProducto
            }

            this.registerFormality(this.form).then(res => {
              console.log('res', res)
              eventData.datos.statusCode = res.status
              eventData.datos.response = res.data
              if (res.status === 200 && res.data.success) {
                // SET CODE OF REQUIREMENT
                let event = {}
                // gtm success
                switch (self.form.transact) {
                  case 'Endoso a entidad financiera': {
                    event = self.trackEvents.endorsements.success
                    break
                  }
                  case 'Cuota comodín': {
                    event = self.trackEvents.wildcard.success
                    break
                  }
                  case 'Cambio de frecuencia de pago': {
                    event = self.trackEvents.frequency.success
                    break
                  }
                  case 'Liberación de endoso': {
                    event = self.trackEvents.release.success
                    break
                  }
                  case 'Eliminación de cobertura': {
                    event = self.trackEvents.coverages.success
                    break
                  }
                }
                event.producto = this.form.product
                // self.$gtm.trackEvent(event)
                self.numCode = res.data.data.num_code
                // Capturando el ID del requerimiento para pasarlo al endoso
                const requirementId = res.data.data.id
                
                // Validar que el requirementId esté presente
                if (!requirementId) {
                  self.$swal({
                    title: 'Error',
                    text: 'No se pudo obtener el ID del requerimiento. Por favor, inténtalo de nuevo.',
                    imageUrl: require('./../assets/formpp/atencion-1.svg'),
                    imageHeight: 180,
                    imageWidth: 180,
                    confirmButtonText: 'Entendido'
                  })
                  self.solicitudEnProceso = false
                  self.loader = false
                  return
                }

                // MAKE FORMDATA FOR FILES
                let filesExist = false
                if ((this.filesAttachments !== null && this.filesAttachments.length > 0) ||
                  (this.beneficiariosAdd !== null && this.beneficiariosAdd.length > 0)) {
                  formData.append('requirement_id', res.data.data.id)
                  formData.append('policy', res.data.data.policy)
                  eventData.datos.requerimiento = res.data.data.id
                  filesExist = true
                }

                for (let index = 0; this.filesAttachments !== null && index < this.filesAttachments.length; index++) {
                  formData.append('filenames[]', this.filesAttachments[index]['file'])
                  formData.append('fileinputnames[]', this.filesAttachments[index]['name'])
                  // SAVE FILES UPLOAD
                  this.fileAlreadyUpload.push(this.filesAttachments[index]['file'].name)
                }
                let callBackRegisterFiles = function () {
                  self.solicitudEnProceso = false
                  let requestEndoso = null

                  switch (self.form.transact) {
                  case 'Cambio Frecuencia de Pago': {
                    if (!requirementId) {
                      requestEndoso = null
                    } else {
                      requestEndoso = self.makeRequirementForAcsele(self.form.transact, null, requirementId)
                    }
                    break
                  }
                  case 'Eliminación de cobertura': {
                    if (!requirementId) {
                      requestEndoso = null
                    } else {
                      const coverages = self.form.coberturas;
                      requestEndoso = self.makeRequirementForAcsele(self.form.transact, coverages, requirementId)
                    }
                    break
                  }
                  case 'Liberación de endoso': {
                    // Para liberación de endoso no se necesita generar requestEndoso
                    // ya que es un trámite que solo requiere adjuntar documentos
                    requestEndoso = { transact: 'Liberación de endoso', skipEndoso: true }
                    break
                  }
                  case 'Endoso a entidad financiera': {
                    requestEndoso = { transact: 'Endoso a entidad financiera', skipEndoso: true }
                    break
                  }
                  case 'Anulación de póliza': {
                    // Anulación de póliza no genera endoso, solo requiere el registro del requerimiento
                    requestEndoso = { transact: 'Anulación de póliza', skipEndoso: true }
                    break
                  }
                  }
                  const callback = (error) => {
                    self.loader = false
                    self.processFinished = !error
                    // REGISTER INTO GOOGLE TAG MANAGER
                    // #004.34: Elemento - Botón Enviar Solicitud
                    self.$gtm.trackEvent({
                      'event': 'virtualEvent',
                      'category': 'Zona Segura',
                      'action': 'Mis solicitudes - Paso 2 - Resumen de solicitud',
                      'label': 'Seleccionar botón - Enviar solicitud'
                    })

                  }

                  // PASO 2: Generar endoso en backend Zona Segura
                  if (requestEndoso) {
                    // Para liberación de endoso, no se necesita generar endoso
                    if (requestEndoso.skipEndoso) {
                      callback(); // Llamar callback sin error
                      return;
                    }
                    
                    const changeNumCode = ['Cambio Frecuencia de Pago', 'Eliminación de cobertura'].includes(requestEndoso.transact);
                    self.makeEndorsement(requestEndoso).then((response) => {
                      
                      // Manejo específico por código de respuesta
                      switch(response.data.codigoRespuesta) {
                        case '01':
                          // Éxito
                          self.numCode = changeNumCode && response.data.idEnvio;
                          callback();
                          break;
                        case '98':
                          // Requerimiento pendiente
                          self.$swal({
                            title: '¡Lo sentimos!',
                            text: 'Tienes un requerimiento pendiente.',
                            imageUrl: require('./../assets/characters/sorprendido.svg'),
                            imageHeight: 180,
                            imageWidth: 180,
                            confirmButtonText: 'Entendido'
                          });
                          callback(true);
                          break;
                        default:
                          // Cualquier otro error
                          callback(response.data.codigoRespuesta);
                          self.$swal({
                            title: 'Atención',
                            text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
                            imageUrl: require('./../assets/formpp/atencion-1.svg'),
                            imageHeight: 180,
                            imageWidth: 180,
                            confirmButtonText: 'Entendido'
                          });
                          break;
                      }
                    }).catch((err) => {
                      console.log('err', err)
                      
                      // Manejo de errores de red/excepción
                      if(err.data && err.data.codigoRespuesta === '99') {
                        self.$swal({
                          title: '¡Lo sentimos!',
                          text: 'No hemos podido procesar la operación. Por favor, vuelve a intentarlo más tarde.',
                          imageUrl: require('@/assets/characters/oops.svg'),
                          imageHeight: 180,
                          imageWidth: 180,
                          confirmButtonText: 'Entendido'
                        });
                      } else {
                        // Error de red o cualquier otro error
                        self.$swal({
                          title: 'Atención',
                          text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
                          imageUrl: require('./../assets/formpp/atencion-1.svg'),
                          imageHeight: 180,
                          imageWidth: 180,
                          confirmButtonText: 'Entendido'
                        });
                      }
                      callback(true);
                    })
                  } else {
                    self.$swal({
                      title: 'Ocurrió un problema',
                      text: 'No se pudo generar la solicitud de endoso. Por favor, inténtalo de nuevo.',
                      imageUrl: require('./../assets/formpp/atencion-1.svg'),
                      imageHeight: 180,
                      imageWidth: 180,
                      confirmButtonText: 'Entendido'
                    })
                    callback(true)
                  }

                }
                self.eventLog(eventData).then(() => { }).catch(() => { })
                self.$root.$emit('showNps', {
                  nombre: 'NPS - Inicio de Encuesta',
                  funcionalidad: 'Solicitud ' + self.form.transact,
                  metadata
                })

                if (filesExist) {
                  this.registerFiles(formData).then(r => {
                    // GO TO FINISH
                    callBackRegisterFiles()
                  })
                } else {
                  callBackRegisterFiles()
                }
              } else {
                self.solicitudEnProceso = false
                self.loader = false
              }
            })
              .catch((err) => {
                /** AUX VARIABLES */
                // this.form.department = auxDepartment
                // this.form.province = auxProvince
                // this.form.district = auxDistrict
                this.loader = false
                self.solicitudEnProceso = false
                this.$swal({
                  title: 'Atención',
                  text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
                  imageUrl: require('./../assets/formpp/atencion-1.svg'),
                  imageHeight: 180,
                  imageWidth: 180,
                  confirmButtonText: 'Entendido'
                })
                eventData.datos.Estado = 'Error'
                eventData.datos.statusCode = err.status
                eventData.datos.statusCode = err.data
                self.eventLog(eventData).then(() => { }).catch(() => { })
                metadata.error = err
                self.$root.$emit('showNps', {
                  nombre: 'NPS - Inicio de Encuesta',
                  funcionalidad: 'Solicitud ' + self.form.transact,
                  metadata
                })
              })
          }
        } else {
          this.loader = false
        }
      } else {
        this.loader = false
      }
    },
    processTransactModifyAccountNumber(){
      const eventData = {
        categoria: 'Funcionalidad',
        nombre: this.form.transact,
        datos: {
          request: this.form,
          numeroPoliza: this.form.policy
        }
      }

      let self = this
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.requestSent,
          {
            'Producto': this.form.product,
            'Poliza': this.form.policy,
            'Tipo de Solicitud': this.form.transact,
            'Motivo': ''
          }
        )
      if (this.checkPhoneValidation()) {
        return
      }

      const payloadApiDoc = {
        "tipo": "cambio_metodo_pago",
        "contratante": {
          "poliza": this.form.policy,
          "nombres": this.form.name,
          "apellido_paterno": this.form.paternal_surname,
          "apellido_materno": this.form.maternal_surname,
          "numero_documento": this.form.number_document,
          "tipo_documento": this.form.type_document,
          "correo": this.form.email,
          "telefono": this.form.cellphone
        },
        "devolucion": {
          "monto": "1",
          "moneda": this.dataNroCuenta.tipoMoneda
        },
        "medio_devolucion": {
          "numero_cuenta": this.dataNroCuenta.nroCuenta,
          "titular_cuenta": `${this.form.name} ${this.form.paternal_surname} ${this.form.maternal_surname}`,
          "numero_documento": this.form.number_document,
          "banco": this.dataNroCuenta.entidad,
          "tipo_cuenta": this.dataNroCuenta.tipoCuenta,
          "medio": "Transferencia bancaria"
        }
      }
      
      this.registerFormalityModifyAccount(payloadApiDoc).then(res => {
        self.loader = false
        self.processFinished = true
        eventData.datos.statusCode = res.status
        eventData.datos.response = res.data
        
        self.numCode = res.data.nrosolicitud
        self.eventLog(eventData).then(() => { }).catch(() => { })
      })
      .catch((err) => {
        this.loader = false
        this.$swal({
          title: 'Atención',
          text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
          imageUrl: require('./../assets/formpp/atencion-1.svg'),
          imageHeight: 180,
          imageWidth: 180,
          confirmButtonText: 'Entendido'
        })
        eventData.datos.Estado = 'Error'
        eventData.datos.statusCode = err.status
        eventData.datos.statusCode = err.data
        self.eventLog(eventData).then(() => { }).catch(() => { })
        metadata.error = err
        self.$root.$emit('showNps', {
          nombre: 'NPS - Inicio de Encuesta',
          funcionalidad: 'Solicitud ' + self.form.transact,
          metadata
        })
      })
    },
    /* CESION-ZS PASO3 — Traductor solo si Vida Free: códigos alineados a exención PENDIENTE SAC en next(), más nombre de producto */
    async shouldUseTraductorForCession () {
      const poliza = (this.polizasInfo || []).find((p) => p.numeroPoliza === this.form.policy)
      if (!poliza) {
        return false
      }
      const code = String(poliza.codigoProducto || '').trim()

      const isCessionProduct = TRADUCTOR_PRODUCTS.FINANCIAL_CESSION.includes(code)

      if (!isCessionProduct) return false

      const requiresPdf = TRADUCTOR_PRODUCTS.REQUIRE_PDF.includes(code)

      if (requiresPdf) {
        const codigos = poliza.codigoProceso
        if (!Array.isArray(codigos) || codigos.length === 0) {
          return false
        }
        const existsPdf = await this.checkPdfPoliza({
          numPoliza: poliza.numeroPoliza,
          codProceso: codigos
        })

        return existsPdf
      }

      return true
    },
    /* /CESION-ZS PASO3 — fin shouldUseTraductorForCession */
    async processTransact () {
      // Verificar si hay una solicitud en proceso
      if (!this.solicitudEnProceso) {
        this.solicitudEnProceso = true
      } else {
        return
      }

      try {
        // Determinar qué flujo usar basado en el tipo de transacción
        const canModifyAccount = this.form.transact === 'Modificar número de cuenta'
        const isFrequencyOrCoverageRemoval = ['Cambio Frecuencia de Pago', 'Eliminación de cobertura'].includes(this.form.transact)
        /* CESION-ZS PASO3 — Cesión: traductor/registrar-requerimiento solo Vida Free + PDF si aplica; resto tramites-api legacy */
        let useTraductorForCesion = false
        if (this.form.transact === 'Endoso a entidad financiera') {
          this.loader = true
          useTraductorForCesion = await this.shouldUseTraductorForCession()
          this.cesionUltimoEnvioUsaTraductor = useTraductorForCesion
        }
        const useNewEndorsementFlow = isFrequencyOrCoverageRemoval || useTraductorForCesion
        /* /CESION-ZS PASO3 */

        if (canModifyAccount) {
          this.processTransactModifyAccountNumber()
          return
        }
        if (useNewEndorsementFlow) {
          this.processTransactEndorsementRequirement()
          return
        }
        // Flujo normal para el resto de transacciones
        this.processTransactNormal()
      } catch (err) {
        console.error('Error al determinar flujo de cesión', { message: err && err.message ? err.message : 'unknown' })
        this.solicitudEnProceso = false
        this.loader = false
        this.$swal({
          title: 'Error',
          text: 'Ocurrió un problema al procesar la solicitud. Por favor, inténtalo de nuevo.',
          imageUrl: require('./../assets/formpp/atencion-1.svg'),
          imageHeight: 180,
          imageWidth: 180,
          confirmButtonText: 'Entendido'
        })
      }
    },
    // Método para generar el endoso para el nuevo flujo endoso simple
    makeRequirementForAcseleNew (transact, coverages) {
      const polizaInfo = (this.polizasInfo && Array.isArray(this.polizasInfo))
        ? this.polizasInfo.find(p => p.numeroPoliza === this.form.policy) || {}
        : {}

      let today = new Date()
      let currentDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2)
      let endosoHeader = {
        idProducto: transact === 'Eliminación de cobertura' ? polizaInfo.codigoProducto : '',
        PlanVida: transact === 'Eliminación de cobertura' ? polizaInfo.plan : '',
        interesado: 'digital',
        policyNumber: this.form.policy,
        FechaSolicitud: currentDate,
        ResponsableAtencion: 'SAC',
        TipoEndoso: 'Endoso Simple',
        InicioVigenciaEndoso: transact === 'Eliminación de cobertura' ? 'Default' : '',
        TipoVigenciaEndoso: '',
        Endoso: transact === 'Cambio Frecuencia de Pago' ? 'CambioFrecuenciaPago' : 'EliminacionCobAdicional',
        FechaMovimiento: transact === 'Cambio Frecuencia de Pago' ? this.form.new_endorsement_date : currentDate,
        FechaCliente: currentDate,
        FechaEfectiva: this.form.new_endorsement_date,
        ...(transact === 'Eliminación de cobertura' && { operacion: 'SolicitarEndoso' })
      }
      // MAKE JSON FOR ENDORSEMENT
      let hashEndoso = {
        transact,
        ENDOSO: endosoHeader,
        dynamicData: transact === 'Cambio Frecuencia de Pago' ? [
          {
            'etiqueta': 'FinancialPlan',
            'value': this.form.new_frequency
          }
        ] : [],
        COVERAGES: coverages,
        // Datos del formulario organizados en formData
        formData: {
          transact: transact,
          product: this.form.product,
          policy: this.form.policy,
          name: this.form.name,
          paternal_surname: this.form.paternal_surname,
          maternal_surname: this.form.maternal_surname,
          type_document: this.form.type_document,
          number_document: this.form.number_document,
          home_address: this.form.home_address,
          interior: this.form.interior,
          response_medium: this.form.response_medium,
          department: this.form.department,
          province: this.form.province,
          district: this.form.district,
          cellphone: this.form.cellphone,
          phone: this.form.phone,
          email: this.form.email,
          email_financial_advisor: this.form.email_financial_advisor,
          requisition_number: this.form.requisition_number,
          detail_transact: this.form.detail_transact,
          state: this.form.state,
          description_cancellation: this.form.description_cancellation,
          account_number: this.form.account_number,
          fullname_account_holder: this.form.fullname_account_holder,
          bank: this.form.bank,
          currency: this.form.currency,
          reason: this.form.reason,
          amount_endorse: this.form.amount_endorse,
          actual_frequency: this.form.actual_frequency,
          new_frequency: this.form.new_frequency,
          new_endorsement_date: this.form.new_endorsement_date,
          wildcard_fee_month: this.form.wildcard_fee_month,
          current_amount: this.form.current_amount,
          new_amount: this.form.new_amount,
          coberturas: this.form.coberturas,
          filenames: this.form.filenames,
          origen: 'ZONASEGURA'
        }
      }

      return hashEndoso
    },
    /**
     * Payload registrar-requerimiento para TES005 (cesión / endoso a entidad financiera), alineado a Nest/Java.
     */
    makeRequirementForCesionTerceros () {
      const polizaInfo = (this.polizasInfo && Array.isArray(this.polizasInfo))
        ? this.polizasInfo.find(p => p.numeroPoliza === this.form.policy) || {}
        : {}

      const today = new Date()
      const currentDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2)
      const rucCesionario = this.endosos.ruc === 'otros' ? this.endosos.otroRuc : this.endosos.ruc
      const banks = []
      if (this.endosos.entidad || rucCesionario || this.endosos.monto || this.form.bank) {
        banks.push({
          name: (this.form.bank.toUpperCase() || this.endosos.entidad || '').trim(),
          ruc: (rucCesionario || '').trim(),
          amount: (this.endosos.monto != null && this.endosos.monto !== '' ? String(this.endosos.monto) : (this.form.amount_endorse || '')).trim(),
          percentage: '',
          email: (this.form.email_financial_advisor || this.endosos.asesor || '').trim()
        })
      }

      const transact = this.form.transact
      const endosoHeader = {
        idProducto: polizaInfo.codigoProducto,
        PlanVida: polizaInfo.plan,
        interesado: 'digital',
        policyNumber: this.form.policy,
        FechaSolicitud: currentDate,
        ResponsableAtencion: 'SAC',
        TipoEndoso: 'Endoso Simple',
        InicioVigenciaEndoso: 'No Aplica',
        TipoVigenciaEndoso: '',
        Endoso: 'CesionTercero',
        FechaMovimiento: currentDate,
        FechaCliente: currentDate,
        FechaEfectiva: currentDate,
        moneda: this.form.currency || 'S/'
      }

      return {
        transact,
        ENDOSO: endosoHeader,
        dynamicData: [],
        COVERAGES: [],
        origen: 'ZONASEGURA',
        formData: {
          transact,
          product: this.form.product,
          policy: this.form.policy,
          name: this.form.name,
          paternal_surname: this.form.paternal_surname,
          maternal_surname: this.form.maternal_surname,
          type_document: this.form.type_document,
          number_document: this.form.number_document,
          home_address: this.form.home_address,
          interior: this.form.interior,
          response_medium: this.form.response_medium,
          department: this.form.department,
          province: this.form.province,
          district: this.form.district,
          cellphone: this.form.cellphone,
          phone: this.form.phone,
          email: this.form.email,
          email_financial_advisor: this.form.email_financial_advisor,
          requisition_number: this.form.requisition_number,
          detail_transact: this.form.detail_transact,
          state: this.form.state,
          description_cancellation: this.form.description_cancellation,
          account_number: this.form.account_number,
          fullname_account_holder: this.form.fullname_account_holder,
          bank: this.form.bank.toUpperCase(),
          currency: this.form.currency,
          reason: this.form.reason,
          amount_endorse: this.form.amount_endorse,
          actual_frequency: this.form.actual_frequency,
          new_frequency: this.form.new_frequency,
          new_endorsement_date: this.form.new_endorsement_date,
          wildcard_fee_month: this.form.wildcard_fee_month,
          current_amount: this.form.current_amount,
          new_amount: this.form.new_amount,
          coberturas: this.form.coberturas,
          filenames: this.form.filenames,
          banks,
          origen: 'ZONASEGURA'
        }
      }
    },
    // Método para procesar la solicitud de nuevo flujo endoso simple
    processTransactEndorsementRequirement () {
      let self = this
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.requestSent,
          {
            'Producto': this.form.product,
            'Poliza': this.form.policy,
            'Tipo de Solicitud': this.form.transact,
            'Motivo': ''
          }
        )
      // Configurar datos del formulario (asumiendo que las validaciones ya pasaron)
      this.loader = true
      this.form.home_address = '-'
      this.form.department = '-'
      this.form.province = '-'
      this.form.district = '-'
      this.form.response_medium = 'Electrónico'
      // Este bloque de código no es necesario para 'Cambio Frecuencia de Pago' y 'Eliminación de cobertura'
      // ya que este método solo se llama para estos dos tipos de transacción
      // El manejo de beneficiarios y modificación de cuenta se hace en otros métodos
      const eventData = {
        categoria: 'Funcionalidad',
        nombre: this.form.transact,
        datos: {
          request: this.form,
          numeroPoliza: this.form.policy
        }
      }
      // BEGIN PROCESS
      const polizaFind = self.polizasInfo.find(p => p.numeroPoliza === self.form.policy) || {}
      const metadata = {
        numeroPoliza: self.form.policy,
        productoConsultado: polizaFind.ramo || self.ramo
      }
      switch (metadata.productoConsultado) {
      case 'Vida':
        metadata.subproductoConsultado = polizaFind.nombreProducto
        break
      case 'RRVV':
        metadata.subproductoConsultado = polizaFind.codigoProducto
        break
      case 'Masivo':
        metadata.subproductoConsultado = polizaFind.producto
        break
      default:
        metadata.subproductoConsultado = polizaFind.nombreProducto
      }

      // NUEVO FLUJO: Solo para Cambio de frecuencia y Eliminación de cobertura
      let requestEndoso = null

      switch (self.form.transact) {
      case 'Cambio Frecuencia de Pago': {
        requestEndoso = self.makeRequirementForAcseleNew(self.form.transact, null)
        break
      }
      case 'Eliminación de cobertura': {
        const coverages = self.form.coberturas
        requestEndoso = self.makeRequirementForAcseleNew(self.form.transact, coverages)
        break
      }
      case 'Endoso a entidad financiera': {
        requestEndoso = self.makeRequirementForCesionTerceros()
        break
      }
      case 'Liberación de endoso': {
        // Para liberación de endoso no se necesita generar requestEndoso
        // ya que es un trámite que solo requiere adjuntar documentos
        requestEndoso = { transact: 'Liberación de endoso', skipEndoso: true }
        break
      }
      default: {
        // Enviar eventData
        eventData.datos.statusCode = 400
        eventData.datos.response = { error: 'Tipo de transacción no soportado' }
        eventData.datos.error = 'Transacción no soportada en nuevo flujo'
        self.eventLog(eventData).then(() => {}).catch(() => {})

        self.$swal({
          title: 'Error',
          text: 'Ocurrió un problema al procesar la solicitud. Por favor, inténtalo de nuevo.',
          imageUrl: require('./../assets/formpp/atencion-1.svg'),
          imageHeight: 180,
          imageWidth: 180,
          confirmButtonText: 'Entendido'
        })
        self.loader = false
        self.solicitudEnProceso = false
        return
      }
      }

      if (requestEndoso) {
        // Para liberación de endoso, no se necesita generar endoso
        if (requestEndoso.skipEndoso) {
          // Simular respuesta exitosa
          const mockResponse = {
            data: {
              codigoRespuesta: '01',
              idEnvio: 'Procesado exitosamente',
              requirementId: 'Liberación de endoso procesada'
            },
            status: 200
          }

          // Configurar evento de éxito
          let event = self.trackEvents.release.success
          event.producto = this.form.product

          // Registrar evento
          eventData.datos.statusCode = 200
          eventData.datos.response = mockResponse.data
          eventData.datos.requerimiento = 'Liberación de endoso procesada'
          self.eventLog(eventData).then(() => {}).catch(() => {})

          // Mostrar NPS
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Solicitud ' + self.form.transact,
            metadata
          })

          // Finalizar proceso
          self.loader = false
          self.solicitudEnProceso = false
          self.processFinished = true
          return
        }

        // PASO ÚNICO: El backend maneja validación, registro y endoso
        self.makeEndorsementRequirement(requestEndoso).then((response) => {
          console.log('response', response)
          // Manejo específico por código de respuesta
          switch(response.data.codigoRespuesta) {
            case '01':
              // Éxito - El backend ya registró el requerimiento y generó el endoso
              self.numCode = response.data.idEnvio || response.data.num_code || 'Procesado exitosamente';
              
              // Configurar evento de éxito
              let event = {}
              switch (self.form.transact) {
                case 'Cambio Frecuencia de Pago': {
                  event = self.trackEvents.frequency.success
                  break
                }
                case 'Eliminación de cobertura': {
                  event = self.trackEvents.coverages.success
                  break
                }
                case 'Endoso a entidad financiera': {
                  event = self.trackEvents.endorsements.success
                  break
                }
                case 'Liberación de endoso': {
                  event = self.trackEvents.release.success
                  break
                }
              }
              event.producto = this.form.product
              
              // Registrar evento
              eventData.datos.statusCode = response.status
              eventData.datos.response = response.data
              eventData.datos.requerimiento = response.data.requirementId || response.data.idEnvio
              self.eventLog(eventData).then(() => {}).catch(() => {})
              
              // Mostrar NPS
              self.$root.$emit('showNps', {
                nombre: 'NPS - Inicio de Encuesta',
                funcionalidad: 'Solicitud ' + self.form.transact,
                metadata
              })
              
              // Finalizar proceso
              self.loader = false
              self.processFinished = true
              self.solicitudEnProceso = false
              
              // REGISTER INTO GOOGLE TAG MANAGER
              self.$gtm.trackEvent({
                'event': 'virtualEvent',
                'category': 'Zona Segura',
                'action': 'Mis solicitudes - Paso 2 - Resumen de solicitud',
                'label': 'Seleccionar botón - Enviar solicitud'
              })
              break;
              
            case '98':
              // Requerimiento pendiente - validación falló
              self.$swal({
                title: '¡Lo sentimos!',
                text: 'Tienes un requerimiento pendiente.',
                imageUrl: require('./../assets/characters/sorprendido.svg'),
                imageHeight: 180,
                imageWidth: 180,
                confirmButtonText: 'Entendido'
              });
              
              // Enviar eventData
              eventData.datos.statusCode = response.status
              eventData.datos.response = response.data
              eventData.datos.error = 'Requerimiento pendiente'
              self.eventLog(eventData).then(() => {}).catch(() => {})
              
              self.loader = false
              self.solicitudEnProceso = false
              break;
              
            default:
              // Cualquier otro error
              self.$swal({
                title: 'Atención',
                text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
                imageUrl: require('./../assets/formpp/atencion-1.svg'),
                imageHeight: 180,
                imageWidth: 180,
                confirmButtonText: 'Entendido'
              });
              
              // Enviar eventData
              eventData.datos.statusCode = response.status
              eventData.datos.response = response.data
              eventData.datos.error = 'Código de respuesta no manejado'
              self.eventLog(eventData).then(() => {}).catch(() => {})
              
              self.loader = false
              self.solicitudEnProceso = false
              break;
          }
        }).catch((err) => {
          // Manejo de errores de red/excepción
          if(err.data && err.data.codigoRespuesta === '99') {
            // Verificar si el mensaje contiene "en proceso"
            const mensajeRespuesta = err.data.mensajeRespuesta || '';
            const contieneEnProceso = mensajeRespuesta.toLowerCase().includes('en proceso');
            
            if (contieneEnProceso) {
              // Enviar eventData
              eventData.datos.statusCode = err.status || 500
              eventData.datos.response = err.data || err
              eventData.datos.error = 'Solicitud de endoso en proceso'
              self.eventLog(eventData).then(() => {}).catch(() => {})
              
              self.$swal({
                title: '¡Atención!',
                text: 'Ya tienes una solicitud de endoso en proceso. Por favor, espera a que se complete antes de realizar una nueva solicitud.',
                imageUrl: require('@/assets/characters/informa.svg'),
                imageHeight: 180,
                imageWidth: 180,
                confirmButtonText: 'Entendido'
              });
            } else {
              // Enviar eventData
              eventData.datos.statusCode = err.status || 500
              eventData.datos.response = err.data || err
              eventData.datos.error = 'Error que requiere contacto'
              self.eventLog(eventData).then(() => {}).catch(() => {})
              
              self.$swal({
                title: '¡Atención!',
                html: 'No podemos procesar tu solicitud en este momento. Por favor, comunícate con nuestros canales de atención para ayudarte a finalizar este proceso.',
                imageUrl: require('@/assets/characters/informa.svg'),
                imageHeight: 180,
                imageWidth: 180,
                confirmButtonText: 'Conócelos aquí'
              }).then((result) => {
                if (result.isConfirmed) {
                  window.open('https://www.interseguro.pe/ayuda', '_blank');
                }
              });
            }
          } else {
            // Error de red o cualquier otro error
            // Enviar eventData
            eventData.datos.statusCode = err.status || 500
            eventData.datos.response = err.data || err
            eventData.datos.error = 'Error de red o conexión'
            self.eventLog(eventData).then(() => {}).catch(() => {})
            
            self.$swal({
              title: '¡Atención!',
              text: 'Tuvimos inconvenientes al enviar tu solicitud, revisa tu conexión a internet e inténtalo de nuevo.',
              imageUrl: require('./../assets/formpp/atencion-1.svg'),
              imageHeight: 180,
              imageWidth: 180,
              confirmButtonText: 'Entendido'
            });
          }
          self.loader = false
          self.solicitudEnProceso = false
        })
      } else {
        // Enviar eventData
        eventData.datos.statusCode = 400
        eventData.datos.response = { error: 'requestEndoso es null' }
        eventData.datos.error = 'No se pudo generar la solicitud de endoso'
        self.eventLog(eventData).then(() => {}).catch(() => {})
        
        self.$swal({
          title: 'Ocurrió un problema',
          text: 'No se pudo generar la solicitud de endoso. Por favor, inténtalo de nuevo.',
          imageUrl: require('./../assets/formpp/atencion-1.svg'),
          imageHeight: 180,
          imageWidth: 180,
          confirmButtonText: 'Entendido'
        })
        self.loader = false
        self.solicitudEnProceso = false
      }
    },
    // Método para generar el requestEndoso con la estructura específica para simulación
    makeSimulationRequest (coverages) {
      let self = this
      
      // Obtener la fecha actual en formato YYYY-MM-DD
      let today = new Date()
      let currentDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2)
      
      // Obtener información de la póliza
      const polizaInfo = self.polizasInfo.find(p => p.numeroPoliza === self.form.policy) || {}
      
      // Construir el objeto endoso que requiere el backend (misma estructura que makeRequirementForAcseleNew)
      const endosoHeader = {
        idProducto: polizaInfo.codigoProducto,
        PlanVida: polizaInfo.plan,
        interesado: 'digital',
        policyNumber: self.form.policy,
        FechaSolicitud: currentDate,
        ResponsableAtencion: 'SAC',
        TipoEndoso: 'Endoso Simple',
        InicioVigenciaEndoso: 'Default',
        TipoVigenciaEndoso: '',
        Endoso: 'EliminacionCobAdicional',
        FechaMovimiento: currentDate,
        FechaCliente: currentDate,
        FechaEfectiva: self.form.new_endorsement_date,
        operacion: 'SimularEndoso'
      }
      
      // Generar formData para tener acceso a formData.coberturas
      const formData = {
        transact: self.form.transact,
        product: self.form.product,
        policy: self.form.policy,
        name: self.form.name,
        paternal_surname: self.form.paternal_surname,
        maternal_surname: self.form.maternal_surname,
        type_document: self.form.type_document,
        number_document: self.form.number_document,
        home_address: self.form.home_address,
        interior: self.form.interior,
        response_medium: self.form.response_medium,
        department: self.form.department,
        province: self.form.province,
        district: self.form.district,
        cellphone: self.form.cellphone,
        phone: self.form.phone,
        email: self.form.email,
        email_financial_advisor: self.form.email_financial_advisor,
        requisition_number: self.form.requisition_number,
        detail_transact: self.form.detail_transact,
        state: self.form.state,
        description_cancellation: self.form.description_cancellation,
        account_number: self.form.account_number,
        fullname_account_holder: self.form.fullname_account_holder,
        bank: self.form.bank,
        currency: self.form.currency,
        reason: self.form.reason,
        amount_endorse: self.form.amount_endorse,
        actual_frequency: self.form.actual_frequency,
        new_frequency: self.form.new_frequency,
        new_endorsement_date: self.form.new_endorsement_date,
        wildcard_fee_month: self.form.wildcard_fee_month,
        current_amount: self.form.current_amount,
        new_amount: self.form.new_amount,
        coberturas: self.form.coberturas,
        filenames: self.form.filenames,
        origen: 'ZONASEGURA'
      }
      
      // Procesar las coberturas para el formato correcto de COVERAGES
      const coveragesArray = formData.coberturas.map(cobertura => ({
        COVCodigoCobertura: cobertura.codigoCobertura,
        COVDescCobertura: cobertura.nombre.toUpperCase(),
        COVEstado: cobertura.selected ? "Excluir" : "Vigente"
      }))
      
      // Construir el requestEndoso con la misma estructura que makeRequirementForAcseleNew
      let requestEndoso = {
        transact: self.form.transact,
        ENDOSO: endosoHeader,
        dynamicData: [],
        COVERAGES: coveragesArray,
        formData: formData
      }
      
      return requestEndoso
    },
    async calcularEndoso () {
      let self = this
      
      // Configurar eventData
      const eventData = {
        categoria: 'Funcionalidad',
        nombre: this.form.transact + ' - Simulación',
        datos: {
          request: this.form,
          numeroPoliza: this.form.policy,
          action: 'Calcular Endoso'
        }
      }
      
      // Activar loader en el botón Calcular
      self.calculatingEndoso = true
      
      // Obtener fecha efectiva
      try {
        // Obtener fecha actual en formato YYYY-MM-DD
        let today = new Date()
        let currentDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2)
        
        // Llamar al endpoint para obtener fecha efectiva
        const fechaData = await self.$store.dispatch('endorsements/obtenerFechaEfectiva', {
          tipoEndoso: 'EliminacionCobAdicional',
          numeroPoliza: self.form.policy,
          fechaSolicitud: currentDate
        })
        
        // Actualizar la fecha efectiva con la respuesta del endpoint
        if (fechaData.fechaEfectiva) {
          self.form.new_endorsement_date = fechaData.fechaEfectiva
        }
        
      } catch (error) {
        console.error('Error al obtener fecha efectiva:', error)
      }
      
      // Generar el requestEndoso para Eliminación de cobertura
      // Usar form.coberturas que ahora contiene todas las coberturas de la póliza
      const coverages = self.form.coberturas;
      
      // Verificar las coberturas seleccionadas
      if (coverages && coverages.length > 0) {
        const seleccionadas = coverages.filter(c => c.selected);
      }

      const requestEndoso = self.makeSimulationRequest(coverages)
      
      // Llamar al método de simulación con el requestEndoso generado
      self.simularEndosoMethod(requestEndoso)
      .then((response) => {
        
        try {
          // Parsear el mensajeRespuesta que viene como string JSON
          const mensajeData = JSON.parse(response.data.mensajeRespuesta)
          
          // Extraer el totalPremium del detalle
          if (mensajeData.data && mensajeData.data.detalle && mensajeData.data.detalle.length > 0) {
            const policyDataResult = mensajeData.data.detalle[0].policyDataResult
            if (policyDataResult && policyDataResult.totalPremium) {
              // Validar que totalPremium sea un número válido
              const totalPremiumValue = policyDataResult.totalPremium
              const isValidNumber = /^\d+(\.\d{1,2})?$/.test(totalPremiumValue.toString())
              
              if (isValidNumber) {
                self.form.new_amount = parseFloat(totalPremiumValue).toFixed(2)
                this.showButtonCalculate = false;
                this.showEmailAndConditions = true;
                
                // EventLog para caso de éxito
                eventData.datos.Estado = 'Éxito'
                eventData.datos.statusCode = response.status
                eventData.datos.response = response.data
                eventData.datos.totalPremium = policyDataResult.totalPremium
                eventData.datos.new_amount = self.form.new_amount
                self.eventLog(eventData).then(() => {}).catch(() => {})
                
              } else {
                console.error('totalPremium no tiene un formato válido:', totalPremiumValue)
                self.form.new_amount = '0.00'
                this.showButtonCalculate = true;
                this.showEmailAndConditions = false;
                
                // EventLog para caso de error - formato inválido
                eventData.datos.Estado = 'Error'
                eventData.datos.statusCode = response.status
                eventData.datos.response = response.data
                eventData.datos.error = 'totalPremium con formato inválido'
                eventData.datos.totalPremiumValue = totalPremiumValue
                self.eventLog(eventData).then(() => {}).catch(() => {})
              }
            } else {
              // EventLog para caso de error - no se encontró totalPremium
              eventData.datos.Estado = 'Error'
              eventData.datos.statusCode = response.status
              eventData.datos.response = response.data
              eventData.datos.error = 'No se encontró totalPremium en la respuesta'
              self.eventLog(eventData).then(() => {}).catch(() => {})
            }
          } else {
            // EventLog para caso de error - estructura inválida
            eventData.datos.Estado = 'Error'
            eventData.datos.statusCode = response.status
            eventData.datos.response = response.data
            eventData.datos.error = 'Estructura de respuesta no válida'
            self.eventLog(eventData).then(() => {}).catch(() => {})
          }
        } catch (error) {
          console.error('Error al parsear mensajeRespuesta:', error)
          
          // EventLog para caso de error - error de parsing
          eventData.datos.Estado = 'Error'
          eventData.datos.statusCode = 500
          eventData.datos.response = response.data
          eventData.datos.error = 'Error al parsear mensajeRespuesta: ' + error.message
          self.eventLog(eventData).then(() => {}).catch(() => {})
        }
        
        // Desactivar loader del botón Calcular
        self.calculatingEndoso = false
        
      })
      .catch((err) => {
        console.error('Error en el cálculo:', err)
        
        // EventLog para caso de error - error de red/conexión
        eventData.datos.Estado = 'Error'
        eventData.datos.statusCode = err.status || 500
        eventData.datos.response = err.data || err
        eventData.datos.error = 'Error en simulación'
        self.eventLog(eventData).then(() => {}).catch(() => {})
        
        // Desactivar loader del botón Calcular
        self.calculatingEndoso = false
        
        self.$swal({
          title: 'Error',
          text: 'Ocurrió un error al calcular el endoso. Por favor, inténtalo de nuevo.',
          imageUrl: require('./../assets/formpp/atencion-1.svg'),
          imageHeight: 180,
          imageWidth: 180,
          confirmButtonText: 'Entendido'
        })
      })
    },
    // Para formatear las coberturas en el formato requerido por el API
    formatCoberturasForAPI (listaCoberturas) {
      const resultado = listaCoberturas.map((cobertura) => ({
        COVCodigoCobertura: cobertura.codigoCobertura,
        COVDescCobertura: cobertura.nombre.toUpperCase(),
        COVEstado: cobertura.estado,
      }));
      return resultado
    },
    simularEndosoMethod (requestEndoso) {
      let self = this
      
      return new Promise((resolve, reject) => {
        self.simularEndoso(requestEndoso)
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            console.error('Error simularEndoso:', err)
            reject(err)
          })
      })
    },
    noMissingFormData () {
      return this.form.name &&
          this.form.paternal_surname &&
          this.form.maternal_surname &&
          this.form.type_document &&
          this.form.number_document &&
          this.form.email &&
          this.form.cellphone
    },
    uploadFile (evt) {
      if (evt.target.classList.contains('v-btn')) {
        evt.target.nextSibling.click()
      }
    },
    hidePreviewFile (evt) {
      if (evt.target.type !== 'button' && evt.target.className !== 'v-btn__content') {
        // WHEN USER CLICK ON ICON REMOVE, THEN PUT FLAG TO FALSE
        this.availableForUpload = false
        // CLASSES FOR HTML ELEMENTS
        evt.target.parentElement.parentElement.firstElementChild.classList.remove('hide')
        evt.target.parentElement.parentElement.firstElementChild.nextElementSibling.value = ''
        evt.target.parentElement.classList.add('hide')
        evt.target.parentElement.parentElement.parentElement.parentElement.classList.remove('uploaded')
      } else {
        evt.preventDefault()
      }
    },
    previewFile (evt) {
      let path = evt.path || (evt.composedPath && evt.composedPath())
      if (evt.target.files[0] !== null) {
        // WHEN USER UPLOAD FILE, THEN PUT FLAG TO TRUE
        this.availableForUpload = true
        // HIDE FIRST BTN
        evt.target.parentElement.firstElementChild.classList.add('hide')
        evt.target.parentElement.parentElement.parentElement.classList.add('uploaded')
        // SHOW BTN WITH NAME FILE
        let fileName = evt.target.files[0].name
        path[0].nextSibling.classList.remove('hide')
        if (path[0].nextSibling.children.length > 1) {
          path[0].nextSibling.children[1].remove()
        }
        let iconClose = document.createElement('i')
        // aria-hidden="true" class="v-icon v-icon--right material-icons theme--dark" style="color: #00ADEE"
        iconClose.setAttribute('aria-hidden', 'true')
        iconClose.classList.add('v-icon', 'v-icon--right', 'material-icons', 'theme--dark')
        iconClose.style = 'color: #00A9FF'
        iconClose.innerHTML = 'close'
        path[0].nextSibling.appendChild(iconClose)
        path[0].nextSibling.firstChild.innerHTML = fileName
        // path[0].nextSibling.firstChild.innerHTML = evt.target.files[0].name + '<i aria-hidden="true" class="v-icon v-icon--right material-icons theme--dark" align="right" style="color: #00ADEE; margin-right: -80px">cancel_circle</i>'
        let splitFileName = evt.target.getAttribute('id').split('_')
        if (splitFileName.length > 2) {
          let type = splitFileName[1]
          let inputFileId = splitFileName[2]
          const typesConf = [
            'renov',
            'benef',
            'rmvbenef'
          ]
          if (typesConf.indexOf(type) !== -1) {
            let fileUploadName = this.attachments.attachments.filter(function (a) { return a.id === inputFileId })[0].name
            const idx = this.beneficiario.files.findIndex((f) => f.name === fileUploadName)
            if (idx === -1) {
              this.beneficiario.files.push({
                'name': fileUploadName,
                'file': evt.target.files[0]
              })
            } else {
              this.beneficiario.files[idx].file = evt.target.files[0]
            }
          }
        } else {
          let inputFileId = splitFileName[1]
          let fileUploadName = this.attachments.attachments.filter(function (a) { return a.id === inputFileId })[0].name
          const idx = this.filesAttachments.findIndex((f) => f.name === fileUploadName)
          if (idx === -1) {
            this.filesAttachments.push({
              'name': fileUploadName,
              'file': evt.target.files[0]
            })
          } else {
            this.filesAttachments[idx].file = evt.target.files[0]
          }
        }
      } else {
        // HIDE BTN WITH NAME FILE
        path[0].nextSibling.classList.add('hide')
      }
    },
    removeFileEndorsementRelease (evt, index) {
      let array = []
      for (let i = 0; i < this.filesAttachments.length; i++) {
        if (i !== index) {
          array.push(this.filesAttachments[i])
        }
      }
      this.filesAttachments = array
      if (this.filesAttachments.length === 0) {
        this.availableForUpload = false
      }
    },
    uploadFileEndorsementRelease (evt) {
      let len = this.filesAttachments.length
      if (len < 2) {
        evt.target.nextSibling.click()
      } else {
        this.$swal({
          text: 'Solo puede adjuntar un máximo de 2 documentos',
          confirmButtonText: 'Entendido'
        })
      }
    },
    previewFileEndorsementRelease (evt) {
      // let len = this.filesAttachments.length
      const size5mb = 5242880
      let file = evt.target.files[0]
      evt.target.value = ''
      let ext = file.name.slice((file.name.lastIndexOf('.') - 1 >>> 0) + 2)
      if (!['pdf', 'png', 'jpg', 'jpeg'].includes(ext.toLowerCase())) {
        this.$swal({
          text: 'Tipo de archivo no permitido',
          confirmButtonText: 'Entendido'
        })
      } else if (file.size > size5mb) {
        this.$swal({
          text: 'El archivo no puede ser mayor a 5MB',
          confirmButtonText: 'Entendido'
        })
      } else {
        this.filesAttachments.push({
          'name': file + '_' + (new Date().toISOString()),
          'file': file
        })
      }
    },
    openDialogSendConstancy (evt) {
      evt.preventDefault()
      this.form.email_send_constancy = this.form.email
      this.dialogSendConstancy = true
    },
    sendConstancy () {
      let data = {
        'name': this.form.name,
        'num_req': this.numCode,
        'date_req': this.today,
        'product': this.form.product,
        'policy': this.form.policy,
        'transact': this.form.transact,
        'email': this.form.email_send_constancy
      }
      this.loader = true
      this.sendMailConstancy(data).then(res => {
        this.loader = false
        if (res.status === 200 && res.data.success) {
          this.dialogSendConstancy = false
          this.dialogConstancySent = true
        }
      })
        .catch(() => {
          this.loader = false
          this.$swal({
            title: 'Atención',
            text: 'Tuvimos inconvenientes al enviar su constancia via correo electrónico.',
            imageUrl: require('./../assets/formpp/atencion-1.svg'),
            imageHeight: 180,
            imageWidth: 180,
            confirmButtonText: 'INTENTAR DE NUEVO'
          })
        })
    },
    closeDailogSendConstancy () {
      this.dialogSendConstancy = false
      this.dialogConstancySent = false
      this.errors.email = []
    },
    openDialogBeneficiario () {
      document.querySelector('#dialog_beneficiario').setAttribute('data-mode', 'create')
      this.dialogBeneficiario = true
    },
    closeDialogBeneficiario () {
      this.cleanFormAddBeneficiario()
      let elementsCloseUploadFile = document.querySelectorAll('#dialog_beneficiario .previewFile i')
      elementsCloseUploadFile.forEach(element => {
        element.click()
      })
      this.dialogBeneficiario = false
    },
    openDialogRenovCertificado (benef) {
      this.beneficiario.dni = benef.num_identificacion
      this.beneficiario.fullName = benef.gls_beneficiario
      this.dialogRenovCertificado = true
    },
    closeDialogRenovCertificado () {
      this.cleanFormAddBeneficiario()
      let elementsCloseUploadFile = document.querySelectorAll('#dialog_renovarcertificado .previewFile i')
      elementsCloseUploadFile.forEach(element => {
        element.click()
      })
      this.dialogRenovCertificado = false
    },
    isDisabledBtnSendSolicitud () {
      let form = this.form
      if (this.solicitudEnProceso === true) {
        return true
      }
      // SI ES ENDOSOS - VALIDA CAMPOS ANTES DE PASAR
      if (this.codeGTM === transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA) {
        return !this.isEndosoBancarioFormValid()
      } else if (this.codeGTM === transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO) {
        return !(this.form.new_frequency && this.declaracion)
      } else if (this.codeGTM === transacts.codesGTM.CUOTA_COMODIN) {
        return !(this.form.wildcard_fee_month)
      } else if (this.codeGTM === transacts.codesGTM.LIBERACION_ENDOSO) {
        return !(this.filesAttachments.length > 0)
      } else if (this.codeGTM === transacts.codesGTM.RETIRO_COBERTURAS) {
        return !(this.form.new_amount && this.declaracion)
      } else {
        return !(form.product && form.policy && form.transact &&
                (!this.showReason || (this.showReason && form.description_cancellation)) &&
                (!this.showRelationShip || (this.showRelationShip && form.relationship)) &&
                (!this.showBeneficiarios || (this.showBeneficiarios && this.beneficiariosAdd.length > 0)) &&
                (!this.showRenovacionCertificados || (this.showRenovacionCertificados && this.beneficiariosAdd.length > 0)) &&
                (!this.showRemoveBeneficiarios || (this.showRemoveBeneficiarios && this.beneficiariosAdd.length > 0)) &&
                (!this.showModificarNroCuenta || (this.showModificarNroCuenta && this.validateModNroDCuenta())) &&
                form.email &&
                this.filesUploadesSuccessfully())
      }
    },
    validateModNroDCuenta () {
      return this.dataNroCuenta.entidad !== null &&
          this.dataNroCuenta.tipoCuenta !== null &&
          this.dataNroCuenta.tipoMoneda !== null &&
          this.dataNroCuenta.nroCuenta !== null
    },
    openDialogRemoveBeneficiario (benef) {
      this.beneficiario.dni = benef.num_identificacion
      this.beneficiario.fullName = benef.gls_beneficiario
      this.dialogRemoveBeneficiario = true
    },
    closeDialogRemoveBeneficiario () {
      this.cleanFormAddBeneficiario()
      this.changeReasonRemovebenef(null)
      this.changeLabel('reason_removebenef')
      let elementsCloseUploadFile = document.querySelectorAll('#dialog_removebeneficiario .previewFile i')
      elementsCloseUploadFile.forEach(element => {
        element.click()
      })
      this.dialogRemoveBeneficiario = false
    },
    openDialogListaSolicitudes () {
      this.dialogListaSolicitudes = true
    },
    closeDialogListaSolicitudes () {
      this.dialogListaSolicitudes = false
      this.transact = []
    },
    goProfile () {
      var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
      for (var i = 0; i < allElements.length; i++) {
        allElements[i].classList.remove('active-menu')
      }
      var el = allElements[1] // MI PERFIL
      el.classList.add('active-menu')
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          'Funcionalidad Seleccionada',
          {
            'Funcionalidad': 'Mis Datos'
          }
        )
      // FOR AVOID ERROR IN REDUDANT PATH
      if (this.$route.path !== '/mi-perfil') { this.$router.push('/mi-perfil') }
    },
    validateProduct () {
      if (this.products !== null && this.products.length > 0) {
        if (this.products.length === 1) {
          this.form.product = this.products[0]
          this.showFilterTipoSolicitud(this.form.product)
          // console.log(this.justOneProduct)
          this.justOneProduct = true
          return
        }
      }
      this.justOneProduct = false
    },
    showFilterTipoSolicitud (product) {
      let polizaProduct = this.polizasInfo.filter((p) => p.producto === product)[0]
      this.transact = []
      if (polizaProduct.ramo === 'Vida') {
        this.transact = this.transact.concat(transacts.vida)
        // REMOVIENDO ANULACION DE POLIZA PARA LAS DEMAS POLIZAS VIDA, A EXCEPCION DE CASH
        if (product !== 'Vida Cash') {
          let indexAnulacion = this.transact.indexOf('Anulación de póliza')
          this.transact.splice(indexAnulacion, 1)
        }
      } else if (polizaProduct.codigoProducto === 'RRVV') {
        if (polizaProduct.tipoPension !== null && (polizaProduct.tipoPension.toUpperCase().indexOf('JUBILACION') !== -1 ||
            polizaProduct.tipoPension.toUpperCase().indexOf('JUBILACIÓN') !== -1)) {
          this.transact = this.transact.concat(transacts.rentas)
        } else {
          this.transact = this.transact.concat(transacts.RentasInvSob)
        }
      } else if (polizaProduct.ramo === 'Masivo') {
        if (product === 'Seguro Vehicular' || product === 'SOAT') {
          this.transact = this.transact.concat(transacts.masivos)
        }
      } else {
        this.transact = this.transact.concat(transacts.RentasRPP)
      }
    },
    isViewProductSelected () {
      let isViewDesktop = window.innerWidth >= 1200
      let isShow = this.form.product !== null && this.form.policy !== null && this.form.transact !== null
      this.isViewProductSelectedDesktop = (isViewDesktop && isShow)
    },
    changeViewForDesktop () {
      this.isViewProductSelected()
      /*
       * NO ENTIENDO PORQUE HACE ESTO O AL MENOS NO HACERLO ASI
       * SOLO SEGUIR CON ESTA LOGICA HASTA REMODELAR ESTA PAGINA
       * */
      let elemViewProd = document.getElementById('view_myproduct')
      let elemFormConstancy = document.getElementById('view_form_constancy')
      let columnAdditional = document.getElementById('column_additional')
      if (this.isViewProductSelectedDesktop) {
        if (elemViewProd !== null) {
          // FOR MEDIUM AND UP DESKTOP
          elemViewProd.classList.remove('lg4')
          elemViewProd.classList.add('lg6')
          // FOR MEDIUM AND DOWN DESKTOP
          elemViewProd.classList.remove('md4')
          elemViewProd.classList.add('md6')
        }
        if (elemFormConstancy !== null) {
          // FOR MEDIUM AND UP DESKTOP
          elemFormConstancy.classList.remove('lg4')
          elemFormConstancy.classList.add('lg6')
          // FOR MEDIUM AND DOWN DESKTOP
          elemFormConstancy.classList.remove('md4')
          elemFormConstancy.classList.add('md6')
        }
        if (columnAdditional !== null) {
          columnAdditional.classList.remove('lg4')
          columnAdditional.classList.add('lg0')
        }
      } else {
        if (elemViewProd !== null) {
          elemViewProd.classList.remove('lg6')
          elemViewProd.classList.add('lg4')
        }
        if (elemFormConstancy !== null) {
          elemFormConstancy.classList.remove('lg6')
          elemFormConstancy.classList.add('lg4')
        }
        if (columnAdditional !== null) {
          columnAdditional.classList.remove('lg0')
          columnAdditional.classList.add('lg4')
        }
      }
      let self = this
      setTimeout(function () {
        self.changeLabel('product')
        self.changeLabel('poliza')
        self.changeLabel('reason')
      }, 200)
    },
    myProductEdit () {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.editionRequest,
          {
            'Producto': this.form.product,
            'Poliza': this.form.policy,
            'Tipo de Solicitud': this.form.transact
          }
        )
      this.showAnulacionFields = false
      // #004.32: Elemento - Botón Editar
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis solicitudes - Paso 1 - Mi producto',
        'label': 'Seleccionar botón - Editar'
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis solicitudes - Paso 1 - Mi producto',
        'CTA': 'Seleccionar botón - Editar'
      })

      this.isViewProductSelectedDesktop = false
      this.form.transact = null
      this.codeGTM = null
      this.afterSelectTransact()
      this.changeViewForDesktop()
    },
    goToTransact (keyGTM) {
      // this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: keyGTM, seguroPolicy: policy } })
      this.dialogCancellation = false
      switch (keyGTM) {
      case transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA:
        this.codeGTM = transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA
        this.form.transact = 'Endoso a entidad financiera'
        break

      case transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO:
        this.codeGTM = transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO
        this.form.transact = 'Cambio Frecuencia de Pago'
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.CUOTA_COMODIN:
        this.codeGTM = transacts.codesGTM.CUOTA_COMODIN
        this.form.transact = 'Cuota comodín'
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.LIBERACION_ENDOSO:
        this.codeGTM = transacts.codesGTM.LIBERACION_ENDOSO
        this.form.transact = 'Liberación de endoso'
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.ANULACION_POLIZA:
        this.dialogCancellation = true
        this.codeGTM = transacts.codesGTM.ANULACION_POLIZA
        this.form.transact = 'Anulación de póliza'
        
        // Redirigir a vista específica para SOAT
        if (this.form.product === 'SOAT') {
          this.$router.push({
            name: 'FormalitiesSOATCancellation',
            params: {
              policy: this.form.policy,
              product: this.form.product
            }
          })
          return
        }
        
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.RETIRO_COBERTURAS:
        this.dialogCancellation = true
        this.codeGTM = transacts.codesGTM.RETIRO_COBERTURAS
        this.form.transact = 'Eliminación de cobertura'
        this.changeViewForDesktop()
        break

      default:
        break
      }
    },
    afterSelectTransact () {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.requestAttempt,
          {
            'Producto': this.form.product,
            'Poliza': this.form.policy,
            'Tipo de Solicitud': this.form.transact
          }
        )
      // show FileAttachments
      let self = this
      if (this.codeGTM === null || this.codeGTM === '') {
        this.resetShowElements()
        return
      }

      if (this.codeGTM === transacts.codesGTM.ANULACION_POLIZA) { // Anulacion de poliza
        // Redirigir a vista específica para SOAT
        if (this.form.product === 'SOAT') {
          this.$router.push({
            name: 'FormalitiesSOATCancellation',
            params: {
              policy: this.form.policy,
              product: this.form.product
            }
          })
          return
        }
        
        // reasons Anulacion Poliza
        this.reasons = [
          'Viaje fuera del país',
          'No satisface mis necesidades',
          'Problemas para seguir pagando',
          'Cobros indebidos',
          'Falta de comunicación de la CIA y de mi agente',
          'Otros'
        ]
        this.showReason = false
        this.showAnulacionFields = true
        this.showFileAttachments = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
        this.endososIsActivated = false
        this.wildcardFeeIsActivated = false
        this.endorsementReleaseIsActivated = false
        this.showReleaseFileAttachments = false
        this.changeFrecuencyIsActivated = false
        this.deleteCoverageIsActivated = false
        this.dialogCancellation = true
        this.reqAvailables = []
        for (let requirement of this.transact) {
          let keyGTM = ''
          switch (requirement) {
          case 'Cuota comodín':
            keyGTM = transacts.codesGTM.CUOTA_COMODIN
            break
          case 'Liberación de endoso':
            keyGTM = transacts.codesGTM.LIBERACION_ENDOSO
            break
          case 'Endoso a entidad financiera':
            keyGTM = transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA
            break
          case 'Cambio Frecuencia de Pago':
            keyGTM = transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO
            break
          case 'Eliminación de cobertura':
            keyGTM = transacts.codesGTM.RETIRO_COBERTURAS
            break
          default:
            continue
          }
          this.reqAvailables.push({key: keyGTM, name: requirement, message: this.requirementsData[keyGTM]})
        }
      } else if (this.codeGTM === transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA) {
        // - [CASO PARA ENDOSOS]
        this.loader = true
        this.textLoader = 'Corroborando información...'
        let poliza = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
        this.form.currency = (poliza[0] && poliza[0].primaProgramadaMoneda.toLowerCase() !== 'nuevo sol') ? '$' : 'S/'
        this.trackEvents.endorsements.access.producto = this.form.product
        // this.$gtm.trackEvent(this.trackEvents.endorsements.access)
        this.checkIfPolicyHasPendingOkEndoso({ numeroPoliza: this.form.policy })
          .then((res) => {
            // SI NO TIENE ALGUN ENDOSO PENDIENTE EN APROBAR
            if (res.data.data.length < 1) {
              this.getMaxAmountEndorse({ numeroPoliza: this.form.policy })
                .then((res) => {
                  this.loader = false
                  this.textLoader = 'Procesando trámite...'
                  // SI TIENE UN MONTO A CESIONAR MAYOR A 0
                  if (res.data.maximaCesion > 0) {
                    this.changeViewForDesktop()
                    this.endosos.montoMaximo = res.data.maximaCesion
                    this.endososIsActivated = true
                    this.wildcardFeeIsActivated = false
                    this.changeFrecuencyIsActivated = false
                    this.endorsementReleaseIsActivated = false
                    this.deleteCoverageIsActivated = false
                    this.showReason = false
                    this.dialogEndorsements = true
                    this.showEmailAndConditions = true
                  } else {
                    this.$swal({
                      title: 'Atención',
                      html: 'No puede endosar tu póliza porque no tiene monto disponible a endosar. Para mayor información, por favor comunícate por nuestro <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aqui</a>.',
                      confirmButtonText: 'Entendido'
                    })
                  }
                })
                .catch(() => {
                  this.loader = false
                  this.textLoader = 'Procesando trámite...'
                })
              /*
              this.getPolicyDataPerEndoso({ numeroPoliza: this.form.policy })
                .then((res) => {
                  // SI TIENE DATA PARA VERIFICAR SI ES CESIONABLE O NO
                  if (res.data !== '') {
                    // SI TIENE INFO DE PAGADO HASTA O NO. IGUAL LE DAMOS VALORES.
                    let pagadoHasta = res.data.fecha_PAGADO_HASTA === '' ? moment() : moment(res.data.fecha_PAGADO_HASTA)
                    let now = moment()
                    // VERIFICAR SI ESTA AL DIA EN SUS PAGOS
                    if (pagadoHasta.isSameOrAfter(now)) {
                      // VERIFICAR SI TIENE ALGUNA CESION O NO
                      if (res.data.flag_CESIONADA === '' || res.data.flag_CESIONADA === 'No') {
                        this.getMaxAmountEndorse({ numeroPoliza: this.form.policy })
                          .then((res) => {
                            this.loader = false
                            this.textLoader = 'Procesando trámite...'
                            // SI TIENE UN MONTO A CESIONAR MAYOR A 0
                            if (res.data.maximaCesion > 0) {
                              this.changeViewForDesktop()
                              this.endosos.montoMaximo = res.data.maximaCesion
                              this.endososIsActivated = true
                              this.wildcardFeeIsActivated = false
                              this.changeFrecuencyIsActivated = false
                              this.endorsementReleaseIsActivated = false
                              this.showReason = false
                              this.dialogEndorsements = true
                              this.showEmailAndConditions = true
                            } else {
                              this.$swal({
                                title: 'Atención',
                                html: 'No puede endosar su póliza porque no tiene monto disponible a endosar. Para mayor información, por favor comunícate por nuestro <a href="links.WhatsApp" target="_blank" class="omnesMedium">chat web</a>.',
                                confirmButtonText: 'Entendido'
                              })
                            }
                          })
                          .catch(() => {
                            this.loader = false
                            this.textLoader = 'Procesando trámite...'
                          })
                      } else {
                        this.loader = false
                        this.textLoader = 'Procesando trámite...'
                        this.$swal({
                          title: 'Atención',
                          html: 'No puedes endosar tu póliza porque ya cuentas con un endoso sobre esta. Por favor, inténtalo con otra póliza o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                          confirmButtonText: 'Entendido'
                        })
                      }
                    } else {
                      this.loader = false
                      this.textLoader = 'Procesando trámite...'
                      this.$swal({
                        title: 'Atención',
                        html: 'No puedes endosar la póliza seleccionada porque no estás al día en tus pagos. Para mayor información, comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                        confirmButtonText: 'Entendido'
                      })
                    }
                  } else {
                    this.loader = false
                    this.textLoader = 'Procesando trámite...'
                    this.$swal({
                      title: 'Atención',
                      html: 'No puedes realizar un endoso porque no podemos extraer la información necesaria para ellos en estos momentos. Vuelve a intentarlo en unos minutos o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                      confirmButtonText: 'Entendido'
                    })
                  }
                })
                .catch(() => {
                  self.trackEvents.endorsements.error.producto = this.form.product
                  self.$gtm.trackEvent(this.trackEvents.endorsements.error)
                  this.loader = false
                  this.textLoader = 'Procesando trámite...'
                })
                */
            } else {
              self.trackEvents.endorsements.pending.producto = this.form.product
              // self.$gtm.trackEvent(this.trackEvents.endorsements.pending)
              this.loader = false
              this.textLoader = 'Procesando trámite...'
              this.$swal({
                title: 'Atención',
                html: 'No puedes endosar tu póliza porque ya cuentas con una solicitud pendiente. Por favor, vuelve a intentarlo con otra póliza o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                confirmButtonText: 'Entendido'
              })
            }
          })
          .catch((err) => { console.log('err: ', err) })
      } else if (this.codeGTM === transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO) {
        let poliza = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
        this.form.currency = (poliza[0] && poliza[0].primaProgramadaMoneda.toLowerCase() !== 'nuevo sol') ? '$' : 'S/'
        this.changeFrecuencyIsActivated = true
        this.wildcardFeeIsActivated = false
        this.deleteCoverageIsActivated = false
        this.endososIsActivated = false
        this.showEmailAndConditions = true
        this.dialogChangeFrecuency = true
        this.showReason = false
        this.endorsementReleaseIsActivated = false
        this.showReleaseFileAttachments = false
        this.frecuencias.montoActual = parseFloat(poliza[0].primaProgramada).toFixed(2)
        this.frecuencias.frecuenciaActual = poliza[0].frecuenciaPago.charAt(0).toUpperCase() + poliza[0].frecuenciaPago.slice(1).toLowerCase()
        this.form.actual_frequency = poliza[0].frecuenciaPago
        this.loader = true
        this.trackEvents.frequency.access.producto = this.form.product

        // this.$gtm.trackEvent(this.trackEvents.frequency.access)
        this.textLoader = 'Corroborando información...'
        this.getFrequency({numeroPoliza: poliza[0].numeroPoliza})
          .then((res) => {
            this.loader = false
            this.textLoader = 'Procesando trámite...'
            //- CAMBIO DE FRECUENCIA DE PAGO:
            if (res.data.mensual || res.data.trimestral || res.data.semestral || res.data.anual) {
              if (poliza[0].frecuenciaPago !== 'Mensual') {
                self.frecuencias.mensual = res.data.mensual
              }
              if (poliza[0].frecuenciaPago !== 'Trimestral') {
                self.frecuencias.trimestral = res.data.trimestral
              }
              if (poliza[0].frecuenciaPago !== 'Semestral') {
                self.frecuencias.semestral = res.data.semestral
              }
              if (poliza[0].frecuenciaPago !== 'Anual') {
                self.frecuencias.anual = res.data.anual
              }
            } else {
              self.trackEvents.frequency.reject.producto = this.form.product
              // self.$gtm.trackEvent(this.trackEvents.frequency.reject)
              self.$swal({
                title: '¡Parece que algo salió mal!',
                html: 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                imageUrl: require('@/assets/characters/oops.svg'),
                confirmButtonText: 'Entendido'
              }).then(() => {
                self.$router.push('/inicio')
              })
            }
          })
          .catch(() => {
            self.loader = false
            self.textLoader = 'Procesando trámite...'
            self.trackEvents.frequency.error.producto = this.form.product
            // self.$gtm.trackEvent(this.trackEvents.frequency.error)
            self.$swal({
              title: '¡Parece que algo salió mal!',
              html: 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
              imageUrl: require('@/assets/characters/oops.svg'),
              confirmButtonText: 'Entendido'
            }).then((result) => {
              self.$router.push('/inicio')
            })
          })
      } else if (this.codeGTM === transacts.codesGTM.CUOTA_COMODIN) {
        let poliza = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
        if (poliza.length < 1) {
          self.$swal({
            title: '¡Lo sentimos!',
            text: 'Hemos tenido un inconveniente en estos momentos. Por favor, te pedimos volver a intentarlo.',
            imageUrl: require('@/assets/characters/sorprendido.svg'),
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.$router.push('/inicio')
          })
        }
        this.form.currency = (poliza[0] && poliza[0].primaProgramadaMoneda.toLowerCase() !== 'nuevo sol') ? '$' : 'S/'
        this.changeFrecuencyIsActivated = false
        this.endososIsActivated = false
        this.deleteCoverageIsActivated = false
        this.showReason = false
        this.endorsementReleaseIsActivated = false
        this.showReleaseFileAttachments = false
        this.showEmailAndConditions = true
        this.loader = true
        this.textLoader = 'Corroborando información...'
        let wildcardsFeeRes
        this.trackEvents.wildcard.access.producto = this.form.product
        // this.$gtm.trackEvent(this.trackEvents.wildcard.access)
        this.getWildcardFees({numeroPoliza: poliza[0].numeroPoliza})
          .then((res) => {
            let all = res.data.cuota_COMODIN
            this.wildcardFeesTotal = res.data.cuota_COMODIN.length
            wildcardsFeeRes = all.filter(cuota => cuota.tipo_PROGRAMACION === '1')
            if (all.length > 0) {
              this.wildcardFeeIsActivated = true
              this.dialogWildcardFee = true
              this.wildcardFeesUsed = wildcardsFeeRes
              if (wildcardsFeeRes.length > 0) {
                const max = wildcardsFeeRes.reduce(function (prev, current) {
                  return (prev.fecha_PROGRAMADA > current.fecha_PROGRAMADA) ? prev : current
                })
                this.mesesComodin = this.getWildcardMonths(max.fecha_PROGRAMADA)
              } else {
                this.mesesComodin = this.getWildcardMonths('')
              }
            } else {
              self.trackEvents.wildcard.reject.producto = this.form.product
              // self.$gtm.trackEvent(this.trackEvents.wildcard.reject)
              self.$swal({
                title: '¡Lo sentimos!',
                html: 'No posees el beneficio de cuota comodín o no tienes cuotas disponibles. Para mayor información, comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                imageUrl: require('@/assets/characters/sorprendido.svg'),
                confirmButtonText: 'Entendido'
              }).then(() => {
                self.$router.push('/inicio')
              })
            }
            self.loader = false
          })
          .catch(() => {
            self.trackEvents.wildcard.error.producto = this.form.product
            // self.$gtm.trackEvent(this.trackEvents.wildcard.error)
            self.$swal({
              title: '¡Oops, algo salió mal!',
              html: 'Inténtalo más tarde o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
              imageUrl: require('@/assets/characters/oops.svg'),
              confirmButtonText: 'Entendido'
            }).then(() => {
              self.$router.push('/inicio')
            })
          })
        self.loader = true
      } else if (this.codeGTM === transacts.codesGTM.LIBERACION_ENDOSO) {
        this.changeFrecuencyIsActivated = false
        this.deleteCoverageIsActivated = false
        this.filesAttachments = []
        this.endososIsActivated = false
        this.wildcardFeeIsActivated = false
        this.showReason = false
        this.showEmailAndConditions = true
        this.dialogEndorsementRelease = true
        this.endorsementReleaseIsActivated = true
        this.showReleaseFileAttachments = true
        this.trackEvents.release.access.producto = this.form.product
        // this.$gtm.trackEvent(this.trackEvents.release.access)
        // this.loader = true
        // this.textLoader = 'Corroborando información...
      } else if (this.codeGTM === transacts.codesGTM.AVISO_FALLEC) { // Aviso de fallecimiento
        this.fileAttachment.title = 'Acta de defunción del Beneficiario'
        this.showFileAttachments = true
        this.showReason = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
      } else if (this.codeGTM === transacts.codesGTM.BAJA_BENEF_ESSALUD) { // Baja beneficiario essalud
        // reasons Anulacion Poliza
        this.reasons = [
          'Fallecimiento',
          'Divorcio'
        ]
        this.showReason = true
        this.showFileAttachments = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
      } else if (this.codeGTM === transacts.codesGTM.ALTA_BENEF_ESSALUD) { // alta beneficiario essalud
        this.fileAttachment.title = 'DNI del beneficiario'
        this.showFileAttachments = true
        this.fileAttachment2.title = 'Documentos adicionales'
        this.showFileAttachments2 = true
        this.showReason = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRelationShip = true
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
        this.changeRelationship()
      } else if (this.codeGTM === transacts.codesGTM.INCLUSION_BENEF) {
        this.showReason = false
        this.showFileAttachments = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
        this.getBeneficiariosInclusionBenef()
      } else if (this.codeGTM === transacts.codesGTM.EXCLUSION_BENEF) {
        this.showReason = false
        this.showFileAttachments = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
        this.getBeneficiariosExclusionBenef()
      } else if (this.codeGTM === transacts.codesGTM.RENOV_CERTIF) {
        this.showReason = false
        this.showFileAttachments = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = true
        this.showModificarNroCuenta = false
        this.showEmailAndConditions = true
        this.getBeneficiariosRenovacionCertificado()
      } else if (this.codeGTM === transacts.codesGTM.MODIF_NUM_CUENTA) {
        this.showReason = false
        this.showFileAttachments = false
        this.showFileAttachments2 = false
        this.showRelationShip = false
        this.showImportantMessageRelationShip = false
        this.showBeneficiarios = false
        this.showRemoveBeneficiarios = false
        this.showRenovacionCertificados = false
        this.showModificarNroCuenta = true
        this.showEmailAndConditions = true
        this.setEntidadesBancarias()
      } else if (this.codeGTM === transacts.codesGTM.RETIRO_COBERTURAS) {
        // ELIMINACIÓN DE COBERTURAS:
        this.deleteCoverageIsActivated = true
        this.showEmailAndConditions = false
        let poliza = this.polizasInfo.filter((v) => { return v.numeroPoliza === this.form.policy })
        this.form.currency = (poliza[0] && poliza[0].primaProgramadaMoneda.toLowerCase() !== 'nuevo sol') ? '$' : 'S/'
        this.form.current_amount = parseFloat(poliza[0].primaProgramada).toFixed(2)
        
        if (poliza[0].ramo.toUpperCase() === "VIDA") {
          this.coberturas = poliza[0].coberturasVida;
          
          // Poblar form.coberturas con todas las coberturas de la póliza para "Eliminación de cobertura"
          this.form.coberturas = this.coberturas.map(cobertura => ({
            ...cobertura,
            nombre: cobertura.nombre.charAt(0).toUpperCase() + cobertura.nombre.slice(1).toLowerCase(),
            selected: false // Inicialmente ninguna cobertura está seleccionada para eliminar
          }));
          
          this.coberturasAdicionales = this.coberturas
            .filter(cobertura => {
              const isExcludedByProduct = (poliza[0].nombreProducto === "PLANGARANTIZADO" || poliza[0].nombreProducto === "EDUCGARANTIZADAPLUSNEW") 
                && cobertura.nombre.toUpperCase() === "EXONERAC PAGO PRIMA INV TOTAL Y PERM POR ACC O ENF";
              return cobertura.tipo === "ADICIONAL" 
                && cobertura.nombre.toUpperCase() !== "FONDO UNIVERSITARIO" 
                && cobertura.nombre.toUpperCase() !== "SOBREVIVENCIA"
                && !isExcludedByProduct;
            })
            .map(cobertura => ({
            ...cobertura,
            nombre: cobertura.nombre.charAt(0).toUpperCase() + cobertura.nombre.slice(1).toLowerCase(),
            montoCobertura: cobertura.montoCobertura.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }));

          // Limpiar coberturas seleccionadas
          this.coberturasAdicionales.forEach(cobertura => {
            cobertura.selected = false;
          });

          // Mostrar popups iniciales de eliminación de coberturas
          this.flagPopupAlert = true
          this.infoPopup.img = this.endorsementReleaseInfo.logo
          this.infoPopup.title = 'Aviso importante'
          this.infoPopup.message = parseFloat(poliza[0].porcentajeDevolucion) > 0
            ? `<p>Al eliminar una cobertura en tu póliza:</p>
              <ul>
                <li>La prima pagada y el monto de devolución son recalculados</li>
                <li>Ten en cuenta que no podrás agregarla nuevamente en el futuro.</li>
                <li>El porcentaje de devolución que contrataste no cambia.</li>
              </ul>`
            : `<p>Al eliminar una cobertura en tu póliza:</p>
              <ul>
                <li>La prima pagada es recalculada.</li>
                <li>Ten en cuenta que no podrás agregarla nuevamente en el futuro.</li>
              </ul>`
          this.infoPopup.messageButton = 'Entendido'
        }
        
      }
      this.beneficiariosAdd = []
      this.showImportantMessageRelationShip = false
    },
    resetShowElements () {
      this.showFileAttachments = false
      this.showReason = false
      this.showFileAttachments2 = false
      this.showRelationShip = false
      this.showEmailAndConditions = false
      this.showImportantMessageRelationShip = false
      this.showBeneficiarios = false
      this.showRemoveBeneficiarios = false
      this.showRenovacionCertificados = false
      this.endososIsActivated = false
      this.wildcardFeeIsActivated = false
      this.changeFrecuencyIsActivated = false
      this.endorsementReleaseIsActivated = false
      this.deleteCoverageIsActivated = false
    },
    launchSendSMS (callback) {
      this.loader = true
      const data = {
        userCode: this.userInfo.codigoUsuario,
        phoneNumber: this.form.cellphone
      }
      this.sendSMSValidationPhone(data).then(res => {
        this.loader = false
        if (res.status === 200 && res.data.codigoRespuesta === '01') {
          callback()
        }
      })
        .catch(() => {
          this.loader = false
          this.$swal({
            title: 'Atención',
            text: 'Tuvimos inconvenientes al enviar el código de validacion via SMS.',
            imageUrl: require('./../assets/formpp/atencion-1.svg'),
            imageHeight: 180,
            imageWidth: 180,
            confirmButtonText: 'Intentar de nuevo'
          })
        })
    },
    onResize () {
      this.changeViewForDesktop()
    },
    isNumber: function (evt) {
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isDigitsOnly (evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
        return false
      }
      return true
    },
    isEmailChar (evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode <= 31) {
        return true
      }
      const char = String.fromCharCode(charCode)
      if (EMAIL_CHAR_REGEX.test(char)) {
        return true
      }
      evt.preventDefault()
      return false
    },
    onEmailInput () {
      const sanitized = sanitizeEmailInput(this.form.email)
      if (sanitized !== this.form.email) {
        this.form.email = sanitized
      }
      this.emailErrorsValidate()
    },
    onEmailPaste (evt) {
      evt.preventDefault()
      const clipboardData = evt.clipboardData || window.clipboardData
      const pasted = clipboardData ? clipboardData.getData('text') : ''
      this.form.email = sanitizeEmailInput(pasted)
      this.emailErrorsValidate()
    },
    isBankEntityChar (evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode <= 31) {
        return true
      }
      const char = String.fromCharCode(charCode)
      if (/[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ0-9\s.&'-]/.test(char)) {
        return true
      }
      evt.preventDefault()
      return false
    },
    onBankEntityPaste (evt) {
      evt.preventDefault()
      const clipboardData = evt.clipboardData || window.clipboardData
      const pasted = clipboardData ? clipboardData.getData('text') : ''
      this.endosos.entidad = sanitizeBankEntityName(pasted)
      this.endososEntidadErrorsValidate()
    },
    onBankEntityInput () {
      const sanitized = sanitizeBankEntityName(this.endosos.entidad)
      if (sanitized !== this.endosos.entidad) {
        this.endosos.entidad = sanitized
      }
      this.endososEntidadErrorsValidate()
    },
    onOtroRucInput () {
      const sanitized = (this.endosos.otroRuc || '')
        .replace(/\D/g, '')
        .substring(0, 11)
      if (sanitized !== this.endosos.otroRuc) {
        this.endosos.otroRuc = sanitized
      }
      this.endososOtroRucErrorsValidate()
    },
    endososEntidadErrorsValidate () {
      if (!this.habilitarOtroBanco) {
        this.errors.endososEntidad = []
        return
      }
      const { errors } = validateBankEntityName(this.endosos.entidad)
      this.errors.endososEntidad = errors
    },
    endososOtroRucErrorsValidate () {
      if (!this.habilitarOtroBanco) {
        this.errors.endososOtroRuc = []
        return
      }
      const { errors } = validateFinancialEntityRuc(this.endosos.otroRuc)
      this.errors.endososOtroRuc = errors
    },
    onEndosoMontoInput () {
      let sanitized = (this.endosos.monto || '').replace(/[^\d.]/g, '')
      const dotIndex = sanitized.indexOf('.')
      if (dotIndex !== -1) {
        const integerPart = sanitized.slice(0, dotIndex)
        const decimalPart = sanitized.slice(dotIndex + 1).replace(/\./g, '').slice(0, 2)
        sanitized = integerPart + '.' + decimalPart
      }
      if (sanitized !== this.endosos.monto) {
        this.endosos.monto = sanitized
      }
      this.endososMontoErrorsValidate()
    },
    endososMontoErrorsValidate () {
      const { errors } = validateEndorsementAmount(this.endosos.monto, this.endosos.montoMaximo)
      this.errors.endososMonto = errors
    },
    isEndosoBancarioFormValid () {
      if (!this.declaracion) {
        return false
      }

      if (!validateEndorsementAmount(this.endosos.monto, this.endosos.montoMaximo).isValid) {
        return false
      }

      if (!validateEmail(this.form.email).isValid) {
        return false
      }

      if (this.habilitarOtroBanco) {
        return validateBankEntityName(this.endosos.entidad).isValid &&
          validateFinancialEntityRuc(this.endosos.otroRuc).isValid
      }

      return !!(this.endosos.ruc && this.endosos.entidad)
    },
    // VALIDATIONS
    productErrors () {
      const errors = []
      if (this.form.product) return errors
      !this.form.product && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    policyErrors () {
      const errors = []
      if (this.form.policy) return errors
      !this.form.policy && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    transactErrors () {
      const errors = []
      if (this.form.transact) return errors
      !this.form.transact && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    departmentErrors () {
      const errors = []
      if (this.form.department) return errors
      !this.form.department && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    provinceErrors () {
      const errors = []
      if (this.form.province) return errors
      !this.form.province && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    districtErrors () {
      const errors = []
      if (this.form.district) return errors
      !this.form.district && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    emailErrors () {
      const { errors } = validateEmail(this.form.email)
      if (errors.length === 0) {
        return []
      }
      if (!this.form.email) {
        return ['Rellenar campo obligatorio.']
      }
      return errors.map((error) => {
        if (error === 'El correo electrónico es requerido' || error === 'El correo electrónico no puede estar vacío') {
          return 'Rellenar campo obligatorio.'
        }
        if (error === 'El formato del correo electrónico no es válido') {
          return 'El email debe ser válido.'
        }
        return error
      })
    },
    emailErrorsValidate () {
      this.errors.email = this.emailErrors()
    },
    emailConstErrors () {
      const errors = []
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!re.test(this.form.email_send_constancy)) {
        errors.push('El email debe ser válido.')
      }
      if (!this.form.email_send_constancy) {
        errors.push('Rellenar campo obligatorio.')
      }
      this.errors.email = errors
    },
    homeAddressErrors () {
      const errors = []
      if (this.form.home_address) return errors
      !this.form.home_address && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    interiorErrors () {
      const errors = []
      if (this.form.interior) return errors
      !this.form.interior && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    cellphoneErrors () {
      const errors = []
      !/^9[\d]{8}$/.test(this.form.cellphone) && errors.push('El teléfono celular debe ser válido ')
      if (this.form.cellphone) return errors
      !this.form.cellphone && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    phoneErrors () {
      const errors = []
      if (this.form.phone) return errors
      !this.form.phone && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    detailTransactErrors () {
      const errors = []
      if (this.form.detail_transact) return errors
      !this.form.detail_transact && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    responseMediumErrors () {
      const errors = []
      if (this.form.response_medium) return errors
      !this.form.response_medium && errors.push('Seleccionar medio de respuesta.')
      return errors
    },
    acceptConditionErrors () {
      const errors = []
      if (this.checkPersonalData === 'acepto') return errors
      this.checkPersonalData !== 'acepto' && errors.push('Debes aceptar la actualización de datos.')
      return errors
    },
    // PRESTAMOS - ANULACION Validation Errors
    descriptionCancellationErrors () {
      const errors = []
      if (this.form.description_cancellation) return errors
      !this.form.description_cancellation && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    cancellationReasonErrors () {
      const errors = []
      if (this.form.cancellation_reason) return errors
      !this.form.cancellation_reason && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    accountNumberErrors () {
      const errors = []
      if (this.form.account_number) return errors
      !this.form.account_number && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    fullnameAccountHolderErrors () {
      const errors = []
      if (this.form.fullname_account_holder) return errors
      !this.form.fullname_account_holder && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    bankErrors () {
      const errors = []
      if (this.form.bank) return errors
      !this.form.bank && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    currencyErrors () {
      const errors = []
      if (this.form.currency) return errors
      !this.form.currency && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    reasonsErrors () {
      const errors = []
      if (this.form.reason) return errors
      !this.form.reason && errors.push('Rellenar campo obligatorio.')
      return errors
    },
    getWildcardMonths (lastFee) {
      let wildcardMonths = []
      let now = new Date()
      let month
      let year
      let y, m
      if (lastFee) {
        [y, m] = lastFee.split('-')
        year = parseInt(y)
        month = parseInt(m) + 12
        if (month > 12) {
          month -= 12
          year += 1
        }
      }

      if (!lastFee || (lastFee && (now.getFullYear() > year || (now.getFullYear() === year && now.getMonth() + 1 >= month)))) {
        month = now.getMonth() + ((now.getDate() <= 5) ? 2 : 3)
        year = now.getFullYear()
      }
      /*
      if (!lastFee || lastFee === null || lastFee === '') {
        month = now.getMonth() + ((now.getDate() <= 5) ? 2 : 3)
        year = now.getFullYear()
      } else {
        let dateFee = lastFee.split('-')
        year = parseInt(dateFee[0])
        month = parseInt(dateFee[1]) + 12
        if (month > 12) {
          month -= 12
          year += 1
        }
        if (year < now.getFullYear() || (year === now.getFullYear() && month <= now.getMonth())) {
          month = now.getMonth() + ((now.getDate() <= 5) ? 2 : 3)
          year = now.getFullYear()
        }
      }
      console.log(lastFee, month, year)
      */
      let i
      let months = 12
      for (i = month; months > 0; i++) {
        if (i >= 12) {
          year++
          i = 12 - (i - 2)
        }
        let wildcardMonth = {
          key: year + '-' + ((i > 9) ? '' + i : '0' + i),
          value: this.months[i] + ' - ' + year
        }
        wildcardMonths.push(wildcardMonth)
        months--
      }
      return wildcardMonths
    },
    // #004.31: Elemento - Seleccionar detalles
    selectDetailsAnalytics (section) {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis solicitudes - Paso 1 - Formulario Información de solicitud',
        'label': section
      })

      this.$gtm.trackEvent({
        'event': 'select_details',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'item_list',
        'TipoAccion': 'Mis solicitudes - Paso 1 - Formulario Información de solicitud',
        'CTA': section
      })
    },
    // #004.33: Elemento - Botón Siguiente
    nextButtonAnalytic () {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis solicitudes - Paso 1 - Mi Solicitud',
        'label': 'Seleccionar botón - Siguiente'
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis solicitudes - Paso 1 - Mi Solicitud',
        'CTA': 'Seleccionar botón - Siguiente'
      })
    },
    closeAlertPopupMethod () {
      this.flagPopupAlert = false
    },
    capitalizeString (str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    getFullName() {
      return `${this.capitalizeString(this.form.name)} ${this.capitalizeString(this.form.paternal_surname)} ${this.capitalizeString(this.form.maternal_surname)}`;
    },
    selectedCoverages(coverage) {
      this.form.new_amount = '';
      this.form.new_endorsement_date = '';
      if (coverage.selected) {
        this.coberturasEliminadas.push(coverage);
      } else {
        this.coberturasEliminadas = this.coberturasEliminadas.filter(item => item.nombre !== coverage.nombre);
      }
      
      // Actualizar también la propiedad selected en form.coberturas para mantener sincronización
      if (this.form.coberturas && this.form.coberturas.length > 0) {
        const coberturaEnForm = this.form.coberturas.find(item => 
          item.nombre === coverage.nombre || 
          item.codigoCobertura === coverage.codigoCobertura
        );
        if (coberturaEnForm) {
          coberturaEnForm.selected = coverage.selected;
        }
      }
    },
    recalculateDateEndorsement(fechaPagadoHasta) {
      // Recalcular fecha efectiva de endoso
      if (!fechaPagadoHasta) {
        this.form.new_endorsement_date = "";
        return;
      }

      const [day, month, year] = fechaPagadoHasta.split("/").map(Number);
      const date = new Date(year, month - 1, day);

      if (isNaN(date.getTime())) {
        this.form.new_endorsement_date = "";
        return;
      }

      // Sumar un día a la fecha
      date.setDate(date.getDate() + 1);

      // Convertir al formato YYYY-MM-DD
      const formattedDate = date.toISOString().split("T")[0];

      // Asignar la fecha formateada al formulario
      this.form.new_endorsement_date = formattedDate;
    },
    getMonthYearFormat(date) {
      if (!date) return "";

      const dateObj = new Date(`${date}T00:00:00Z`);
      const month = dateObj.toLocaleString("es-ES", { month: "long", timeZone: "UTC" });
      const year = dateObj.getUTCFullYear();

      return `${month.charAt(0).toUpperCase()}${month.slice(1)} ${year}`;
    },
    formatDate(date) {
      if (!date) return "";
      
      const dateObj = new Date(`${date}T00:00:00Z`);
      const day = dateObj.getUTCDate().toString().padStart(2, '0');
      const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = dateObj.getUTCFullYear();
      
      return `${day}/${month}/${year}`;
    },
    showTooltip (type) {
      switch (type) {
      case 'coberturaAdicional':
        this.tooltips.coberturaAdicional = true
        break
      case 'coberturaRecalculo':
        this.tooltips.coberturaRecalculo = true
        break
      case 'declaracionJurada':
        this.tooltips.declaracionJurada = true
        break
      default:
        break
      }
    },
  },
  mounted () {
    let self = this
    this.$refs.stepperText[0].classList.add('active')
    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    this.today = dd + '/' + mm + '/' + yyyy
    this.modUbigeo.department = ubigeo.departments
    if (this.polizasInfo !== null) {
      this.setInfoInForm()
    }

    window.addEventListener('resize', this.onResize, { passive: true })
    // Campos de bancos para Endosos (API Sistemas Workflow)
    this.loadBanksForEndosos()
    // PROPS FROM MIS SEGUROS - OBJETO QUE VIENE SOLO DE LA SECCIÓN DE MIS SEGUROS
    if (this.seguroCodeGTM && this.seguroPolicy) {
      this.form.policy = this.seguroPolicy
      this.form.product = this.polizasInfo.filter(function (poliza) { return poliza.numeroPoliza === self.seguroPolicy })[0].producto

      switch (this.seguroCodeGTM) {
      case transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA:
        this.codeGTM = transacts.codesGTM.ENDOSOS_ENTIDAD_FINANCIERA
        this.form.transact = 'Endoso a entidad financiera'
        break

      case transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO:
        this.codeGTM = transacts.codesGTM.CAMBIO_FRECUENCIA_PAGO
        this.form.transact = 'Cambio Frecuencia de Pago'
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.CUOTA_COMODIN:
        this.codeGTM = transacts.codesGTM.CUOTA_COMODIN
        this.form.transact = 'Cuota comodín'
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.LIBERACION_ENDOSO:
        this.codeGTM = transacts.codesGTM.LIBERACION_ENDOSO
        this.form.transact = 'Liberación de endoso'
        this.changeViewForDesktop()
        break

      case transacts.codesGTM.ANULACION_POLIZA:
        this.codeGTM = transacts.codesGTM.ANULACION_POLIZA
        this.form.transact = 'Anulación de póliza'
        
        // Redirigir a vista específica para SOAT
        if (this.form.product === 'SOAT') {
          this.$router.push({
            name: 'FormalitiesSOATCancellation',
            params: {
              policy: this.form.policy,
              product: this.form.product
            }
          })
          return
        }
        
        this.changeViewForDesktop()
        break
      
      case transacts.codesGTM.RETIRO_COBERTURAS:
        this.codeGTM = transacts.codesGTM.RETIRO_COBERTURAS
        this.form.transact = 'Eliminación de cobertura'
        this.changeViewForDesktop()
        break

      default:
        break
      }
    }
    // VERIFICAMOS SI TIENES ALGUN PENDIENTE EN ACT_DATOS
    this.checkIfPolicyHasPendingOkActDatos({ numDoc: this.basicInfo.numeroDocumento })
      .then((res) => {
        if (res.data.data.length > 0) {
          this.anulaciones.actDatosPendiente = true
        }
      })

    self.$root.$emit('npsInactivity', {seccion: 'Mis solicitudes'})
  },
  created () {
    let self = this
    this.$root.$on('donePolizas', function (obj) {
      if (self.polizasInfo !== null) {
        self.setInfoInForm()
      }
    })
    this.$root.$on('finishValidationPhone', function (data) {
      if (data.status === 'OK') {
        if (self.validatedPhone === false && self.showValidationPhone === true) {
          self.showValidationPhone = false
          self.validatedPhone = true
          self.processTransact()
        }
      }
    })
    this.$root.$on('backValidationPhone', function () {
      self.showValidationPhone = false
    })
  },
  components: {
    'upload-btn': UploadButton,
    'validation-phone': ValidationPhone,
    PopupAlertMessage
  }
}
</script>

<style>
/** Estilos para ENDOSOS */
#form-formalities .endosos-fields .v-text-field .v-input__prepend-outer {
  margin: 0;
  height: 59px;
  border: 1.2px solid #cccccc;
  width: 65px;
  border-right: 0;
  background: #eff1f4;
  -webkit-border-top-right-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  -moz-border-radius-topright: 0;
  -moz-border-radius-bottomright: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  -webkit-border-top-left-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
#form-formalities .endosos-fields .v-text-field .v-input__prepend-outer p {
  width: 100%;
  margin: 0;
  align-self: center;
  text-align: center;
}
#form-formalities .endosos-fields.otros-bancos .v-text-field:nth-child(3) .v-input__control .v-input__slot .v-text-field__slot,
#form-formalities .endosos-fields:not(.otros-bancos) .v-text-field:nth-child(2) .v-input__control .v-input__slot .v-text-field__slot {
  -webkit-border-top-right-radius: 3px;
  -webkit-border-bottom-right-radius: 3px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  -webkit-border-top-left-radius: 0;
  -webkit-border-bottom-left-radius: 0;
  -moz-border-radius-topleft: 0;
  -moz-border-radius-bottomleft: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
#form-formalities .endosos-fields  p.info-parraf-endosos {
  color: rgb(234, 12, 144);
  text-align: initial;
  margin-top: 5px;
  font-size: 14px;
}
#form-formalities .endosos-fields  p.info-parraf-endosos img {
  margin-right: 6px;
  position: relative;
  top: 4px;
}
/** Estilos para ENDOSOS */
#form-formalities .endosos-fields .v-select .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
  margin-top: 2.6%;
}
#form-formalities input#monto-endosable {
  width: 88%;
  flex: initial;
}
#gracias{
  border-color: #FFF;
  text-align: end
}

h3.contactar span {
    color: #0855C4;
    font-family: 'Omnes Medium';
  }

/* Estilo para botón "Siguiente" */
button#btnSolicitud, button#btnSendSolicitud, button#btnBackToMain
, button#btnSendConstancy, button#btnConstancySentAccept, button#btnBeneficiarios
, button#btnRenovCertificado, button#btnRemoveBenef, button#btnListaSolicitudes {
  font-size: 14px;
  border-radius: 3px;
  background-color: var(--fuchsia-color);
  color: #fff;
  text-transform: initial;
  height: auto;
}
button#btnSolicitud.actualizar_datos {
  color: var(--fuchsia-color);
  margin-right: 10%;
}
button#btnSolicitud.actualizar_datos .v-btn__content {
  padding: 3px;
}
button#btnSendConstancy, button#btnConstancySentAccept {
  width: 100%;
}
button#btnBeneficiarios, button#btnRenovCertificado, button#btnRemoveBenef, button#btnListaSolicitudes {
  width: 40%;
  margin-bottom: 2em;
}
button#btnSolicitud:hover { background-color: #d6058b; }
button#btnSolicitud .v-btn__content
, button#btnSendSolicitud .v-btn__content
, button#btnBackToMain .v-btn__content
, button#btnSendConstancy .v-btn__content
, button#btnConstancySentAccept .v-btn__content
, button#btnBeneficiarios .v-btn__content
, button#btnRenovCertificado .v-btn__content
, button#btnRemoveBenef .v-btn__content
, button#btnListaSolicitudes .v-btn__content {
  padding: 1em 0;
}
a#btnBack, a.simple-btn-blue {
  font-size: 14px;
  color: #0855C4;
  display: block;
  text-align: center;
  margin: 1em 0;
}
.v-dialog button#btnSendConstancy, .v-dialog button#btnConstancySentAccept {
  margin-bottom: 3em;
}
.v-dialog button#btnConstancySentAccept {
  margin-top: 3em;
}
.label-beneficiarios {
  display: block;
  text-align: left;
  color: #1251C4;
  font-weight: bold;
}
.inputtext-beneficiario {
  padding-top: 0px;
  margin-top: 0px;
}
.inputtext-beneficiario.input-border-dashed .v-input__control .v-input__slot .v-text-field__slot {
  border: dashed 1px #ccc !important;
}
#form-formalities #view_form_constancy .btnadd-beneficiario {
  display: block;
  background-color: #1251C4;
  color: white;
  width: 100%;
  margin: 0px;
  text-transform: none;
}
#form-formalities #view_form_constancy .btnadd-renovcertificado {
  display: block;
  background-color: #1251C4;
  color: white;
  width: 100%;
  margin: 0px;
  margin-top: -18px;
  margin-bottom: 0.5em;
  text-transform: none;
}
#form-formalities #view_form_constancy .btnadd-renovcertificado img {
  margin-right: 5px;
}
#form-formalities .v-input.hide-details .v-text-field__details {
  display: none;
}
#form-formalities .ly-new-beneficiario img, #form-formalities .ly-new-beneficiario p {
  display: inline;
}
#form-formalities .ly-new-beneficiario p {
  color: var(--fuchsia-color);
  margin: 2px 4px;
}
#form-formalities .mr-2 {
  margin-right: 2px !important;
}
#form-formalities .ml-2 {
  margin-right: 2px !important;
}
p.text-indication {
  text-align: left;
  font-size: 11px;
  color: #0855C4;
  margin-bottom: 0.5em;
}
#dialog_beneficiario .title-dialog
, #dialog_renovarcertificado .title-dialog
, #dialog_removebeneficiario .title-dialog {
  color: #1251C4;
  margin-top: 3em;
}
#dialog_listasolicitudes .title-dialog-without-close {
  color: #1251C4;
  margin-top: 2.5em;
}
#dialog_removebeneficiario .title-dialog {
  margin-bottom: 0.5em;
}
#dialog_renovarcertificado .title-dialog {
  margin-bottom: 2px;
}
#dialog_removebeneficiario .mg-bt-0 {
  margin-bottom: 0px;
}
#dialog_beneficiario .subtitle-dialog {
  margin-bottom: 1em;
}
#dialog_listasolicitudes .list-solicitudes li {
  list-style: none;
  position: relative;
}
#dialog_listasolicitudes .list-solicitudes li p {
  text-align: left;
  margin-left: 2em;
}
#dialog_listasolicitudes .list-solicitudes li img {
  position: absolute;
  top: 1px;
  left: 0px;
}
.v-dialog .dialog-with-inputbox p.subtitle-dialog-min {
  font-size: 11px;
  color: var(--text-color);
  font-weight: bold;
}
.v-dialog .dialog-with-inputbox div.layout.mg-bt-4 {
  margin-bottom: 1em;
}
#dialog_beneficiario .text-fileupload-indications-blue {
  color: #1251C4;
  margin-top: 1em;
  font-weight: bold;
  font-size: 12px;
}
.v-dialog .dialog-with-attachments p.title-attachment {
  margin-top: 1em;
  margin-bottom: 2px;
}
.v-dialog .dialog-with-attachments p.title-attachment-blue {
  text-align: left;
  font-size: 12px;
  color: #0855C4;
  margin-bottom: 1px;
  font-weight: bold;
}
.border-bottom {
  border-bottom: solid 1px #B2B4C7;
}
.v-dialog .dialog-with-attachments .border-bottom {
  padding-bottom: 4em;
}
.v-dialog .check-message {
  text-align: left;
  margin-top: 0;
  font-size: 11px;
}
.v-dialog .check-message .v-input.v-input--checkbox {
  margin-top: 0;
}
.v-dialog .check-message .v-input.v-input--checkbox label {
  font-size: 11px;
  line-height: 15px;
  margin-left: -5px;
}
.v-dialog .check-message .v-input.v-input--checkbox .v-icon {
  font-size: 18px;
}
#form-formalities button.btn-border-blue {
  border-color: #1251C4;
  border-width: 2px;
  margin: 0px;
  margin-top: -18px;
  margin-bottom: 1em;
  margin-right: 5px;
  height: 30px;
  width: 50px;
  text-transform: none;
  color: #1251C4;
}
#form-formalities button.btn-border-blue img {
  margin-right: 2px;
}
#form-formalities .v-input.v-text-field {
  margin-top: 2px;
  padding-top: 2px;
}
.disclaimer-endosos {
  margin-top: 20px;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  padding: 12px 20px;
  background: #F9F9F9;
  /* border-radius: 0 0 6px 6px; */
  font-size: 13px;
  color: #666;
  text-align: center;
  border: 1px solid #DADADA;
  
}

.disclaimer-endosos p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disclaimer-endosos .img-disclaimer {
  display: inline-block;
  vertical-align: middle;
}
@media only screen and (max-width : 600px) {
  button#btnSolicitud {
    margin: 2em 0;
  }
  .v-text-field.v-text-field--placeholder .v-input__control .v-input__slot .v-input__prepend-inner img { width: 90%; }

  #form-formalities #ly_resumen .resumen-data {
    border: none;
    margin-top: 1.5em;
  }

  #form-formalities #ly_resumen .resumen-data p.label-resumen,
  #form-formalities #ly_resumen_2 .resumen-data p.label-resumen {
    padding-left: 1em;
  }
  button#btnSolicitud,
  button#btnSendSolicitud,
  button#btnBackToMain,
  button#btnSendConstancy,
  button#btnConstancySentAccept {
    width: 70%;
  }
  button#btnSolicitud.actualizar_datos {
    margin: 0;
  }
  #form-formalities .tramite .text-phone-confirmation {
    margin: 0 !important;
  }
  #dialog_listasolicitudes .list-solicitudes {
    padding: 2em 0em;
    border: none;
    margin: 2em 0em;
  }
  .ly-uploadfile.uploaded .text-file-uploaded {
    margin-left: 15px;
  }
}
/* Meidum */
@media only screen  and (min-width : 961px) and (max-width: 1264px) {
  .ly-uploadfile.uploaded .text-file-uploaded {
    margin-left: 0px;
  }
}
/* Desktop ----------- */
@media only screen  and (min-width : 1265px) {
  #form-formalities #ly_resumen .resumen-data {
    border: none;
    margin-left: 10px;
  }
  button#btnSolicitud {
    font-size: 14px;
    width: 60%;
    margin-left: 0;
    margin-right: 0;
    color: #fff;
    font-family: 'Omnes SemiBold';
    font-weight: normal;
    padding: 2px 16px;
  }
  button#btnSolicitud.v-btn.v-btn--disabled { color: #717285 !important; }

  #form-formalities #ly_resumen {
    margin-top: 1.5em;
    padding-top: 1em;
    border: 1px solid #D8D8D8;
    margin-bottom: 2em;
    padding-left: 1.5em;
    padding-right: 1em;
  }
  #form-formalities #ly_resumen_2 {
    margin: 2em 0;
    border: 1px solid #C9C9C9;
  }
  #form-formalities #ly_resumen .resumen-data {
    margin-top: 1em;
    padding: 0.5em;
    border-radius: 3px;
  }

  #form-formalities .tramite .text-phone-confirmation {
    margin: 0 6em;
  }

  #form-formalities .tramite #btnBack {
    margin-bottom: 2em;
  }

  #form-formalities #ly_constancy_registered .cr-main .subtitle-solicitud {
    /* margin: 0px 4em; */
  }
  button#btnBackToMain {
    width: 50% !important;
  }
  button#btnSolicitud,
  button#btnSendSolicitud,
  button#btnBackToMain,
  button#btnSendConstancy,
  button#btnConstancySentAccept {
    width: 40%;
  }
  #dialog_listasolicitudes .list-solicitudes {
    padding: 2em 1em 1em 3em;
    border: 1px solid #ccc;
    margin: 2em 2em;
  }
  .ly-uploadfile.uploaded .text-file-uploaded {
    margin-left: 0px;
  }
  .v-dialog .ly-uploadfile.uploaded .text-file-uploaded {
    margin-left: 0px;
  }
}
#formalities .v-item-group {
  align-items: center;
  width: 21.33%;
  padding-left: 4.1em;
  background-color: #FFF;
  font-family: 'Omnes Medium';
}
.hide { display: none; }
#form-formalities { width: 78.67%; }
#formalities .v-item-group div button {
  color: transparent;
  height: auto;
  width: 27%;
}
#formalities .flex .v-window.elevation-1 { box-shadow: none!important; }
#formalities, #formalities .flex .v-window.elevation-1 .v-window__container {
  height: calc(100vh - 54.55px);
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text {
  background-color: #FFF;
  padding: 0;
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-card.v-sheet {
  margin-bottom: 28px;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid var(--second-brand-color);
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-card.v-sheet p {
  font-family: 'Omnes Medium';
  color: #535D66;
  font-size: 20px;
  text-align: center;
  margin-bottom: 4px;
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-btn.back, .last-step .v-btn.back {
  text-transform: uppercase;
  border-radius: 6px;
  width: 95%;
  border-color: var(--second-brand-color);
  color: var(--second-brand-color);
  height: auto;
  padding: 9.5px 0;
  border: 2px solid;
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-btn.next, .last-step .v-btn.next {
  background-color: var(--fuchsia-color) !important;
  color: #FFF;
  text-transform: uppercase;
  border-radius: 6px;
  width: 95%;
  height: auto;
  padding: 11px 0;
}
button.theme--light.v-btn.btn-form-formalities {
  background-color: var(--fuchsia-color) !important;
  color: #FFF !important;
  text-transform: capitalize;
  border-radius: 6px;
  width: 40%;
  height: auto;
  padding: 10px 0;
}
h2.title-formalities {
  text-align: center;
  color: var(--second-brand-color);
  border: 1.5px solid var(--second-brand-color);
  border-radius: 18px;
  font-family: Omnes Regular;
  font-weight: 400;
  position: relative;
  /*
  padding: 2px 0;
  margin-top: 0.7em;
  margin-bottom: 0.3em;
  */
}
h2.title-formalities img {
  position: absolute;
  width: 11%;
  left: 3em;
  top: 6px;
}
h2.title-formalities.personal-data img { left: 2.6em; }

/* ESTILO para SELECT */
.selectPP.v-text-field--outline.v-select .v-input__control .v-input__slot {
  border: 1px solid var(--second-brand-color);
  border-radius: 0;
  min-height: 42px;
  height: 42px;
}
#form-formalities .v-select.v-text-field .v-input__control .v-input__slot .v-select__slot
, .v-dialog .dialog-with-inputbox .v-select.v-text-field .v-input__control .v-input__slot .v-select__slot
, #form-formalities .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot
, .v-dialog .dialog-with-inputbox .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot
, .v-dialog #dialog_constancy_sent .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  border: 1.2px solid #cccccc;
  padding: 5px;
  border-radius: 3px;
}
.v-dialog .textfield-benef-fecnac.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  width: 70%;
}
.dialog-with-inputbox .textfield-benef-fecnac.v-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin-right: 0px !important;
}
#form-formalities .v-text-field > .v-input__control > .v-input__slot:before
, .v-dialog #dialog-formalities .v-text-field > .v-input__control > .v-input__slot:before
, .v-dialog .dialog-with-inputbox .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}
#form-formalities .v-text-field > .v-input__control > .v-input__slot:after
, .v-dialog #dialog-formalities .v-text-field > .v-input__control > .v-input__slot:after
, .v-dialog .dialog-with-inputbox .v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}
.v-select.v-text-field .v-input__control .v-input__slot .v-select__slot label {
  top: 18px;
  left: 10px !important;
}
.v-select.v-text-field .v-input__control .v-input__slot .v-select__slot label.v-label--active {
  top: 20px;
  left: 0px !important;
  font-weight: bold;
}
#form-formalities .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot label
, .dialog-with-inputbox .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot label {
  top: 17px;
  left: 15px !important;
}
#form-formalities .v-select.v-text-field .v-input__control .v-input__slot .v-select__slot label.v-label--active
, #form-formalities .v-input.v-text-field.v-input--is-label-active .v-input__control .v-input__slot .v-text-field__slot label
, .v-dialog .dialog-with-inputbox .v-select.v-text-field .v-input__control .v-input__slot .v-select__slot label.v-label--active
, .v-dialog .dialog-with-inputbox .v-input.v-text-field.v-input--is-label-active .v-input__control .v-input__slot .v-text-field__slot label {
  top: 20px;
  left: 15px !important;
  color: #717285 !important;
}
#form-formalities .v-select.v-text-field .v-input__control .v-input__slot .v-select__selections
, #form-formalities .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot input
, .dialog-with-inputbox .v-select.v-text-field .v-input__control .v-input__slot .v-select__selections
, .dialog-with-inputbox .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin-top: 15px;
  margin-left: 10px;
}
#form-formalities #ly_emailaddress .v-input.v-text-field {
  margin-top: 0px;
  padding-top: 6px;
}
#form-formalities #ly_emailaddress .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot input
, .dialog-with-inputbox .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin-right: 35px;
}
#form-formalities .v-input.v-text-field .v-input__control .v-input__slot .v-input__prepend-inner
, .v-dialog .dialog-with-inputbox .v-input.v-text-field .v-input__control .v-input__slot .v-input__prepend-inner {
  position: absolute;
  right: 8px;
  top: 14px;
}
#form-formalities .v-text-field .v-label--active
, .dialog-with-inputbox .v-text-field .v-label--active {
    transform: translateY(-10px) scale(0.75);
}
.v-dialog .dialog-with-inputbox .textfield-benef-apepat {
  margin-right: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-benef-apemat {
  margin-left: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-benef-fecnac {
  margin-right: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-benef-genero {
  margin-left: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-dialog {
  margin-top: 2px;
  padding-top: 2px;
}
.v-dialog .dialog-with-inputbox .textfield-dialog .v-input__slot {
  margin-bottom: 0px;
}
#dialog-formalities h3 {
  margin-top: 1em;
}
p.text-email_address {
  margin: 0px;
  margin-top: 1em;
  text-align: left;
  color: #717285;
}
ul.list-terms_and_conditions {
  font-size: 11px;
  padding: 0px;
}
ul.list-terms_and_conditions li.text-conditions {
  text-align: left;
  margin-top: 1em;
  list-style: none;
  position: relative;
}
ul.list-terms_and_conditions li.text-conditions span {
  position: absolute;
  top: 5px;
  left: 3px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: var(--text-color);
}
ul.list-terms_and_conditions li.text-conditions p {
  margin-left: 15px;
  color: var(--text-color);
}
#form-formalities a.simple-btn-blue {
  color: #0855C4;
  font-weight: bold;
}
#form-formalities .btnBackToMain {
  margin-top: 1em;
  margin-bottom: 1em;
}
#form-formalities img.img-solicitud_registrada {
  margin-bottom: 1em;
}
.v-dialog img.imgbtn-icon_close {
  position: absolute;
  right: 0px;
  margin: 1em;
  cursor: pointer;
}
.v-dialog img.img-send_constancy {
  margin-top: 7em;
}
.v-dialog img.img-constancy_sent {
  margin-top: 5em;
  margin-bottom: 2em;
}
h3.text-fileupload-title {
  text-align: left;
  margin-bottom: 4px;
  margin-top: 5px;
  color: #717285;
  font-weight: bold;
}
p.text-fileupload-indications {
  font-size: 10px;
  color: #1f1f1f;
  text-align: left;
  margin: 0px;
  margin-bottom: 2px;
  margin-left: 2em;
}
p.text-fileupload-indications span {
  font-weight: bold;
}
p.text-product {
  text-align: left;
  font-weight: bold;
  color: var(--text-color);
  margin-bottom: 2em;
}
p.text-product span {
  color: #0855c4;
  margin-left: 5px;
}
.selectPP.v-text-field--outline.v-select .v-input__control .v-input__slot:hover,
.inputPP.v-text-field--outline.v-text-field .v-input__control .v-input__slot:hover {
  border: 2px solid #000 !important;
}
.selectPP.v-text-field--outline.v-select .v-input__control .v-input__slot .v-select__slot .v-select__selections {
  line-height: 1;
  padding: 0;
}
.selectPP.v-text-field--outline.v-select .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
  margin-top: 7px;
}
.selectPP.v-text-field--outline.v-select .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon i {
  color: #0855C4;
}
/** CHECKBOX ANULACIONES */
.anulaciones-datos_personales .v-input--checkbox {
  margin-top: 0;
  padding-top: 0;
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot {
  margin-bottom: 0;
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input {
  margin-right: 0;
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot label {
  font-size: 11px;
  color: var(--text-color);
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input i.material-icons {
  font-size: 16px;
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input i.material-icons.accent--text {
  color: #0855C4 !important;
  caret-color: #0855C4 !important;
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input .v-input--selection-controls__ripple {
  width: 23px;
  height: 26px;
  top: calc(50% - 19px);
}
.anulaciones-datos_personales .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input .v-input--selection-controls__ripple.accent--text {
  color: #0855C4 !important;
  caret-color: #0855C4 !important;
}
/** END - CHECKBOX ANULACIONES */
#view_myproduct.lg6, #view_form_constancy.lg6 {
  margin: 1em 2em;
}
#view_form_constancy.lg6 {
  border: 1px solid #E7EAED;
}
#view_form_constancy.lg6 .layout.pd-lr {
  padding-left: 1.5em;
  padding-right: 1.5em;
}
#view_form_constancy.lg6 .layout.pd-top {
  padding-top: 0.5em;
}
#view_form_constancy.lg6 .layout.pd-bottom {
  padding-bottom: 0.5em;
}
#view_myproduct .myproduct {
  border: solid 1px #E7EAED;
  border-radius: 3px;
}
#view_myproduct .myproduct .mp-title {
  color: #0855C4;
  padding: 10px 15px;
  text-align: left;
  border-bottom: 1px solid #E7EAED;
}

#view_myproduct .myproduct .row-mp-subtitle {
  margin: 10px 15px 30px 15px;
}

#view_myproduct .myproduct .row-mp-subtitle .mp-subtitle {
  text-align: left;
  color: var(--text-color) !important;
}

#view_myproduct .myproduct .row-mp-subtitle .col-mp-button {
  text-align: right;
}

#view_myproduct .myproduct .row-mp-subtitle button {
  background-color: #0855C4;
  padding: 0.3em 1em;
  color: #FFFFFF;
  border-radius: 4px;
  font-size: 12px;
}

#view_myproduct .myproduct .row-mp-data {
  margin: 10px 15px;
}

#view_myproduct .myproduct .row-mp-data.hr {
  border-bottom: 1px solid #E7EAED;
}

#view_myproduct .myproduct .mp-data-name {
  text-align: left;
}

#view_myproduct .myproduct .mp-data-name span {
  color: var(--text-color) !important;
}

#view_myproduct .myproduct .mp-data-value {
  text-align: left;
  font-weight: bold;
}

#view_myproduct .myproduct .mp-data-value p {
  color: #717285 !important;
}

#view_form_constancy .title-constancy {
  color: #0855C4;
  padding: 10px 1em;
  text-align: left;
  border-bottom: 1px solid #E7EAED;
}

#view_form_constancy .pd-rl {
  padding-left: 1em;
  padding-right: 1em;
}

/* ESTILO para INPUTS */
.inputPP.v-text-field--outline.v-text-field .v-input__control .v-input__slot {
  border: 2px solid #bfc6cc;
  border-radius: 0;
  min-height: 42px;
  height: 42px;
}
/* ESTILO para INPUTS en MODALS */
.grid-list-md .inputPP.v-text-field--outline.v-text-field .v-input__control .v-input__slot .v-text-field__slot input { margin-top: 5px; }
/* ESTILO GLOBAL  */
#container--body-insurance.formalities { padding: 0; }
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-select .v-input__control .v-input__slot, #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-text-field .v-input__control .v-input__slot {
  min-height: 36px;
  margin-bottom: 3px;
  height: 36px;
  background-color: #fff!important;
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-input--is-disabled .v-input__control .v-input__slot:hover { border: 0; }
/* INPUT DISABLED */
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-input--is-disabled .v-input__control .v-input__slot {
  border: 0;
  background-color: #e9e9e9!important;
  border-radius: 0;
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-input--is-disabled .v-input__control .v-text-field__details { display: none; }
/* INPUT DISABLED */
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-input--is-disabled .v-input__control .v-input__slot .v-text-field__slot input { color: #535D66; }
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-textarea .v-input__control .v-input__slot {
  min-height: 56px;
  height: auto;
}
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-select .v-input__control .v-input__slot .v-select__slot label { top: 10px; }
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-text-field .v-input__control .v-input__slot .v-text-field__slot input { margin-top: 1px; }
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-select .v-input__control .v-input__slot .v-select__slot .v-select__selections { padding-top: 0; }
#form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-select .v-input__control .v-input__slot .v-select__slot .v-input__append-inner { margin-top: 6px; }
/* Estilo subtitulo */
h2.subtitle-formalities { color: var(--second-brand-color); }
h2.subtitle-form-formalities {
  color: var(--second-brand-color);
  font-weight: initial;
  font-family: 'Omnes Regular';
  font-size: 24px;
}
p.option-as-text {
  font-size: 16px;
  font-family: 'Omnes Medium';
}
p.label-input-formalitites {
  font-family: 'Omnes Regular';
  color: #535D66;
  margin-bottom: 5px;
}
p.label-input-formalitites-color {
  font-family: 'Omnes Medium';
  font-size: 20px;
  color: var(--second-brand-color);
}
button.previewFile.v-btn {
  background-color: #FFF !important;
  max-width: 150px;
}
button.previewFileRelease.v-btn {
  background-color: #0855CA !important;
  color: #FFF !important;
  max-width: 120px;
  border-radius: 20px;
  font-size: 9px;
}
button.previewFileRelease.v-btn .v-btn__content {
  max-width: 140px;
  overflow: hidden;
  height: 20px;
  margin-right: -5px;
  margin-left: 0px;
  justify-content:left;
  padding-left: 0px;
}
button.previewFile.v-btn .v-btn__content {
  max-width: 120px;
  overflow: hidden;
  height: 20px;
  max-width: 120px;
  margin-right: 82px;
  margin-left: 50px;
  justify-content:left;
  padding-left: 2px;
}
button.previewFile.v-btn i.v-icon {
  position: absolute;
  right: 0;
  z-index: 1000;
  top: 7px;
}
.layout.ly-uploadfile {
  height: 50px;
}
.ly-uploadfile .text-fileupload-indications {
  display: block;
}
.ly-uploadfile .text-file-uploaded {
  display: none;
}
.ly-uploadfile.uploaded .text-fileupload-indications {
  display: none;
}
.ly-uploadfile.uploaded .text-file-uploaded {
  display: block;
  position: relative;
  margin-top: 12px;
}
.ly-uploadfile.uploaded .text-file-uploaded img {
  position: absolute;
  left: 0px;
  width: 20px;
}
.ly-uploadfile.uploaded .text-file-uploaded span {
  position: absolute;
  left: 25px;
}
.v-dialog .v-card#info-cancellation {
  padding-bottom: 10%;
  border-radius: 8px;
}
/* Radio Group */
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio:first-child { margin-right: 9em; }
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label { display: inline; }
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label img { width: 48%; }
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label img.last-image {
  position: relative;
  bottom: 13px;
}
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label p {
  padding-left: 22px;
  margin-bottom: 0px;
}
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label p.title-label {
  font-family: 'Omnes Regular';
  font-size: 19px;
}
#responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio .v-input--selection-controls__input {
  position: relative;
}
/* BOTON BACK */
.btn-back-formalities { padding: 1em 0 2em 0; }
/* COLOR AND SIZE FOR RADIO BUTTON */
.v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio .v-input--selection-controls__input i {
  font-size: 30px;
}
.v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio .v-input--selection-controls__input i.accent--text {
  color: #0855c4 !important;
}

.listAttachments {
  margin-bottom: 16px;
  border-bottom: 1px solid #7C7C7C;
  padding-bottom: 16px;
}
.listAttachments:last-child {
  border-bottom: 0;
}
.listAttachments p { font-size: 16px; }
.listAttachments p i.v-icon {
  color: var(--second-brand-color);
  font-size: 19px;
}
.btns-upload-download {
  display: flex;
  align-items: center;
}
.btns-upload-download .upload-btn label {
  background-color: var(--fuchsia-color);
  color: #FFF;
  height: auto;
  border-radius: 8px;
  padding: 7px 16px;
}
.btns-upload-download a.v-btn:not(.v-btn--icon):not(.v-btn--flat), .btns-upload-download button.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #0855c4;
  color: #FFF;
  height: auto;
  border-radius: 8px;
  padding: 11px 20px;
}
.btns-upload a.v-btn:not(.v-btn--icon):not(.v-btn--flat), .btns-upload button.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #FFF;
  border-radius: 0;
  border: 2px dashed var(--second-brand-color);
  color: var(--second-brand-color);
  padding: 5px;
}
#form-formalities .btns-upload.btn-border-solid
, .v-dialog .dialog-with-attachments .btns-upload.btn-border-solid {
  position: relative;
}
#form-formalities .btns-upload.btn-border-solid button.v-btn
, .v-dialog .dialog-with-attachments .btns-upload.btn-border-solid button.v-btn {
  border: 1px solid #B2B4C7;
  color: #0855C4;
  background-color: #FFFFFF;
  text-transform: none;
  box-shadow: none;
  position: absolute;
  left: 0px;
  margin: 0px;
  padding-top: 10px;
  padding-bottom: 30px;
  padding-right: 50px;
  padding-left: 60px;
  align-items: normal;
  font-weight: bold;
}
#form-formalities .btns-upload.btn-border-solid img
, .v-dialog .dialog-with-attachments .btns-upload.btn-border-solid img {
  position: absolute;
  left: 40px;
  width: 20px;
}
#form-formalities #msg_relationship {
  text-align: left;
  color: var(--fuchsia-color);
  margin-top: 0px;
  margin-bottom: 1em;
}
#form-formalities #msg_relationship span {
  color: var(--fuchsia-color);
  font-weight: bold;
}
/*
#form-formalities .btns-upload.btn-border-solid button.v-btn::before {
  background: url('./../assets/formpp/number-one-checked.svg') no-repeat left;
  background-size: 25px;
}
*/
/* LINE FOR STEPPER */
.separator-line {
  height: 70px;
  width: 2px;
  margin-left: 17%;
}
.separator-line.non-activated {
  border: 1px solid #DDDDDD;
  background-color: #DDDDDD;
}
.separator-line.activated {
  border: 1px solid #0855C4;
  background-color: #0855C4;
}
.stepper-text {
  display: block;
  font-size: 11px;
  text-align: left;
  margin-left: 6px;
}
.stepper-text.active {
  color: #0855c4;
}
.flex.description-requirements p:first-child {
  font-family: 'Omnes Medium';
  margin-bottom: 0;
  font-size: 16px;
}
.flex.description-requirements + div { margin-bottom: 2em; }
.listAttachments p span {
  font-family: 'Omnes Medium';
  color: var(--second-brand-color);
  font-size: 20px;
  margin-right: 10px;
}

#form-formalities form .container .layout .flex { padding-bottom: 0 }
#form-formalities form .container .layout .flex .v-input.selectPP.v-text-field .v-input__control .v-text-field__details,
#form-formalities form .container .layout .flex .v-input.inputPP.v-text-field .v-input__control .v-text-field__details { margin-bottom: 0 }

#form-formalities .title-solicitud {
  color: #0855C4;
    margin-left: 10px;
  margin-right: 10px;
}
#form-formalities .subtitle-solicitud {
  font-size: 13px;
  color: var(--text-color);
  margin-top: 10px;
  /* margin-bottom: 20px; */
  /* margin-left: 10px; */
  /* margin-right: 10px; */
}
#form-formalities .subtitle-solicitud.text-align-left {
  text-align: left;
}

#form-formalities #ly_resumen p.label-resumen,
#form-formalities #ly_resumen_2 p.label-resumen {
  text-align: left;
  margin-right: 2px;
  color: var(--text-color);
  font-weight: bold;
}
#form-formalities #ly_resumen p.text-resumen,
#form-formalities #ly_resumen_2 p.text-resumen {
  text-align: left;
  margin-left: 2em;
  color: var(--text-color);
}
#form-formalities .tramite p.resumen-confirmation-title {
  color: #0855C4;
  font-size: 18px;
  font-weight: bold;
  margin-top: 1em;
  margin-bottom: 0.3em;
}

#form-formalities .tramite p.resumen-confirmation-subtitle {
  color: var(--text-color);
  margin-bottom: 0.2em;
}

/** PAGE THANK YOU */
.last-step h2 {
  text-align: center;
  font-weight: normal;
  font-size: 18px !important;
}
.last-step p.first-parraf {
  text-align: center;
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 3px;
}
.last-step p.second-parraf {
  text-align: center;
  font-size: 13px;
}
.last-step .layout .layout p {
  font-weight: bold;
  margin-bottom: 0;
}
.last-step p.disclaimer { text-align: center; }
p.last-parraf {
  text-align: center;
  margin-top: 25%;
  margin-bottom: 0;
}
#todayProcess .v-text-field .v-input__control .v-input__slot, #numberTransact .v-text-field .v-input__control .v-input__slot {
  min-height: auto;
  padding: 0 6px;
  border: 1px solid #FFF;
}
#todayProcess .v-text-field .v-input__control .v-input__slot .v-text-field__slot input, #numberTransact .v-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
/*  */
.btn_close__dialog { cursor: pointer; }
.btn_close__dialog {
  display: flex;
  align-items: center;
  float: right;
}
.btn_close__dialog span {
  color: var(--second-brand-color);
  font-size: 15px;
}
.btn_close__dialog i.v-icon {
  color: var(--second-brand-color);
  font-weight: bold;
  font-size: 27px;
}
/**/
.complete--address--dialog .v-card .v-card__text .container.grid-list-md, .complete--email--dialog .v-card .v-card__text .container.grid-list-md { padding: 0 24px; }
#formalities .v-item-group .items-selectables { cursor: pointer; }
/* BTN Cerrar form solicitudes */
.btn-back-formalities a {
  display: block;
  font-size: 17px;
  line-height: 1;
  margin-top: 1em;
  text-decoration: none;
  color: rgba(0,0,0,.87);
}
.btn-back-formalities a span {
  position: relative;
  bottom: 4px;
  left: 8px;
}
/** ENDOSOS */
#info-endorsements #info-change-payment{
  padding: 30px 0;
}
#btn-endorsements {
  color: #FFF;
  height: 40px;
  padding: 0 40px;
  border-radius: 5px;
  margin-top: 1em;
  margin-bottom: 1em;
  box-shadow: none;
}
#btn-endorsements .v-btn__content {
  text-transform: initial;
}

.landing-item-formalities h3 {
  color: #535D66;
  font-size: 1.5rem;
  margin: 5px 0 0 0;
}

.landing-item-formalities p {
  font-size: 16px;
  line-height: 19.9px;
}

.landing-item-formalities {
  width: 100%;
  }

.landing-item-formalities .btn-purple {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  font-size: 13px;
  height: 30px!important;
  margin: 68px 0 0 19px;
  width: 130px;
  border-radius: 2.51034px !important;
}

/* Small to large handset ----------- */
@media only screen and (max-width : 600px) {
  /* STRUCTURE */
  #formalities { display: initial; }
  #form-formalities {
    display: block;
    width: 100%;
  }
  .accept-privacy.flex .v-input.v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio {
    margin-right: 0;
  }
  .landing-item-formalities {
    width: 100%;
  }
  h2.title-formalities {
    padding-left: 1em;
    padding-top: 4px;
    padding-bottom: 4px;
    border-radius: 22px;
  }
  h2.title-formalities img {
    width: 11%;
    left: 2em;
    top: 6px;
  }
  h2.title-formalities.personal-data img {
    left: 3em;
    width: 9%;
  }
  .last-step p.first-parraf { font-size: 18px; }
  .last-step p.second-parraf { font-size: 14px; }
  p.last-parraf { margin-top: 8%; }
  .formalities#container--body-insurance {
    height: auto;
    overflow-y: initial;
  }
  #numberTransact .v-input.v-text-field.v-text-field--outline { width: 83%; }
  #todayProcess .v-input.v-text-field.v-text-field--outline { width: 87%; }
  /*.selectPP.v-text-field--outline.v-select .v-input__control .v-text-field__details, .inputPP.v-text-field--outline.v-text-field .v-input__control .v-text-field__details { display: none; }*/
  .complete--address--dialog .v-card .v-card__text .container.grid-list-md, .complete--email--dialog .v-card .v-card__text .container.grid-list-md { padding: 0; }
  .type-transact .label-input-formalitites-color { margin-bottom: 0; }
  #responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label p.title-label {
    font-family: 'Omnes Medium';
    font-size: 17px;
  }
  .listAttachments {
    background-color: #FFF;
    margin-bottom: 20px;
    padding: 15px;
    border: 0;
  }
  #formalities,
  #formalities .flex .v-window.elevation-1 .v-window__container,
  #formalities .flex .v-window.elevation-1 .v-window__container .v-window-item {
    height: auto;
  }
  button.theme--light.v-btn.btn-form-formalities { width: 95%; }
  #formalities .v-item-group div button { width: 50px; }
  #formalities .v-item-group {
    width: 100%;
    padding: 18px 0;
    text-align: center;
  }
  .separator-line {
    height: 2px;
    width: 40px;
    display: inline-block;
    margin-left: 4px;
    margin-right: 4px;
    position: relative;
    bottom: 0px;
    margin-left: -8px;
    margin-right: -8px;
  }
  .stepper-item-contain {
    text-align: center;
    display: inline-block;
  }
  .stepper-item {
    display: inline-block;
  }
  .bells {
    width: 91%;
    height: 87%;
    position: absolute;
    z-index: 999;
  }
  #responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio label img.last-image {
    position: initial;
  }
  #responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    left: auto;
    top: auto;
  }
  #responseMediumGroup .v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio:first-child {
    margin-right: 0;
    margin-bottom: 2em;
  }
  /** SECTION FOR SELECT BANK AND CURRENCY */
  .flex .v-input.v-input--radio-group {
    margin-top: 0;
    padding-top: 0;
  }
  .flex .v-input.v-input--radio-group .v-input__control .v-input__slot .v-input--radio-group__input .v-radio {
    margin-right: 100px;
    margin-bottom: 5px;
  }

  #cabecera {
    background-color: #eff1f47a;
    display: none;
  }

}
/* Large handset ----------- */
@media only screen  and (min-width : 1024px) {
  /* .last-step {
    padding-top: 2%;
  } */
  #formalities .v-item-group {
    height: 80%;
    padding-top: 5px;
  }
  h2.title-formalities.no-first-section { margin-top: 38px; }
  h2.title-formalities img {
    width: 8%;
    left: 4em;
  }
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-input .v-input__control .v-input__slot .v-input--radio-group__input .v-radio {
    margin-right: 1.7em;
  }
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text.tramite .layout .flex .v-text-field--outline.v-textarea .v-input__control .v-input__slot,
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text.tramite .layout .flex .v-text-field--outline.v-text-field .v-input__control .v-input__slot {
    width: 70%;
  }
  #form-formalities, #formalities .flex .v-window.elevation-1 { height: 100%; }
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout.wrap { margin-bottom: 0 !important; }
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-text-field--outline.v-input--is-disabled .v-input__control .v-input__slot,
  #form-formalities form .container .layout .flex .v-input.inputPP.v-text-field,
  #form-formalities form .container .layout .flex .v-input.selectPP.v-text-field { width: 83% }
  #formalities .flex .v-window.elevation-1 .v-window__container .v-window-item { background-color: #FFF; }
  #formalities, #formalities .flex .v-window.elevation-1 .v-window__container,
  #formalities .flex .v-window.elevation-1 .v-window__container .v-window-item,
  #form-formalities .v-window .v-window__container .v-window-item:first-child .v-card .v-card__text .layout.wrap:not(#ly_emailaddress) {
    height: 100%;
    min-height: calc(100% - 54.55px);
  }
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-btn.next .v-btn__content i,
  .last-step .v-btn.next .v-btn__content i {
    position: relative;
    left: 0.5em;
  }
  #form-formalities .v-window .v-window__container .v-window-item .v-card .v-card__text .layout .flex .v-btn.back .v-btn__content i,
  .last-step .v-btn.back .v-btn__content i {
    position: relative;
    right: 0.5em;
  }
  .separator-line {
    height: 2px;
    width: 40px;
    display: inline-block;
    margin-left: 4px;
    margin-right: 4px;
    position: relative;
    bottom: 0px;
    margin-left: -8px;
    margin-right: -8px;
  }
  .stepper-item-contain {
    text-align: center;
    display: inline-block;
  }
  .stepper-item { display: inline-block; }
  .bells {
    width: 91%;
    height: 87%;
    position: absolute;
    z-index: 999;
  }
}
/* ----------- Galaxy Phones ----------- */
/* Portrait and Landscape */
@media screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 192dpi) and (max-width: 640px) {
  #todayProcess .v-input.v-text-field.v-text-field--outline { width: 94%; }
}
/* iPhone 6, 7, & 8 in portrait & landscape ----------- */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) {
  h2.title-formalities img {
    left: 3em;
    top: 5px;
  }
}
/* iPhone X in portrait & landscape ----------- */
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-device-pixel-ratio: 3) {
  h2.title-formalities img {
    left: 4em;
    top: 4px;
  }
}
/* iPhone XR in portrait & landscape ----------- */
@media only screen and (device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
  h2.title-formalities img {
    left: 4em;
    top: 4px;
  }
}

.i-input--radio {
  display: inline-block;
  vertical-align: top;
}

.i-input, .i-input__error {
  position: relative;
  height: 50px;
}

.i-input {
  width: 100%;
  margin: 0 auto 16px;
}

.i-input--radio input[type=radio]+div+label:not(.error):after,
.i-input--radio input[type=radio]+div+label:not(.error):before {
  border-radius: 50%
}

.i-input--radio input[type=radio]+div+label:not(.error):after {
  top: 5px;
  right: 5px;
  width: 14px;
  height: 14px;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  background: #0855c4
}

.i-input--radio input[type=checkbox]+div+label:not(.error):after {
  background-color: transparent;
  left: 4px;
  top: 5px;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  background-repeat: no-repeat;
  width: 13px;
  height: 10px
}

.i-input--radio input[type=checkbox].error~label:before {
  border-color: #dc3545
}

.i-input--radio input[type=checkbox],
.i-input--radio input[type=radio] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  color: transparent
}

.i-input--radio input[type=checkbox]:checked+div+label:before,
.i-input--radio input[type=radio]:checked+div+label:before {
  border-color: #0855c4;
  -webkit-animation: ripple .3s linear forwards;
  animation: ripple .3s linear forwards;
  background-color: #fff
}

.i-input--radio input[type=checkbox]:checked+div+label:after,
.i-input--radio input[type=radio]:checked+div+label:after {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1)
}

.i-input--radio label:not(.error) {
  color: #7c8087;
  display: inline-block;
  min-height: 20px;
  position: relative;
  padding-left: 28px;
  padding-top: 1px;
  margin-bottom: 0;
  cursor: pointer;
  vertical-align: bottom;
  font-size: 15px;
  font-size: .9375rem;
  text-align: left;
  line-height: 1.18;
  font-weight: 400
}

@media only screen and (min-width:768px) {
  .i-input--radio label:not(.error) {
    font-size: 16px;
    font-size: 1rem
  }
}

.i-input--radio label:not(.error):after,
.i-input--radio label:not(.error):before {
  position: absolute;
  content: "";
  border-radius: 5px;
  -webkit-transition: all .3s ease;
  -o-transition: all .3s ease;
  transition: all .3s ease;
  -webkit-transition-property: border-color, -webkit-transform;
  transition-property: border-color, -webkit-transform;
  -o-transition-property: transform, border-color;
  transition-property: transform, border-color;
  transition-property: transform, border-color, -webkit-transform
}

.i-input--radio label:not(.error):before {
  right: 2px;
  top: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc
}

.i-input--radio label:not(.error) a,
.i-input--radio label:not(.error) span {
  position: relative;
  top: 0;
  left: 0;
  color: #0855c4;
  font-weight: 400;
  padding: 0;
  text-decoration: underline
}

@media only screen and (min-width:1024px) {
  .i-input--radio label:not(.error) a,
  .i-input--radio label:not(.error) span {
    text-decoration: none
  }
}

@media only screen and (min-width:1024px) {
  .i-input--radio label:not(.error) a:before,
  .i-input--radio label:not(.error) span:before {
    left: 0;
    right: 0;
    background-color: rgba(8, 85, 196, .6)
  }
}

@media only screen and (min-width:1024px) {
  .i-input--radio label:not(.error) a:after,
  .i-input--radio label:not(.error) a:before,
  .i-input--radio label:not(.error) span:after,
  .i-input--radio label:not(.error) span:before {
    content: "";
    position: absolute;
    bottom: -1px;
    height: 1px;
    -webkit-transition-property: left, right;
    -o-transition-property: left, right;
    transition-property: left, right;
    -webkit-transition-duration: .3s;
    -o-transition-duration: .3s;
    transition-duration: .3s;
    -webkit-transition-timing-function: ease-in-out;
    -o-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out
  }
  .i-input--radio label:not(.error) a:after,
  .i-input--radio label:not(.error) span:after {
    left: 50%;
    right: 50%;
    background-color: #0855c4
  }
}

.i-input--radio label:not(.error) a:hover,
.i-input--radio label:not(.error) span:hover {
  color: #0855c4
}

.i-input--radio label:not(.error) a:hover:before,
.i-input--radio label:not(.error) span:hover:before {
  left: 50%;
  right: 50%
}

.i-input--radio label:not(.error) a:hover:after,
.i-input--radio label:not(.error) span:hover:after {
  left: 0;
  right: 0
}

.i-radio--extend.js--focus {
  border: 1px solid #0855c4
}

.i-radio--extend.js--focus label>p:first-of-type {
  border-right: 1px solid #0855c4
}

.i-radio--extend label p:first-of-type {
  margin: 0;
  width: 134px;
  text-align: left;
  padding: 0 36px 0 0;
  border-right: 1px solid #ccc
}

.i-radio--extend {
  height: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 11px 13px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid #C9C9C9;
  border-radius: 3px;
}

.i-radio--extend label p:nth-of-type(2) {
  margin: 0 0 0 18px
}

.i-radio--extend label small {
  display: block;
  font-size: 10px;
  font-size: .625rem
}

.i-radio--extend label em {
  display: block;
  font-style: normal
}

.i-radio--extend label:not(.error) {
  padding: 0;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.i-radio--extend label:not(.error):before {
  top: 5px
}

.i-radio--extend input[type=radio]+div+label:not(.error):after {
  top: 8px
}

.i-radio--extend.scale{
  transform: scale(2);
}

.i-input label {
  font-size: 14px;
  font-size: .875rem;
  font-weight: 500;
  color: #ccc;
  padding: 5px 12px 0;
  vertical-align: top;
  display: inline-block
}

@media only screen and (min-width:425px) {
  .i-input label {
    font-size: 16px;
    font-size: 1rem
  }
}

.i-input input {
  padding-top: 15px!important;
  background-repeat: no-repeat;
  background-position: 97%
}
.i-advice {
  color: var(--fuchsia-color);
  font-size: 13px;
  font-style: normal;
  position: relative;
  display: inline-flex;
  align-items: center;
  padding-top: 10px;
  padding-left: 22px;
}
.i-advice::before {
  left: 0;
  padding-bottom: 0px;
  padding-bottom: 0px;
  position: absolute;
  content: url(../assets/iconsv5/icon-info-endosos.png);
}
.i-advice a {
  color: var(--fuchsia-color);
  text-decoration: underline;
}
.i-advice p {
  color: var(--fuchsia-color);
  margin: 0;
}
.i-advice p span {
  color: var(--fuchsia-color);
  text-decoration: underline;
}

.i-radio__content {
  width: 236px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
}
@media only screen and (min-width: 768px) {
  .i-radio__content {
    width: 374px;
  }
}
.i-radio--date {
  width: 115px;
  height: 50px;
  border: 1px solid #CCCCCC;
  border-radius: 2px;
  margin: 0;
  margin-bottom: 8px;
}
@media only screen and (min-width: 1024px) {
  .i-radio--date {
    width: 120px;
  }
}
.i-radio--date label p {
  text-align: left;
  padding-left: 38px;
  font-size: 14px;
  margin: 0;
}
.i-radio--date label:not(.error) {
  padding: 0;
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 1024px) {
  .i-radio--date label:not(.error) {
    height: 60px;
  }
}
.i-radio--date label:not(.error):before {
  top: 35%;
  left: 9%;
  width: 16px;
  height: 16px;
}
@media only screen and (min-width: 1024px) {
  .i-radio--date label:not(.error):before {
    top: 20px;
  }
}

.layoutresumen-data {
  margin-top: 10px;
  margin-left: 15%;
}

@media only screen and (min-width: 1024px) {
  .layoutresumen-data {
    margin-top: 10px;
    margin-left: 15%;
  }
}

@media only screen and (min-width: 480px) {
  .layoutresumen-data {
    margin-top: 10px;
    margin-left: 15%;
  }
}

.i-radio--date input[type=radio] + div + label:not(.error):after {
  top: 40%;
  left: 12%;
  width: 12px;
  height: 12px;
  right: initial;
}
@media only screen and (min-width: 1024px) {
  .i-radio--date input[type=radio] + div + label:not(.error):after {
    top: 24px;
  }
}

#attachments-release {
  left: 90% !important;
}

@media only screen and (max-width: 1024px) {
  #attachments-release {
    left: 92% !important;
  }
}
@media only screen and (max-width: 480px) {
  #attachments-release {
    left: 89% !important;
  }
}

#ly_changePaymentFrecuency p,
#ly_deleteCoverages p {
  margin-bottom: 10px;
  text-align: left;
}

#ly_changePaymentFrecuency .i-radio--extend label small {
  font-size: 11px;
}

#icon--close {
  color: #0855ca;
  background-color: #FFF;
  font-size: initial;
  border-radius: 100%;
  font-weight: bold;
  margin-left: 10px;
}

#ly_deleteCoverages {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

#ly_deleteCoverages .list-coverages {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

#ly_deleteCoverages .group-checkbox {
  border: 1px solid #ccc;
  border-radius: 4px;
  justify-content: space-between;
  transition: border-color 0.3s ease-in-out;
}

#ly_deleteCoverages .group-checkbox.selected {
  border-color: #0855C4 !important;
  border-width: 2px;
}

#ly_deleteCoverages .group-checkbox .v-input {
  margin: 0;
  padding: 0;
  height: 100%;
}

#ly_deleteCoverages .group-checkbox .v-input__control {
  width: 100%;
}

.group-checkbox .v-input__control .v-input__slot {
  margin-bottom: 0;
}

.group-checkbox .v-input__control .v-messages {
  display: none;
}

#ly_deleteCoverages .group-checkbox .v-input__slot {
  margin: 0;
  display: flex;
  flex-direction: row-reverse;
}

#ly_deleteCoverages .group-checkbox .v-input__slot .v-input--selection-controls__input {
  position: absolute;
  margin-bottom: -2.5rem;
}

#ly_deleteCoverages .group-checkbox .v-input__slot .v-label {
  display: inline-block;
  width: 100%;
  padding: 1rem;
  min-height: 70px;
}

#ly_deleteCoverages .group-checkbox .detail {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

#ly_deleteCoverages .group-checkbox .detail p {
  margin: 0;
  color: #454A6C;
}

#ly_deleteCoverages .group-checkbox .detail .monto {
  text-wrap: nowrap;
}

#ly_deleteCoverages .group-checkbox .v-messages {
  display: none;
}

#ly_deleteCoverages .title-constancy {
  padding: 0;
  border-bottom: none;
}

#ly_deleteCoverages .group-recalculate {
  border-radius: 7px;
  border-top-right-radius: 0px !important;
}

#ly_deleteCoverages .group-recalculate p {
  font-size: 16px;
  line-height: 17px;
  margin: 0;
}

#ly_deleteCoverages .group-recalculate .section-amount {
  background-color: #0855c4;
  border-bottom-right-radius: 7px;
  border-top-left-radius: 7px;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

#ly_deleteCoverages .group-recalculate .section-amount p {
  color: #FFF;
}

#ly_deleteCoverages .group-recalculate .section-amount .amount {
  font-weight: 600;
  margin-left: 1rem;
  text-wrap: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#ly_deleteCoverages .group-recalculate .section-date {
  padding-top: 8px;
}

#ly_deleteCoverages .group-recalculate .section-date p,
#ly_deleteCoverages .group-recalculate .section-date span {
  color: var(--text-color);
}

.list-resumen {
  color: #454A6C;
  margin-bottom: 1.5rem;
}

.list-resumen .no-decimal {
  list-style: none;
}

.input-email input {
  padding-right: 2.5rem !important;
  color: var(--text-color) !important;
}

.tooltip-cobertura {
  position: absolute;
  right: -25px;
  top: 15px;
}

.dialog-close {
  font-size: 1.2rem;
  font-weight: 600;
  color: #0855C4;
  position: absolute;
  right: 1rem;
  top: .5rem;
  padding: .5rem 1rem;
  cursor: pointer;
}

@media only screen and (min-width: 1024px) {
  #ly_deleteCoverages .group-checkbox .detail {
    gap: 4rem;
  }

  .tooltip-cobertura {
    right: -18px;
  }
}

/* Estilos para el resumen de solicitud Endosos Simples*/

.text-primary {
  color: var(--text-color);
}

#ly_resumen_2 h2 {
  padding: 1.2rem 0;
}

#ly_resumen_2 .detalle-actual,
#ly_resumen_2 .detalle-cambio {
  padding: 1.5rem 2rem;
}

#ly_resumen_2 .detalle-actual {
  border-top: 1px solid #C9C9C9;
  padding-bottom: 1rem !important;
}

#ly_resumen_2 .detalle-cambio {
  border-top: 2px dashed #C9C9C9;
  background-color: #F5F5F5;
}

#ly_resumen_2 .text-resumen {
  text-align: right !important;
  margin-left: 0 !important;
}

#ly_resumen_2 .btns-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2.5rem;
}

#ly_resumen_2 .btns-actions #btnSendSolicitud {
  width: 60%;
}

#ly_resumen_2 #btnBack {
  margin: 0.5em 0 !important;
  padding: 1em;
  width: 8rem;
}

#ly_constancy_registered .cr-main {
   border: 1px solid #D8D8D8;
    padding-bottom: 2em;
    padding: 20px 5px;
    border-radius: 8px;
    max-width: 450px;
    margin: 0 auto;

}

#ly_constancy_registered_2 .cr-main {
  border: 1px solid #C9C9C9;
}

#ly_constancy_registered_2 .title-solicitud {
  padding: 0 2rem;
}

#ly_constancy_registered_2 .subtitle-solicitud {
  margin: .5rem auto 1rem;
  width: 100%;
  max-width: 320px;
  line-height: 1.3;
}

#ly_constancy_registered_2 .confirmation-date {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 2px dashed #C9C9C9;
  border-bottom: 2px dashed #C9C9C9;
  background-color: #F5F5F5;
  margin-top: 1.8rem;
  margin-bottom: 3rem;
  padding: 1.6rem 2rem;
}

#ly_constancy_registered_2 .confirmation-date p {
  font-size: 16px;
  color: #454A6C;
  margin: 0;
}

#ly_constancy_registered_2 .btns-actions {
  margin-bottom: 3rem;
}

.text-email_address.endosos-simples {
  line-height: 1.2;
  margin-bottom: .5rem;
  color: var(--text-color);
  text-align: justify;
}

#btnSolicitud.btn-full-width {
  width: 100%;
}

#btnSolicitud.btn-calculate-endoso,
#btnSolicitud.btn-calculate-endoso:hover {
  background-color: #00ADED;
  font-size: 20px;
  height: 50px;
}

#btnSolicitud.btn-calculate-endoso .v-btn__content {
  padding: 0;
}

.modal-procede {
  padding: 2rem 0;
}

.modal-procede p,
.modal-procede ol {
  font-size: 16px;
  line-height: 1.2;
  color: var(--text-color);
  text-align: justify;
}

.modal-procede ol {
  padding-left: 15px;
  margin-top: -5px;
}

.modal-procede li {
  padding-top: 5px;
}

.modal-procede li span {
  color: var(--text-color);
}

@media only screen and (min-width: 1024px) {
  #ly_resumen_2 .detalle-actual,
  #ly_resumen_2 .detalle-cambio {
    padding: 1.8rem 4.5rem;
  }

  #ly_constancy_registered_2 .title-solicitud {
    padding: 0 5rem;
  }

  #ly_constancy_registered_2 .confirmation-date {
    padding: 1.6rem 6rem;
  }
}

.disclaimer-content {
  border-radius: 4px;
  background-color: #EFF1F4;
  border: 1px solid #CCCCCC;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 8px;
}
.disclaimer-content .img-disclaimer {
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
}
.disclaimer-content .text-disclaimer {
  font-size: 1rem;
  line-height: 20px;
  color: rgba(0, 0, 0, .55);
  text-align: justify;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Formalities.vue